/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 625:
/***/ (function() {

/*!
 * zeynepjs v2.1.4
 * A light-weight multi-level jQuery side menu plugin.
 * It's fully customizable and is compatible with modern browsers such as Google Chrome, Mozilla Firefox, Safari, Edge and Internet Explorer
 * MIT License
 * by Huseyin ELMAS
 */
(function ($, pluginName) {
  var defaults = {
    htmlClass: true,
  };

  function Plugin(element, options) {
    this.element = element;
    this.eventController = eventController;
    this.options = $.extend({}, defaults, options);
    this.options.initialized = false;

    this.init();
  }

  Plugin.prototype.init = function () {
    var zeynep = this.element;
    var options = this.options;
    var eventController = this.eventController.bind(this);

    // exit if already initialized
    if (options.initialized === true) return;

    eventController('loading');

    // handle subMenu links/triggers click events
    zeynep.find('[data-submenu]').on('click', function (event) {
      event.preventDefault();

      var self = $(this);
      var subMenuId = self.attr('data-submenu');
      var subMenuEl = $('#' + subMenuId);

      // if subMenu not found, do nothing
      if (!subMenuEl.length) return;

      var eventDetails = {
        subMenu: true,
        menuId: subMenuId,
      };

      eventController('opening', eventDetails);

      // open the subMenu
      zeynep.find('.submenu.current').removeClass('current');
      subMenuEl.addClass('opened current');
      !zeynep.hasClass('submenu-opened') && zeynep.addClass('submenu-opened');

      // scroll to top before submenu transition
      zeynep.scrollTop(0);

      eventController('opened', eventDetails);
    });

    // handle subMenu closers click events
    zeynep.find('[data-submenu-close]').on('click', function (event) {
      event.preventDefault();

      var self = $(this);
      var subMenuId = self.attr('data-submenu-close');
      var subMenuEl = $('#' + subMenuId);

      // if subMenu not found, do nothing
      if (!subMenuEl.length) return;

      var eventDetails = {
        subMenu: true,
        menuId: subMenuId,
      };

      eventController('closing', eventDetails);

      // close subMenu
      subMenuEl.removeClass('opened current');
      zeynep.find('.submenu.opened:last').addClass('current');
      !zeynep.find('.submenu.opened').length && zeynep.removeClass('submenu-opened');

      // scroll to top between submenu transitions
      subMenuEl.scrollTop(0);

      eventController('closed', eventDetails);
    });

    eventController('load');

    // zeynepjs successfully initialized
    this.options.htmlClass && !$('html').hasClass('zeynep-initialized') && $('html').addClass('zeynep-initialized');

    options.initialized = true;
  };

  Plugin.prototype.open = function () {
    this.eventController('opening', { subMenu: false });

    // zeynepjs menu is opened
    this.element.addClass('opened');
    this.options.htmlClass && $('html').addClass('zeynep-opened');

    this.eventController('opened', { subMenu: false });
  };

  Plugin.prototype.close = function (disableEvent) {
    !disableEvent && this.eventController('closing', { subMenu: false });

    // zeynepjs menu is opened
    this.element.removeClass('opened');
    this.options.htmlClass && $('html').removeClass('zeynep-opened');

    !disableEvent && this.eventController('closed', { subMenu: false });
  };

  Plugin.prototype.destroy = function () {
    this.eventController('destroying');

    // close the menu without firing any event
    this.close(true);

    // close submenus
    this.element.find('.submenu.opened').removeClass('opened');

    // clear/remove the instance on the element
    this.element.removeData(pluginName);

    this.eventController('destroyed');

    // reset options
    this.options = defaults;

    this.options.htmlClass && $('html').removeClass('zeynep-initialized');

    delete this.element;
    delete this.options;
    delete this.eventController;
  };

  Plugin.prototype.on = function (name, handler) {
    eventBinder.call(this, name, handler);
  };

  var eventController = function (type, details) {
    if (!this.options[type]) return;
    if (typeof this.options[type] !== 'function') throw Error('event handler must be a function: ' + type);

    // call the event
    this.options[type].call(this, this.element, this.options, details);
  };

  var getInstance = function (element, options) {
    var instance = null;

    if (!element.data(pluginName)) {
      // zeynepjs is not initialized for the element
      // crceate a new instance
      instance = new Plugin(element, options || {});

      // put the instance on element
      element.data(pluginName, instance);
    } else {
      // return the already initialized instance
      instance = element.data(pluginName);
    }

    return instance;
  };

  var eventBinder = function (name, handler) {
    if (typeof name !== 'string') throw Error('event name is expected to be a string but got: ' + typeof name);
    if (typeof handler !== 'function') throw Error('event handler is not a function for: ' + name);

    // update options
    this.options[name] = handler;
  };

  // a really lightweight plugin wrapper around the constructor
  // preventing against multiple instantiations
  $.fn[pluginName] = function (options) {
    // get a zeynepjs instance
    var instance = getInstance($(this[0]), options);

    return instance;
  };
})(window.jQuery, 'zeynep');


/***/ }),

/***/ 529:
/***/ (function(module) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 400:
/***/ (function(module) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 757:
/***/ (function(module) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 117:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 269:
/***/ (function(module) {

"use strict";

module.exports = Object.create ? Object.create(null) : {};


/***/ }),

/***/ 741:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 717:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 103:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 265:
/***/ (function(module) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 823:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/concatenation wrap */
/******/ 	// wrap a concatenated module body as a lazy, memoized accessor; mod is
/******/ 	// set before the body runs so re-entrant calls (require cycles) observe
/******/ 	// the partial exports like Node.js
/******/ 	__webpack_require__.cw = function(body) {
/******/ 		var mod;
/******/ 		return function() {
/******/ 			if (body) {
/******/ 				var fn = body;
/******/ 				body = 0;
/******/ 				mod = { exports: {} };
/******/ 				fn.call(mod.exports, mod, mod.exports);
/******/ 			}
/******/ 			return mod.exports;
/******/ 		};
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	__webpack_require__.f = {};
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function(chunkId) {
/******/ 		var promises = [];
/******/ 		__webpack_require__.f.j(chunkId, promises);
/******/ 		return Promise.all(promises);
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	// This function allow to reference async chunks
/******/ 	__webpack_require__.u = function(chunkId) { return chunkId + ".js"; };
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	__webpack_require__.g = (function() {
/******/ 		if (typeof globalThis === 'object') return globalThis;
/******/ 		try {
/******/ 			return this || new Function('return this')();
/******/ 		} catch (e) {
/******/ 			if (typeof window === 'object') return window;
/******/ 		}
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); };
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "aponeo-webshop:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/set anonymous default export name */
/******/ 	// set .name for anonymous default exports per ES spec
/******/ 	// skipped when the property is non-configurable (pre-ES2015 engines),
/******/ 	// where Object.defineProperty would throw
/******/ 	__webpack_require__.dn = function(x) {
/******/ 		var descriptor = Object.getOwnPropertyDescriptor(x, "name");
/******/ 		if (!descriptor || (!descriptor.writable && descriptor.configurable)) Object.defineProperty(x, "name", { value: "default", configurable: true });
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript && document.currentScript.tagName.toUpperCase() === 'SCRIPT')
/******/ 				scriptUrl = document.currentScript.src;
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) {
/******/ 					var i = scripts.length - 1;
/******/ 					while (i > -1 && (!scriptUrl || !/^https?:/.test(scriptUrl))) scriptUrl = scripts[i--].src;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/^blob:|[?#].*$/g, "").replace(/\/[^/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			792: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										error.event = event;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(__webpack_require__.p + __webpack_require__.u(chunkId), loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkaponeo_webshop"] = self["webpackChunkaponeo_webshop"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";

// MODULE: ./node_modules/core-js/actual/promise/index.js
var actual_promise_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var parent = (stable_promise_namespaceFn());
(es_object_create_namespaceFn());
(es_reflect_own_keys_namespaceFn());
(esnext_promise_all_keyed_namespaceFn());
(esnext_promise_all_settled_keyed_namespaceFn());
// TODO: Remove from `core-js@4`
(esnext_promise_try_namespaceFn());
(esnext_promise_with_resolvers_namespaceFn());

module.exports = parent;

});

// MODULE: ./node_modules/core-js/es/promise/index.js
var promise_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

(es_aggregate_error_namespaceFn());
(es_array_iterator_namespaceFn());
(es_object_to_string_namespaceFn());
(es_promise_namespaceFn());
(es_promise_all_settled_namespaceFn());
(es_promise_any_namespaceFn());
(es_promise_try_namespaceFn());
(es_promise_with_resolvers_namespaceFn());
(es_promise_finally_namespaceFn());
(es_string_iterator_namespaceFn());
var path = (path_namespaceFn());

module.exports = path.Promise;

});

// MODULE: ./node_modules/core-js/internals/a-callable.js
var a_callable_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isCallable = (is_callable_namespaceFn());
var tryToString = (try_to_string_namespaceFn());

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};

});

// MODULE: ./node_modules/core-js/internals/a-constructor.js
var a_constructor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isConstructor = (is_constructor_namespaceFn());
var tryToString = (try_to_string_namespaceFn());

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};

});

// MODULE: ./node_modules/core-js/internals/a-possible-prototype.js
var a_possible_prototype_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isPossiblePrototype = (is_possible_prototype_namespaceFn());

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

});

// MODULE: ./node_modules/core-js/internals/add-to-unscopables.js
var add_to_unscopables_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var wellKnownSymbol = (well_known_symbol_namespaceFn());
var create = (object_create_namespaceFn());
var defineProperty = (object_define_property_namespaceFn().f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

});

// MODULE: ./node_modules/core-js/internals/an-instance.js
var an_instance_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isPrototypeOf = (object_is_prototype_of_namespaceFn());

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};

});

// MODULE: ./node_modules/core-js/internals/an-object.js
var an_object_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isObject = (is_object_namespaceFn());

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};

});

// MODULE: ./node_modules/core-js/internals/array-includes.js
var array_includes_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var toIndexedObject = (to_indexed_object_namespaceFn());
var toAbsoluteIndex = (to_absolute_index_namespaceFn());
var lengthOfArrayLike = (length_of_array_like_namespaceFn());

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  q: createMethod(false)
};

});

// MODULE: ./node_modules/core-js/internals/array-slice.js
var array_slice_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());

module.exports = uncurryThis([].slice);

});

// MODULE: ./node_modules/core-js/internals/check-correctness-of-iteration.js
var check_correctness_of_iteration_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var wellKnownSymbol = (well_known_symbol_namespaceFn());

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

});

// MODULE: ./node_modules/core-js/internals/classof-raw.js
var classof_raw_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};

});

// MODULE: ./node_modules/core-js/internals/classof.js
var classof_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var TO_STRING_TAG_SUPPORT = (to_string_tag_support_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var classofRaw = (classof_raw_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

});

// MODULE: ./node_modules/core-js/internals/copy-constructor-properties.js
var copy_constructor_properties_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var hasOwn = (has_own_property_namespaceFn());
var ownKeys = (own_keys_namespaceFn());
var getOwnPropertyDescriptorModule = (object_get_own_property_descriptor_namespaceFn());
var definePropertyModule = (object_define_property_namespaceFn());

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

});

// MODULE: ./node_modules/core-js/internals/correct-prototype-getter.js
var correct_prototype_getter_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var fails = (fails_namespaceFn());

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/create-iter-result-object.js
var create_iter_result_object_namespaceFn = function() {
	return __webpack_require__(529);
};

// MODULE: ./node_modules/core-js/internals/create-non-enumerable-property.js
var create_non_enumerable_property_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var DESCRIPTORS = (descriptors_namespaceFn());
var definePropertyModule = (object_define_property_namespaceFn());
var createPropertyDescriptor = (create_property_descriptor_namespaceFn());

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

});

// MODULE: ./node_modules/core-js/internals/create-property-descriptor.js
var create_property_descriptor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

});

// MODULE: ./node_modules/core-js/internals/create-property.js
var create_property_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var DESCRIPTORS = (descriptors_namespaceFn());
var definePropertyModule = (object_define_property_namespaceFn());
var createPropertyDescriptor = (create_property_descriptor_namespaceFn());

module.exports = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

});

// MODULE: ./node_modules/core-js/internals/define-built-in-accessor.js
var define_built_in_accessor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var makeBuiltIn = (make_built_in_namespaceFn());
var defineProperty = (object_define_property_namespaceFn());

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

});

// MODULE: ./node_modules/core-js/internals/define-built-in.js
var define_built_in_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isCallable = (is_callable_namespaceFn());
var definePropertyModule = (object_define_property_namespaceFn());
var makeBuiltIn = (make_built_in_namespaceFn());
var defineGlobalProperty = (define_global_property_namespaceFn());

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

});

// MODULE: ./node_modules/core-js/internals/define-global-property.js
var define_global_property_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis[key] = value;
  } return value;
};

});

// MODULE: ./node_modules/core-js/internals/descriptors.js
var descriptors_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var fails = (fails_namespaceFn());

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

});

// MODULE: ./node_modules/core-js/internals/document-create-element.js
var document_create_element_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var isObject = (is_object_namespaceFn());

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/dom-iterables.js
var dom_iterables_namespaceFn = function() {
	return __webpack_require__(400);
};

// MODULE: ./node_modules/core-js/internals/dom-token-list-prototype.js
var dom_token_list_prototype_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = (document_create_element_namespaceFn());

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

});

// MODULE: ./node_modules/core-js/internals/enum-bug-keys.js
var enum_bug_keys_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

});

// MODULE: ./node_modules/core-js/internals/environment-is-ios-pebble.js
var environment_is_ios_pebble_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var userAgent = (environment_user_agent_namespaceFn());

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';

});

// MODULE: ./node_modules/core-js/internals/environment-is-ios.js
var environment_is_ios_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var userAgent = (environment_user_agent_namespaceFn());

module.exports = /ipad|iphone|ipod/i.test(userAgent) && /applewebkit/i.test(userAgent);

});

// MODULE: ./node_modules/core-js/internals/environment-is-node.js
var environment_is_node_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var ENVIRONMENT = (environment_namespaceFn());

module.exports = ENVIRONMENT === 'NODE';

});

// MODULE: ./node_modules/core-js/internals/environment-is-webos-webkit.js
var environment_is_webos_webkit_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var userAgent = (environment_user_agent_namespaceFn());

module.exports = /web0s(?!.*chrome)/i.test(userAgent);

});

// MODULE: ./node_modules/core-js/internals/environment-user-agent.js
var environment_user_agent_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';

});

// MODULE: ./node_modules/core-js/internals/environment-v8-version.js
var environment_v8_version_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var userAgent = (environment_user_agent_namespaceFn());

var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;

});

// MODULE: ./node_modules/core-js/internals/environment.js
var environment_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

/* global Bun, Deno -- detection */
var globalThis = (global_this_namespaceFn());
var userAgent = (environment_user_agent_namespaceFn());
var classof = (classof_raw_namespaceFn());

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

module.exports = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof(globalThis.process) === 'process') return 'NODE';
  if (globalThis.window && globalThis.document) return 'BROWSER';
  return 'REST';
})();

});

// MODULE: ./node_modules/core-js/internals/error-stack-clear.js
var error_stack_clear_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

});

// MODULE: ./node_modules/core-js/internals/error-stack-install.js
var error_stack_install_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var createNonEnumerableProperty = (create_non_enumerable_property_namespaceFn());
var clearErrorStack = (error_stack_clear_namespaceFn());
var ERROR_STACK_INSTALLABLE = (error_stack_installable_namespaceFn());

// non-standard V8
// eslint-disable-next-line es/no-nonstandard-error-properties -- safe
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};

});

// MODULE: ./node_modules/core-js/internals/error-stack-installable.js
var error_stack_installable_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var fails = (fails_namespaceFn());
var createPropertyDescriptor = (create_property_descriptor_namespaceFn());

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});

});

// MODULE: ./node_modules/core-js/internals/export.js
var export_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var getOwnPropertyDescriptor = (object_get_own_property_descriptor_namespaceFn().f);
var createNonEnumerableProperty = (create_non_enumerable_property_namespaceFn());
var defineBuiltIn = (define_built_in_namespaceFn());
var defineGlobalProperty = (define_global_property_namespaceFn());
var copyConstructorProperties = (copy_constructor_properties_namespaceFn());
var isForced = (is_forced_namespaceFn());

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis;
  } else if (STATIC) {
    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis[TARGET] && globalThis[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

});

// MODULE: ./node_modules/core-js/internals/fails.js
var fails_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

});

// MODULE: ./node_modules/core-js/internals/function-apply.js
var function_apply_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var NATIVE_BIND = (function_bind_native_namespaceFn());

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

});

// MODULE: ./node_modules/core-js/internals/function-bind-context.js
var function_bind_context_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_clause_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var NATIVE_BIND = (function_bind_native_namespaceFn());

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

});

// MODULE: ./node_modules/core-js/internals/function-bind-native.js
var function_bind_native_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var fails = (fails_namespaceFn());

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () { /* empty */ }.bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

});

// MODULE: ./node_modules/core-js/internals/function-call.js
var function_call_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var NATIVE_BIND = (function_bind_native_namespaceFn());

var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

});

// MODULE: ./node_modules/core-js/internals/function-name.js
var function_name_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var DESCRIPTORS = (descriptors_namespaceFn());
var hasOwn = (has_own_property_namespaceFn());

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() { /* empty */ }.name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

});

// MODULE: ./node_modules/core-js/internals/function-uncurry-this-accessor.js
var function_uncurry_this_accessor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var aCallable = (a_callable_namespaceFn());

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

});

// MODULE: ./node_modules/core-js/internals/function-uncurry-this-clause.js
var function_uncurry_this_clause_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var classofRaw = (classof_raw_namespaceFn());
var uncurryThis = (function_uncurry_this_namespaceFn());

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};

});

// MODULE: ./node_modules/core-js/internals/function-uncurry-this.js
var function_uncurry_this_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var NATIVE_BIND = (function_bind_native_namespaceFn());

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};

});

// MODULE: ./node_modules/core-js/internals/get-built-in.js
var get_built_in_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var isCallable = (is_callable_namespaceFn());

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};

});

// MODULE: ./node_modules/core-js/internals/get-iterator-internal.js
var get_iterator_internal_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var call = (function_call_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var anObject = (an_object_namespaceFn());
var tryToString = (try_to_string_namespaceFn());
var getIteratorMethod = (get_iterator_method_internal_namespaceFn());

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (isCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};

});

// MODULE: ./node_modules/core-js/internals/get-iterator-method-internal.js
var get_iterator_method_internal_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var classof = (classof_raw_namespaceFn());
var isNullOrUndefined = (is_null_or_undefined_namespaceFn());
var getMethod = (get_method_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || (classof(it) === 'Arguments' ? ArrayPrototype[ITERATOR] : undefined);
};

});

// MODULE: ./node_modules/core-js/internals/get-method.js
var get_method_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var aCallable = (a_callable_namespaceFn());
var isNullOrUndefined = (is_null_or_undefined_namespaceFn());

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

});

// MODULE: ./node_modules/core-js/internals/global-this.js
var global_this_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

});

// MODULE: ./node_modules/core-js/internals/has-own-property.js
var has_own_property_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var toObject = (to_object_namespaceFn());

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

});

// MODULE: ./node_modules/core-js/internals/hidden-keys.js
var hidden_keys_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

module.exports = {};

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/host-report-errors.js
var host_report_errors_namespaceFn = function() {
	return __webpack_require__(757);
};

// MODULE: ./node_modules/core-js/internals/html.js
var html_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var getBuiltIn = (get_built_in_namespaceFn());

module.exports = getBuiltIn('document', 'documentElement');

});

// MODULE: ./node_modules/core-js/internals/ie8-dom-define.js
var ie8_dom_define_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var DESCRIPTORS = (descriptors_namespaceFn());
var fails = (fails_namespaceFn());
var createElement = (document_create_element_namespaceFn());

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

});

// MODULE: ./node_modules/core-js/internals/indexed-object.js
var indexed_object_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var fails = (fails_namespaceFn());
var classof = (classof_raw_namespaceFn());

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

});

// MODULE: ./node_modules/core-js/internals/inspect-source.js
var inspect_source_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var store = (shared_store_namespaceFn());

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;

});

// MODULE: ./node_modules/core-js/internals/install-error-cause.js
var install_error_cause_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isObject = (is_object_namespaceFn());
var createNonEnumerableProperty = (create_non_enumerable_property_namespaceFn());

// `InstallErrorCause` abstract operation
// https://tc39.es/ecma262/#sec-installerrorcause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};

});

// MODULE: ./node_modules/core-js/internals/internal-state.js
var internal_state_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var NATIVE_WEAK_MAP = (weak_map_basic_detection_namespaceFn());
var globalThis = (global_this_namespaceFn());
var isObject = (is_object_namespaceFn());
var createNonEnumerableProperty = (create_non_enumerable_property_namespaceFn());
var hasOwn = (has_own_property_namespaceFn());
var shared = (shared_store_namespaceFn());
var sharedKey = (shared_key_namespaceFn());
var hiddenKeys = (hidden_keys_namespaceFn());

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

});

// MODULE: ./node_modules/core-js/internals/is-array-iterator-method.js
var is_array_iterator_method_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var wellKnownSymbol = (well_known_symbol_namespaceFn());
var Iterators = (iterators_namespaceFn());

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

});

// MODULE: ./node_modules/core-js/internals/is-callable.js
var is_callable_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

});

// MODULE: ./node_modules/core-js/internals/is-constructor.js
var is_constructor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var fails = (fails_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var classof = (classof_namespaceFn());
var getBuiltIn = (get_built_in_namespaceFn());
var inspectSource = (inspect_source_namespaceFn());

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

});

// MODULE: ./node_modules/core-js/internals/is-forced.js
var is_forced_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var fails = (fails_namespaceFn());
var isCallable = (is_callable_namespaceFn());

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/is-null-or-undefined.js
var is_null_or_undefined_namespaceFn = function() {
	return __webpack_require__(117);
};

// MODULE: ./node_modules/core-js/internals/is-object.js
var is_object_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isCallable = (is_callable_namespaceFn());

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

});

// MODULE: ./node_modules/core-js/internals/is-possible-prototype.js
var is_possible_prototype_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isObject = (is_object_namespaceFn());

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};

});

// MODULE: ./node_modules/core-js/internals/is-pure.js
var is_pure_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

module.exports = false;

});

// MODULE: ./node_modules/core-js/internals/is-symbol.js
var is_symbol_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var getBuiltIn = (get_built_in_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var isPrototypeOf = (object_is_prototype_of_namespaceFn());
var USE_SYMBOL_AS_UID = (use_symbol_as_uid_namespaceFn());

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

});

// MODULE: ./node_modules/core-js/internals/iterate.js
var iterate_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var bind = (function_bind_context_namespaceFn());
var call = (function_call_namespaceFn());
var anObject = (an_object_namespaceFn());
var tryToString = (try_to_string_namespaceFn());
var isArrayIteratorMethod = (is_array_iterator_method_namespaceFn());
var lengthOfArrayLike = (length_of_array_like_namespaceFn());
var isPrototypeOf = (object_is_prototype_of_namespaceFn());
var getIterator = (get_iterator_internal_namespaceFn());
var getIteratorMethod = (get_iterator_method_internal_namespaceFn());
var iteratorClose = (iterator_close_namespaceFn());

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    var $iterator = iterator;
    iterator = undefined;
    if ($iterator) iteratorClose($iterator, 'normal');
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    // `IteratorValue` errors should propagate without closing the iterator
    var value = step.value;
    try {
      result = callFn(value);
    } catch (error) {
      if (iterator) iteratorClose(iterator, 'throw', error);
      else throw error;
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

});

// MODULE: ./node_modules/core-js/internals/iterator-close.js
var iterator_close_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var call = (function_call_namespaceFn());
var anObject = (an_object_namespaceFn());
var getMethod = (get_method_namespaceFn());

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

});

// MODULE: ./node_modules/core-js/internals/iterator-create-constructor.js
var iterator_create_constructor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var IteratorPrototype = (iterators_core_namespaceFn().IteratorPrototype);
var create = (object_create_namespaceFn());
var createPropertyDescriptor = (create_property_descriptor_namespaceFn());
var setToStringTag = (set_to_string_tag_namespaceFn());
var Iterators = (iterators_namespaceFn());

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

});

// MODULE: ./node_modules/core-js/internals/iterator-define.js
var iterator_define_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var $ = (export_namespaceFn());
var call = (function_call_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());
var FunctionName = (function_name_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var createIteratorConstructor = (iterator_create_constructor_namespaceFn());
var getPrototypeOf = (object_get_prototype_of_namespaceFn());
var setPrototypeOf = (object_set_prototype_of_namespaceFn());
var setToStringTag = (set_to_string_tag_namespaceFn());
var createNonEnumerableProperty = (create_non_enumerable_property_namespaceFn());
var defineBuiltIn = (define_built_in_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());
var Iterators = (iterators_namespaceFn());
var IteratorsCore = (iterators_core_namespaceFn());

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};

});

// MODULE: ./node_modules/core-js/internals/iterators-core.js
var iterators_core_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var fails = (fails_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var isObject = (is_object_namespaceFn());
var create = (object_create_namespaceFn());
var getPrototypeOf = (object_get_prototype_of_namespaceFn());
var defineBuiltIn = (define_built_in_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/iterators.js
var iterators_namespaceFn = function() {
	return __webpack_require__(269);
};

// MODULE: ./node_modules/core-js/internals/length-of-array-like.js
var length_of_array_like_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var toLength = (to_length_namespaceFn());

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};

});

// MODULE: ./node_modules/core-js/internals/make-built-in.js
var make_built_in_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var fails = (fails_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var hasOwn = (has_own_property_namespaceFn());
var DESCRIPTORS = (descriptors_namespaceFn());
var CONFIGURABLE_FUNCTION_NAME = (function_name_namespaceFn().CONFIGURABLE);
var inspectSource = (inspect_source_namespaceFn());
var InternalStateModule = (internal_state_namespaceFn());

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/math-trunc.js
var math_trunc_namespaceFn = function() {
	return __webpack_require__(741);
};

// MODULE: ./node_modules/core-js/internals/microtask.js
var microtask_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var safeGetBuiltIn = (safe_get_built_in_namespaceFn());
var bind = (function_bind_context_namespaceFn());
var macrotask = (task_namespaceFn().h);
var Queue = (queue_namespaceFn());
var IS_IOS = (environment_is_ios_namespaceFn());
var IS_IOS_PEBBLE = (environment_is_ios_pebble_namespaceFn());
var IS_WEBOS_WEBKIT = (environment_is_webos_webkit_namespaceFn());
var IS_NODE = (environment_is_node_namespaceFn());

var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver;
var document = globalThis.document;
var process = globalThis.process;
var Promise = globalThis.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, globalThis);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;

});

// MODULE: ./node_modules/core-js/internals/new-promise-capability.js
var new_promise_capability_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var aCallable = (a_callable_namespaceFn());

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};

});

// MODULE: ./node_modules/core-js/internals/normalize-string-argument.js
var normalize_string_argument_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var toString = (to_string_namespaceFn());

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};

});

// MODULE: ./node_modules/core-js/internals/object-create.js
var object_create_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

/* global ActiveXObject -- old IE, WSH */
var anObject = (an_object_namespaceFn());
var definePropertiesModule = (object_define_properties_namespaceFn());
var enumBugKeys = (enum_bug_keys_namespaceFn());
var hiddenKeys = (hidden_keys_namespaceFn());
var html = (html_namespaceFn());
var documentCreateElement = (document_create_element_namespaceFn());
var sharedKey = (shared_key_namespaceFn());

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

});

// MODULE: ./node_modules/core-js/internals/object-define-properties.js
var object_define_properties_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(__unused_webpack_module, exports) {

var DESCRIPTORS = (descriptors_namespaceFn());
var V8_PROTOTYPE_DEFINE_BUG = (v8_prototype_define_bug_namespaceFn());
var definePropertyModule = (object_define_property_namespaceFn());
var anObject = (an_object_namespaceFn());
var toIndexedObject = (to_indexed_object_namespaceFn());
var objectKeys = (object_keys_namespaceFn());

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

});

// MODULE: ./node_modules/core-js/internals/object-define-property.js
var object_define_property_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(__unused_webpack_module, exports) {

var DESCRIPTORS = (descriptors_namespaceFn());
var IE8_DOM_DEFINE = (ie8_dom_define_namespaceFn());
var V8_PROTOTYPE_DEFINE_BUG = (v8_prototype_define_bug_namespaceFn());
var anObject = (an_object_namespaceFn());
var toPropertyKey = (to_property_key_namespaceFn());

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

});

// MODULE: ./node_modules/core-js/internals/object-get-own-property-descriptor.js
var object_get_own_property_descriptor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(__unused_webpack_module, exports) {

var DESCRIPTORS = (descriptors_namespaceFn());
var call = (function_call_namespaceFn());
var propertyIsEnumerableModule = (object_property_is_enumerable_namespaceFn());
var createPropertyDescriptor = (create_property_descriptor_namespaceFn());
var toIndexedObject = (to_indexed_object_namespaceFn());
var toPropertyKey = (to_property_key_namespaceFn());
var hasOwn = (has_own_property_namespaceFn());
var IE8_DOM_DEFINE = (ie8_dom_define_namespaceFn());

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

});

// MODULE: ./node_modules/core-js/internals/object-get-own-property-names.js
var object_get_own_property_names_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(__unused_webpack_module, exports) {

var internalObjectKeys = (object_keys_internal_namespaceFn());
var enumBugKeys = (enum_bug_keys_namespaceFn());

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/object-get-own-property-symbols.js
var object_get_own_property_symbols_namespaceFn = function() {
	return __webpack_require__(717);
};

// MODULE: ./node_modules/core-js/internals/object-get-prototype-of.js
var object_get_prototype_of_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var hasOwn = (has_own_property_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var toObject = (to_object_namespaceFn());
var sharedKey = (shared_key_namespaceFn());
var CORRECT_PROTOTYPE_GETTER = (correct_prototype_getter_namespaceFn());

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

});

// MODULE: ./node_modules/core-js/internals/object-is-prototype-of.js
var object_is_prototype_of_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());

module.exports = uncurryThis({}.isPrototypeOf);

});

// MODULE: ./node_modules/core-js/internals/object-keys-internal.js
var object_keys_internal_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var hasOwn = (has_own_property_namespaceFn());
var toIndexedObject = (to_indexed_object_namespaceFn());
var indexOf = (array_includes_namespaceFn().q);
var hiddenKeys = (hidden_keys_namespaceFn());

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

});

// MODULE: ./node_modules/core-js/internals/object-keys.js
var object_keys_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var internalObjectKeys = (object_keys_internal_namespaceFn());
var enumBugKeys = (enum_bug_keys_namespaceFn());

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

});

// MODULE: ./node_modules/core-js/internals/object-property-is-enumerable.js
var object_property_is_enumerable_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(__unused_webpack_module, exports) {

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

});

// MODULE: ./node_modules/core-js/internals/object-set-prototype-of.js
var object_set_prototype_of_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = (function_uncurry_this_accessor_namespaceFn());
var isObject = (is_object_namespaceFn());
var requireObjectCoercible = (require_object_coercible_namespaceFn());
var aPossiblePrototype = (a_possible_prototype_namespaceFn());

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

});

// MODULE: ./node_modules/core-js/internals/object-to-string.js
var object_to_string_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var TO_STRING_TAG_SUPPORT = (to_string_tag_support_namespaceFn());
var classof = (classof_namespaceFn());

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

});

// MODULE: ./node_modules/core-js/internals/ordinary-to-primitive.js
var ordinary_to_primitive_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var call = (function_call_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var isObject = (is_object_namespaceFn());

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};

});

// MODULE: ./node_modules/core-js/internals/own-keys.js
var own_keys_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var getBuiltIn = (get_built_in_namespaceFn());
var uncurryThis = (function_uncurry_this_namespaceFn());
var getOwnPropertyNamesModule = (object_get_own_property_names_namespaceFn());
var getOwnPropertySymbolsModule = (object_get_own_property_symbols_namespaceFn());
var anObject = (an_object_namespaceFn());

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

});

// MODULE: ./node_modules/core-js/internals/path.js
var path_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());

module.exports = globalThis;

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/perform.js
var perform_namespaceFn = function() {
	return __webpack_require__(103);
};

// MODULE: ./node_modules/core-js/internals/promise-constructor-detection.js
var promise_constructor_detection_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var NativePromiseConstructor = (promise_native_constructor_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var isForced = (is_forced_namespaceFn());
var inspectSource = (inspect_source_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());
var ENVIRONMENT = (environment_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());
var V8_VERSION = (environment_v8_version_namespaceFn());

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

});

// MODULE: ./node_modules/core-js/internals/promise-native-constructor.js
var promise_native_constructor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());

module.exports = globalThis.Promise;

});

// MODULE: ./node_modules/core-js/internals/promise-resolve.js
var promise_resolve_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var anObject = (an_object_namespaceFn());
var isObject = (is_object_namespaceFn());
var newPromiseCapability = (new_promise_capability_namespaceFn());

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

});

// MODULE: ./node_modules/core-js/internals/promise-statics-incorrect-iteration.js
var promise_statics_incorrect_iteration_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var NativePromiseConstructor = (promise_native_constructor_namespaceFn());
var checkCorrectnessOfIteration = (check_correctness_of_iteration_namespaceFn());
var FORCED_PROMISE_CONSTRUCTOR = (promise_constructor_detection_namespaceFn().CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/queue.js
var queue_namespaceFn = function() {
	return __webpack_require__(265);
};

// MODULE: ./node_modules/core-js/internals/require-object-coercible.js
var require_object_coercible_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var isNullOrUndefined = (is_null_or_undefined_namespaceFn());

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};

});

// MODULE: ./node_modules/core-js/internals/safe-get-built-in.js
var safe_get_built_in_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var DESCRIPTORS = (descriptors_namespaceFn());

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
module.exports = function (name) {
  if (!DESCRIPTORS) return globalThis[name];
  var descriptor = getOwnPropertyDescriptor(globalThis, name);
  return descriptor && descriptor.value;
};

});

// MODULE: ./node_modules/core-js/internals/set-species.js
var set_species_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var getBuiltIn = (get_built_in_namespaceFn());
var defineBuiltInAccessor = (define_built_in_accessor_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());
var DESCRIPTORS = (descriptors_namespaceFn());

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

});

// MODULE: ./node_modules/core-js/internals/set-to-string-tag.js
var set_to_string_tag_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var defineProperty = (object_define_property_namespaceFn().f);
var hasOwn = (has_own_property_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

});

// MODULE: ./node_modules/core-js/internals/shared-key.js
var shared_key_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var shared = (shared_namespaceFn());
var uid = (uid_namespaceFn());

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

});

// MODULE: ./node_modules/core-js/internals/shared-store.js
var shared_store_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var IS_PURE = (is_pure_namespaceFn());
var globalThis = (global_this_namespaceFn());
var defineGlobalProperty = (define_global_property_namespaceFn());

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.51.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.',
  license: 'https://github.com/zloirock/core-js/blob/v3.51.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

});

// MODULE: ./node_modules/core-js/internals/shared.js
var shared_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var store = (shared_store_namespaceFn());
// eslint-disable-next-line es/no-object-create -- safe
var create = Object.create || Object;

module.exports = function (key, value) {
  return store[key] || (store[key] = value || create(null));
};

});

// MODULE: ./node_modules/core-js/internals/species-constructor.js
var species_constructor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var anObject = (an_object_namespaceFn());
var aConstructor = (a_constructor_namespaceFn());
var isNullOrUndefined = (is_null_or_undefined_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};

});

// MODULE: ./node_modules/core-js/internals/string-multibyte.js
var string_multibyte_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());
var toIntegerOrInfinity = (to_integer_or_infinity_namespaceFn());
var toString = (to_string_namespaceFn());
var requireObjectCoercible = (require_object_coercible_namespaceFn());

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  o: createMethod(true)
};

});

// MODULE: ./node_modules/core-js/internals/symbol-constructor-detection.js
var symbol_constructor_detection_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = (environment_v8_version_namespaceFn());
var fails = (fails_namespaceFn());
var globalThis = (global_this_namespaceFn());

var $String = globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

});

// MODULE: ./node_modules/core-js/internals/task.js
var task_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var apply = (function_apply_namespaceFn());
var bind = (function_bind_context_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var hasOwn = (has_own_property_namespaceFn());
var fails = (fails_namespaceFn());
var html = (html_namespaceFn());
var arraySlice = (array_slice_namespaceFn());
var createElement = (document_create_element_namespaceFn());
var validateArgumentsLength = (validate_arguments_length_namespaceFn());
var IS_IOS = (environment_is_ios_namespaceFn());
var IS_NODE = (environment_is_node_namespaceFn());

var set = globalThis.setImmediate;
var clear = globalThis.clearImmediate;
var process = globalThis.process;
var Dispatch = globalThis.Dispatch;
var Function = globalThis.Function;
var MessageChannel = globalThis.MessageChannel;
var String = globalThis.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = globalThis.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  globalThis.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    globalThis.addEventListener &&
    isCallable(globalThis.postMessage) &&
    !globalThis.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    globalThis.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  h: set,
  clear: clear
};

});

// MODULE: ./node_modules/core-js/internals/to-absolute-index.js
var to_absolute_index_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var toIntegerOrInfinity = (to_integer_or_infinity_namespaceFn());

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

});

// MODULE: ./node_modules/core-js/internals/to-indexed-object.js
var to_indexed_object_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = (indexed_object_namespaceFn());
var requireObjectCoercible = (require_object_coercible_namespaceFn());

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

});

// MODULE: ./node_modules/core-js/internals/to-integer-or-infinity.js
var to_integer_or_infinity_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var trunc = (math_trunc_namespaceFn());

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

});

// MODULE: ./node_modules/core-js/internals/to-length.js
var to_length_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var toIntegerOrInfinity = (to_integer_or_infinity_namespaceFn());

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});

// MODULE: ./node_modules/core-js/internals/to-object.js
var to_object_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var requireObjectCoercible = (require_object_coercible_namespaceFn());

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

});

// MODULE: ./node_modules/core-js/internals/to-primitive.js
var to_primitive_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var call = (function_call_namespaceFn());
var isObject = (is_object_namespaceFn());
var isSymbol = (is_symbol_namespaceFn());
var getMethod = (get_method_namespaceFn());
var ordinaryToPrimitive = (ordinary_to_primitive_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

});

// MODULE: ./node_modules/core-js/internals/to-property-key.js
var to_property_key_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var toPrimitive = (to_primitive_namespaceFn());
var isSymbol = (is_symbol_namespaceFn());

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

});

// MODULE: ./node_modules/core-js/internals/to-string-tag-support.js
var to_string_tag_support_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var wellKnownSymbol = (well_known_symbol_namespaceFn());

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';

});

// MODULE: ./node_modules/core-js/internals/to-string.js
var to_string_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var classof = (classof_namespaceFn());

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

});

// EXTERNAL MODULE: ./node_modules/core-js/internals/try-to-string.js
var try_to_string_namespaceFn = function() {
	return __webpack_require__(823);
};

// MODULE: ./node_modules/core-js/internals/uid.js
var uid_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var uncurryThis = (function_uncurry_this_namespaceFn());

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.1.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

});

// MODULE: ./node_modules/core-js/internals/use-symbol-as-uid.js
var use_symbol_as_uid_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = (symbol_constructor_detection_namespaceFn());

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

});

// MODULE: ./node_modules/core-js/internals/v8-prototype-define-bug.js
var v8_prototype_define_bug_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var DESCRIPTORS = (descriptors_namespaceFn());
var fails = (fails_namespaceFn());

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

});

// MODULE: ./node_modules/core-js/internals/validate-arguments-length.js
var validate_arguments_length_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};

});

// MODULE: ./node_modules/core-js/internals/weak-map-basic-detection.js
var weak_map_basic_detection_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var isCallable = (is_callable_namespaceFn());

var WeakMap = globalThis.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

});

// MODULE: ./node_modules/core-js/internals/well-known-symbol.js
var well_known_symbol_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var globalThis = (global_this_namespaceFn());
var shared = (shared_namespaceFn());
var hasOwn = (has_own_property_namespaceFn());
var uid = (uid_namespaceFn());
var NATIVE_SYMBOL = (symbol_constructor_detection_namespaceFn());
var USE_SYMBOL_AS_UID = (use_symbol_as_uid_namespaceFn());

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

});

// MODULE: ./node_modules/core-js/modules/es.aggregate-error.constructor.js
var es_aggregate_error_constructor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var isPrototypeOf = (object_is_prototype_of_namespaceFn());
var getPrototypeOf = (object_get_prototype_of_namespaceFn());
var setPrototypeOf = (object_set_prototype_of_namespaceFn());
var copyConstructorProperties = (copy_constructor_properties_namespaceFn());
var create = (object_create_namespaceFn());
var createNonEnumerableProperty = (create_non_enumerable_property_namespaceFn());
var createPropertyDescriptor = (create_property_descriptor_namespaceFn());
var installErrorCause = (install_error_cause_namespaceFn());
var installErrorStack = (error_stack_install_namespaceFn());
var iterate = (iterate_namespaceFn());
var normalizeStringArgument = (normalize_string_argument_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Error = Error;
var push = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
  installErrorStack(that, $AggregateError, that.stack, 1);
  if (arguments.length > 2) installErrorCause(that, arguments[2]);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });

var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});

});

// MODULE: ./node_modules/core-js/modules/es.aggregate-error.js
var es_aggregate_error_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
(es_aggregate_error_constructor_namespaceFn());

});

// MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var toIndexedObject = (to_indexed_object_namespaceFn());
var addToUnscopables = (add_to_unscopables_namespaceFn());
var Iterators = (iterators_namespaceFn());
var InternalStateModule = (internal_state_namespaceFn());
var defineProperty = (object_define_property_namespaceFn().f);
var defineIterator = (iterator_define_namespaceFn());
var createIterResultObject = (create_iter_result_object_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());
var DESCRIPTORS = (descriptors_namespaceFn());

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

});

// MODULE: ./node_modules/core-js/modules/es.object.create.js
var es_object_create_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

// TODO: Remove from `core-js@4`
var $ = (export_namespaceFn());
var DESCRIPTORS = (descriptors_namespaceFn());
var create = (object_create_namespaceFn());

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});

});

// MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var TO_STRING_TAG_SUPPORT = (to_string_tag_support_namespaceFn());
var defineBuiltIn = (define_built_in_namespaceFn());
var toString = (object_to_string_namespaceFn());

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}

});

// MODULE: ./node_modules/core-js/modules/es.promise.all-settled.js
var es_promise_all_settled_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var call = (function_call_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var perform = (perform_namespaceFn());
var iterate = (iterate_namespaceFn());
var PROMISE_STATICS_INCORRECT_ITERATION = (promise_statics_incorrect_iteration_namespaceFn());

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.promise.all.js
var es_promise_all_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var call = (function_call_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var perform = (perform_namespaceFn());
var iterate = (iterate_namespaceFn());
var PROMISE_STATICS_INCORRECT_ITERATION = (promise_statics_incorrect_iteration_namespaceFn());

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.promise.any.js
var es_promise_any_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var call = (function_call_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var getBuiltIn = (get_built_in_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var perform = (perform_namespaceFn());
var iterate = (iterate_namespaceFn());
var PROMISE_STATICS_INCORRECT_ITERATION = (promise_statics_incorrect_iteration_namespaceFn());

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.promise.catch.js
var es_promise_catch_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());
var FORCED_PROMISE_CONSTRUCTOR = (promise_constructor_detection_namespaceFn().CONSTRUCTOR);
var NativePromiseConstructor = (promise_native_constructor_namespaceFn());
var getBuiltIn = (get_built_in_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var defineBuiltIn = (define_built_in_namespaceFn());

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

});

// MODULE: ./node_modules/core-js/modules/es.promise.constructor.js
var es_promise_constructor_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());
var IS_NODE = (environment_is_node_namespaceFn());
var globalThis = (global_this_namespaceFn());
var path = (path_namespaceFn());
var call = (function_call_namespaceFn());
var defineBuiltIn = (define_built_in_namespaceFn());
var setPrototypeOf = (object_set_prototype_of_namespaceFn());
var setToStringTag = (set_to_string_tag_namespaceFn());
var setSpecies = (set_species_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var isObject = (is_object_namespaceFn());
var anInstance = (an_instance_namespaceFn());
var speciesConstructor = (species_constructor_namespaceFn());
var task = (task_namespaceFn().h);
var microtask = (microtask_namespaceFn());
var hostReportErrors = (host_report_errors_namespaceFn());
var perform = (perform_namespaceFn());
var Queue = (queue_namespaceFn());
var InternalStateModule = (internal_state_namespaceFn());
var NativePromiseConstructor = (promise_native_constructor_namespaceFn());
var PromiseConstructorDetection = (promise_constructor_detection_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = globalThis.TypeError;
var document = globalThis.document;
var process = globalThis.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && globalThis.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    globalThis.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: null
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

PromiseWrapper = path.Promise;

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

});

// MODULE: ./node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());
var NativePromiseConstructor = (promise_native_constructor_namespaceFn());
var fails = (fails_namespaceFn());
var getBuiltIn = (get_built_in_namespaceFn());
var isCallable = (is_callable_namespaceFn());
var speciesConstructor = (species_constructor_namespaceFn());
var promiseResolve = (promise_resolve_namespaceFn());
var defineBuiltIn = (define_built_in_namespaceFn());

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}

});

// MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
(es_promise_constructor_namespaceFn());
(es_promise_all_namespaceFn());
(es_promise_catch_namespaceFn());
(es_promise_race_namespaceFn());
(es_promise_reject_namespaceFn());
(es_promise_resolve_namespaceFn());

});

// MODULE: ./node_modules/core-js/modules/es.promise.race.js
var es_promise_race_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var call = (function_call_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var perform = (perform_namespaceFn());
var iterate = (iterate_namespaceFn());
var PROMISE_STATICS_INCORRECT_ITERATION = (promise_statics_incorrect_iteration_namespaceFn());

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.promise.reject.js
var es_promise_reject_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var FORCED_PROMISE_CONSTRUCTOR = (promise_constructor_detection_namespaceFn().CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.promise.resolve.js
var es_promise_resolve_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var getBuiltIn = (get_built_in_namespaceFn());
var IS_PURE = (is_pure_namespaceFn());
var NativePromiseConstructor = (promise_native_constructor_namespaceFn());
var FORCED_PROMISE_CONSTRUCTOR = (promise_constructor_detection_namespaceFn().CONSTRUCTOR);
var promiseResolve = (promise_resolve_namespaceFn());

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.promise.try.js
var es_promise_try_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var globalThis = (global_this_namespaceFn());
var apply = (function_apply_namespaceFn());
var slice = (array_slice_namespaceFn());
var promiseResolve = (promise_resolve_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var perform = (perform_namespaceFn());
var fails = (fails_namespaceFn());

var Promise = globalThis.Promise;

var ACCEPT_ARGUMENTS = false;
var FORCED = !Promise || !Promise['try'] || fails(function () {
  var p = Promise.resolve();
  return Promise['try'](function (argument) {
    // avoiding the use of polyfills of the previous iteration of this proposal
    // that does not accept arguments of the callback
    ACCEPT_ARGUMENTS = argument === 8;
    return p;
  // it should use `PromiseResolve`
  // https://github.com/tc39/ecma262/pull/3883
  }, 8) !== p;
}) || !ACCEPT_ARGUMENTS;

// `Promise.try` method
// https://tc39.es/ecma262/#sec-promise.try
$({ target: 'Promise', stat: true, forced: FORCED }, {
  'try': function (callbackfn /* , ...args */) {
    var args = arguments.length > 1 ? slice(arguments, 1) : [];
    var result = perform(function () {
      return apply(aCallable(callbackfn), undefined, args);
    });
    if (!result.error) return promiseResolve(this, result.value);
    var promiseCapability = newPromiseCapabilityModule.f(this);
    var reject = promiseCapability.reject;
    reject(result.value);
    return promiseCapability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.promise.with-resolvers.js
var es_promise_with_resolvers_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());

// `Promise.withResolvers` method
// https://tc39.es/ecma262/#sec-promise.withResolvers
$({ target: 'Promise', stat: true }, {
  withResolvers: function withResolvers() {
    var promiseCapability = newPromiseCapabilityModule.f(this);
    return {
      promise: promiseCapability.promise,
      resolve: promiseCapability.resolve,
      reject: promiseCapability.reject
    };
  }
});

});

// MODULE: ./node_modules/core-js/modules/es.reflect.own-keys.js
var es_reflect_own_keys_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var ownKeys = (own_keys_namespaceFn());

// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});

});

// MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var charAt = (string_multibyte_namespaceFn().o);
var toString = (to_string_namespaceFn());
var InternalStateModule = (internal_state_namespaceFn());
var defineIterator = (iterator_define_namespaceFn());
var createIterResultObject = (create_iter_result_object_namespaceFn());

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

});

// MODULE: ./node_modules/core-js/modules/esnext.promise.all-keyed.js
var esnext_promise_all_keyed_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var anObject = (an_object_namespaceFn());
var call = (function_call_namespaceFn());
var createProperty = (create_property_namespaceFn());
var getBuiltIn = (get_built_in_namespaceFn());
var getOwnPropertyDescriptor = (object_get_own_property_descriptor_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var perform = (perform_namespaceFn());

var create = getBuiltIn('Object', 'create');
var ownKeys = getBuiltIn('Reflect', 'ownKeys');

// `Promise.allKeyed` method
// https://github.com/tc39/proposal-await-dictionary
$({ target: 'Promise', stat: true }, {
  allKeyed: function allKeyed(promises) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var allKeys = ownKeys(anObject(promises));
      var keys = [];
      var values = [];
      var remaining = 1;
      var counter = 0;
      var resolveResult = function () {
        var res = create(null);
        for (var j = 0; j < keys.length; j++) createProperty(res, keys[j], values[j]);
        resolve(res);
      };
      for (var i = 0; i < allKeys.length; i++) (function (key) {
        var desc = getOwnPropertyDescriptor.f(promises, key);
        if (desc && desc.enumerable) {
          var index = counter;
          var alreadyCalled = false;
          remaining++;
          keys[index] = key;
          values[index] = undefined;
          call(promiseResolve, C, promises[key]).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[index] = value;
            --remaining || resolveResult();
          }, reject);
          counter++;
        }
      })(allKeys[i]);
      --remaining || resolveResult();
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/esnext.promise.all-settled-keyed.js
var esnext_promise_all_settled_keyed_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var $ = (export_namespaceFn());
var aCallable = (a_callable_namespaceFn());
var anObject = (an_object_namespaceFn());
var call = (function_call_namespaceFn());
var createProperty = (create_property_namespaceFn());
var getBuiltIn = (get_built_in_namespaceFn());
var getOwnPropertyDescriptor = (object_get_own_property_descriptor_namespaceFn());
var newPromiseCapabilityModule = (new_promise_capability_namespaceFn());
var perform = (perform_namespaceFn());

var create = getBuiltIn('Object', 'create');
var ownKeys = getBuiltIn('Reflect', 'ownKeys');

// `Promise.allSettledKeyed` method
// https://github.com/tc39/proposal-await-dictionary
$({ target: 'Promise', stat: true }, {
  allSettledKeyed: function allSettledKeyed(promises) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var allKeys = ownKeys(anObject(promises));
      var keys = [];
      var values = [];
      var remaining = 1;
      var counter = 0;
      var resolveResult = function () {
        var res = create(null);
        for (var j = 0; j < keys.length; j++) createProperty(res, keys[j], values[j]);
        resolve(res);
      };
      for (var i = 0; i < allKeys.length; i++) (function (key) {
        var desc = getOwnPropertyDescriptor.f(promises, key);
        if (desc && desc.enumerable) {
          var createElementResolver = function (rejection) {
            return function (value) {
              if (alreadyCalled) return;
              alreadyCalled = true;
              values[index] = rejection
                ? { status: 'rejected', reason: value }
                : { status: 'fulfilled', value: value };
              --remaining || resolveResult();
            };
          };
          var index = counter;
          var alreadyCalled = false;
          remaining++;
          keys[index] = key;
          values[index] = undefined;
          call(promiseResolve, C, promises[key]).then(createElementResolver(false), createElementResolver(true));
          counter++;
        }
      })(allKeys[i]);
      --remaining || resolveResult();
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

});

// MODULE: ./node_modules/core-js/modules/esnext.promise.try.js
var esnext_promise_try_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

// TODO: Remove from `core-js@4`
(es_promise_try_namespaceFn());

});

// MODULE: ./node_modules/core-js/modules/esnext.promise.with-resolvers.js
var esnext_promise_with_resolvers_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

// TODO: Remove from `core-js@4`
(es_promise_with_resolvers_namespaceFn());

});

// MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function() {

var globalThis = (global_this_namespaceFn());
var DOMIterables = (dom_iterables_namespaceFn());
var DOMTokenListPrototype = (dom_token_list_prototype_namespaceFn());
var ArrayIteratorMethods = (es_array_iterator_namespaceFn());
var createNonEnumerableProperty = (create_non_enumerable_property_namespaceFn());
var setToStringTag = (set_to_string_tag_namespaceFn());
var wellKnownSymbol = (well_known_symbol_namespaceFn());

var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

});

// MODULE: ./node_modules/core-js/stable/promise/index.js
var stable_promise_namespaceFn = /*#__PURE__*/__webpack_require__.cw(function(module) {

var parent = (promise_namespaceFn());
(web_dom_collections_iterator_namespaceFn());

module.exports = parent;

});

;// ./node_modules/core-js/actual/promise/index.js
actual_promise_namespaceFn();

;// ./build/shared/js/modules/amountInput.js
/**
 * Initialize amount input controls with increment/decrement buttons
 * Looks for `.js-amount` container and controls within it
 */
function initAmountInput() {
  const quantityContainer = document.querySelector('.js-amount');

  if (!quantityContainer) {
    return;
  }

  const minusBtn = quantityContainer.querySelector('.js-amount__btn--minus');
  const plusBtn = quantityContainer.querySelector('.js-amount__btn--plus');
  const input = quantityContainer.querySelector('.js-amount__input');

  if (!minusBtn || !plusBtn || !input) {
    return;
  }

  const updateButtonStates = () => {
    const value = parseInt(input.value);
    minusBtn.disabled = value <= 1;
    plusBtn.disabled = value >= parseInt(input.max);
  };

  const decreaseValue = () => {
    input.stepDown();
    updateButtonStates();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const increaseValue = () => {
    input.stepUp();
    updateButtonStates();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  updateButtonStates();

  input.addEventListener('input', updateButtonStates);
  minusBtn.addEventListener('click', decreaseValue);
  plusBtn.addEventListener('click', increaseValue);

  // Tier prices buttons are setting amount value directly
  const tierBtns = document.querySelectorAll('.js-tier-btn');
  if (tierBtns.length > 0) {
    const onTierBtnClick = (event) => {
      const btn = event.currentTarget;

      if (btn.classList.contains('active')) {
        tierBtns.forEach((b) => b.classList.remove('active'));
        input.value = 1;
      } else {
        const amount = parseInt(btn.dataset.amount, 10) || 1;
        input.value = amount;
      }

      updateButtonStates();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    Array.from(tierBtns).forEach((btn) => {
      btn.addEventListener('click', onTierBtnClick);
    });
  }
}

;// ./build/shared/js/modules/constants.js
const _queryString = window.location.search;
const _urlParams = new URLSearchParams(_queryString);

const _DEBUG = _urlParams.get('debug') == 1 ? true : false;

;// ./build/shared/js/modules/cookies.js


/**
 * Set a cookie
 * @param {string} cname key
 * @param {string} cvalue value
 * @param {int} [exdays] number of days the cookie lasts
 * @param {string} [path] where the cookie is valid
 */
const setCookie = (cname, cvalue, exdays, path) => {
  if (_DEBUG) {
    console.log('setCookie()');
  }
  let expires = '';
  if (exdays) {
    let d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = ';expires=' + d.toUTCString();
  }
  let pathParam = '';
  if (path) {
    pathParam = ';path=' + path;
  }
  let secureParam = '';
  if (window.location.protocol === 'https:') {
    secureParam = ';secure';
  }
  document.cookie = cname + '=' + cvalue + expires + secureParam + pathParam;
};

/**
 * Get value of the give cookie
 * @param d
 * @returns {string}
 */
let getCookie = (d) => {
  const b = d + '=';
  const a = document.cookie.split(';');
  for (let e = 0; e < a.length; e++) {
    //const f = a[e].trim();
    const f = $.trim(a[e]);
    if (f.indexOf(b) === 0) {
      return f.substring(b.length, f.length);
    }
  }
  return '';
};

;// ./build/shared/js/modules/announcementBar.js
__webpack_require__.dn(announcementBar);


const COOKIE_NAME = 'announcement_bar_closed';
const COOKIE_LIFETIME_DAYS = 90;

/**
 * Einzeilige Announcement-Bar im Header.
 *
 * Blendet die Bar aus, sobald sie geschlossen wird, und merkt sich das per Cookie.
 * Der data-announcement-key identifiziert die Meldung: wird er im Template
 * geaendert, wird die Bar erneut ausgespielt.
 *
 * @see templates/frontend/default_de/component_teaser_announcementbar.tpl
 */
/* harmony default export */ function announcementBar() {
  const $bar = $('.js-announcement-bar');

  if (!$bar.length) {
    return;
  }

  const announcementKey = String($bar.data('announcementKey') || '');

  if (announcementKey && getCookie(COOKIE_NAME) === announcementKey) {
    $bar.remove();
    return;
  }

  $bar.on('click', '.js-announcement-bar-close', function () {
    if (announcementKey) {
      setCookie(COOKIE_NAME, announcementKey, COOKIE_LIFETIME_DAYS, '/');
    }
    $bar.slideUp(200, function () {
      $bar.remove();
    });
  });
}

;// ./build/shared/js/modules/loadingScreen.js
const loadingScreen_showLoadingScreen = () => {
  $('body').addClass('loading');
  window.setTimeout(removeLoadingScreen, 5000);
};

const removeLoadingScreen = () => {
  console.log('click on loading-modal');
  $('body').removeClass('loading');
};

/* harmony default export */ var loadingScreen = (() => {
  // Loading animation for view and feel an response of clicking anything
  window.onbeforeunload = () => {
    loadingScreen_showLoadingScreen();
  };

  $(document).ready(($) => {
    $('.loading-modal').click(() => {
      window.setTimeout(removeLoadingScreen, 2000);
    });
  });
});
__webpack_require__.dn(loadingScreen);

;// ./build/shared/js/modules/utils.js


//-----------------------------------
// ### Set Same Height ###
//------------------------------------
const setSameHeight = (parent, childSelector) => {
  let highestBox = 0;
  $(childSelector, parent).each((index, element) => {
    if ($(element).height() > highestBox) {
      highestBox = $(element).height();
    }
  });
  $(childSelector, parent).height(highestBox);
};

const setCursor = (value) => {
  $('body').css('cursor', value);
};

const keepalive = () => {
  if (_DEBUG) console.log('keepalive..........?');

  let basket_empty = window.dataLayer[0].basket.length == 0;
  let basket_add =
    window.dataLayer.filter(function (e) {
      return e.event === 'addToBasket';
    }).length > 0;

  if (!basket_empty || basket_add) {
    $.get('/rpc.php', { action: 'keepalive' }).done(function (data) {
      if (_DEBUG) console.log('keepalive....send');
    });
  } else {
    if (_DEBUG) console.log('keepalive....not needed!');
  }
};

const toggleText = (element, collapsed = true) => {
  if (collapsed) {
    $(element).text($(element).data('collapsed'));
  } else {
    $(element).text($(element).data('collapse'));
  }
};

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

const insertDotLoaderElement = (element) => {
  element.innerHTML = '';
  const loader = document.createElement('div');
  loader.classList.add('dot-loader');
  loader.innerHTML = `
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  `;
  element.appendChild(loader);
};

/**
 * Parses a price string and converts it to a float number.
 */
const parsePrice = (text) => {
  return parseFloat(
    String(text)
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^\d.]/g, ''),
  );
};

/**
 * Returns the shop code from the body dataset or defaults to 'aponeo_de'.
 *
 * For importing css and js assets, use `themeAssetUrl(...)`
 *
 * @returns {string} aponeo_de|meine-onlineapo_de|pharmeo_at|pharmeo_de|sparmed_de
 */
const getShopCode = () => {
  return document.body.dataset.shopcode || 'aponeo_de';
};

;// ./build/shared/js/modules/aponeo.js





// TODO Use arrow functions in this file

/**
 * collection of globally useful utilities
 * @namespace aponeo
 */
const aponeo = {};
(function ($, win) {
  // closure to cache some jQuery calls
  let header = $('.header');
  /**
   * get current height of the header bar
   *
   * @return {int}
   */
  aponeo.headerHeight = function () {
    return header.height();
  };

  let _htmlBody = $('html, body');

  aponeo.log = function (message) {
    if (_DEBUG) {
      console.log(message);
    }
  };

  /**
   * like $('html,body').scrollTop but accounts for the fixed header
   *
   * @param {int|jQuery} top, pixel offset from the top of the document or an element to scroll to
   * @param {int} [duration] of the animation (default 300ms)
   * @function aponeo.scrollTop
   */
  aponeo.scrollTop = function (top, duration) {
    if (typeof top == 'object') {
      top = top.offset().top;
    }
    let target = top - aponeo.headerHeight();
    if (typeof duration == 'undefined') {
      duration = 450;
    }
    if (duration === 0) {
      _htmlBody.scrollTop(target);
    } else {
      _htmlBody.animate({ scrollTop: target }, duration);
    }
  };

  /**
   * Show loading screen
   */
  aponeo.showLoadingScreen = function () {
    $('body').addClass('loading');
    window.setTimeout(aponeo.hideLoadingScreen, 5000);
  };

  /**
   * hide loading screen
   * Todo there is also removeLoadingScreen
   */
  aponeo.hideLoadingScreen = function () {
    $('body').removeClass('loading');
  };

  aponeo.addNotificationList = function (messages) {
    for (let i = 0, length = messages.length; i < length; i++) {
      let msgData = messages[i];
      aponeo.addNotification(msgData[0], msgData[1]);
    }
  };

  aponeo.clearInput = function () {
    $('.apn-clear-input').each((i, elem) => {
      const hasInputClass = 'has-input';
      const toggleClearInputButton = function () {
        const $input = $('input', elem).first();
        $input.toggleClass(hasInputClass, $input.val().length > 0);
      };
      $(elem)
        .off('input.clearInput')
        .on('input.clearInput', () => {
          toggleClearInputButton();
        });
      $('button', elem)
        .off('click.clearInput')
        .on('click.clearInput', () => {
          $('input', elem).first().val('').removeClass(hasInputClass).focus();
        });
      toggleClearInputButton();
    });
  };
  aponeo.clearInput();

  /**
   * Build the symbol.svg URL for the current shop.
   *
   * @param {string} name Symbol name
   * @return {string}
   */
  function buildSymbolUrl(name) {
    const shopCode = getShopCode();
    const basePath = '/images/' + shopCode + '/resplayout/symbol.svg';

    // TODO: Evaluate if for aponeo_de, this should fall through:
    // '/images/resplayout/symbol.svg'

    return basePath + '#' + name;
  }

  /**
   * Build notification HTML matching the partial_notification.tpl markup.
   *
   * @param {string} message Message HTML
   * @param {int}    type     0=success, 1=error, 2=warning, default=info
   * @return {string}
   */
  aponeo.buildNotificationHtml = function (message, type) {
    let alertClass = 'alert-info';
    let alertRole = 'status';
    let iconName = 'info_circle';
    let iconLabel = 'Information:';

    if (type == 0) {
      alertClass = 'alert-success';
      alertRole = 'status';
      iconName = 'check_circle';
      iconLabel = 'Erfolg:';
    } else if (type == 1) {
      alertClass = 'alert-danger';
      alertRole = 'alert';
      iconName = 'x_circle';
      iconLabel = 'Fehler:';
    } else if (type == 2) {
      alertClass = 'alert-warning';
      alertRole = 'alert';
      iconName = 'exclamation_circle';
      iconLabel = 'Warnung:';
    }

    return (
      '<div class="alert ' +
      alertClass +
      ' message message-ajax d-flex align-items-center" role="' +
      alertRole +
      '">' +
      '<svg class="message-icon flex-shrink-0 mr-2" width="24" height="24" viewBox="0 0 100 100" focusable="false" role="img" aria-label="' +
      iconLabel +
      '">' +
      '<use xlink:href="' +
      buildSymbolUrl(iconName) +
      '"></use>' +
      '</svg>' +
      '<div class="message-text flex-grow-1">' +
      '<span class="sr-only">' +
      iconLabel +
      '</span>' +
      '<div>' +
      message +
      '</div>' +
      '</div>' +
      '</div>'
    );
  };

  aponeo.addNotification = function (message, type) {
    // add messages container if none exists
    if (!$('#notification-lines').length) {
      $('main > .breadcrumbs').after($('<div id="notification-lines" aria-live="polite" aria-atomic="false"></div>'));
    }

    $('#notification-lines').append($(aponeo.buildNotificationHtml(message, type)));
  };

  aponeo.refreshCaptcha = function () {
    // force browser to reload the image
    let newSrc = '/sec-img.php?v=' + new Date().getTime();
    $('img[src="/sec-img.php"]').each(function () {
      this.src = newSrc;
    });
  };

  aponeo.showAppInstallBanner = function ($this) {
    $this.removeClass('d-none');
    let $closeButton = $this.find('.apn-app-install-close');
    $closeButton.click(function (e) {
      e.preventDefault();
      $this.addClass('js-dismissed');
      setCookie('appInstallBannerDismissed', '1', 1);
    });
  };
  aponeo.isAndroid = function () {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
  };
  aponeo.isMobile = function () {
    // @see http://detectmobilebrowsers.com/
    let isMobile = false;
    (function (uaString) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          uaString,
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          uaString.substr(0, 4),
        )
      )
        isMobile = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return isMobile;
  };
  aponeo.isTablet = function () {
    let isTablet = false;
    (function (uaString) {
      if (
        /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(
          uaString,
        )
      )
        isTablet = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return isTablet;
  };
  if (aponeo.isAndroid() && aponeo.isMobile() && getCookie('appInstallBannerDismissed') !== '1') {
    let $appInstallBanner = $('#apn-app-install');
    if ($appInstallBanner.length > 0) {
      aponeo.showAppInstallBanner($appInstallBanner);
    }
  }

  /**
   * Quick jQuery plugin to check if an element is in the current view
   */
  let $w = $(win);
  /** @returns {boolean} */
  $.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $w.scrollTop();
    let viewportBottom = viewportTop + $w.height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // AJAX cart:
  let cartTemplate =
    '<div class="popover cart-popover d-none d-lg-block" role="tooltip"><div class="arrow"></div><h3 class="popover-header text-center apn-text-16 font-secondary font-weight-bold py-2"></h3><div class="popover-body"></div></div>';

  /**
   * AJAX cart object
   * @usage cart is available in a global variable apnCart
   * apnCart.add(productId, qty)
   * apnCart.remove(basketItemId)
   * update happens automatically
   * @param elem
   * @constructor
   */
  function Cart(elem) {
    this.popoverElem = elem;
    this.popoverCallback = this.setupPopover;
    this.update();
  }

  Cart.prototype = {
    cartTemplate: cartTemplate,
    add: function (id, qty, code) {
      let self = this;
      loadingScreen_showLoadingScreen();

      let currunturl = window.location.pathname;

      if (currunturl.indexOf('warenkorb') !== -1) {
        // On basket page we need a full refresh page and also a success message
        // So lets use the oldschool post submit functions
        let form = $(
          '<form id="recohelperform_' +
            id +
            '" action="" method="post"><input type="hidden" name="abskt" value="' +
            id +
            '" /><input type="hidden" name="amnt" value="' +
            qty +
            '" /></form>',
        );
        $('body').append(form);
        $('#recohelperform_' + id).submit();
      } else {
        let data = {
          abskt: id,
          amnt: qty,
        };
        if (code) {
          // Seems to be an erx scan
          $('.apn-add2cart-reco').remove(); // Remove add2Cart-Reco recipe
          data.code = btoa(JSON.stringify(code));
        }

        $.ajax({
          url: '/rpc.php?action=addtobasket',
          data: data,
          method: 'GET',
        }).done((response) => {
          removeLoadingScreen();
          self.update();

          //console.log('addtoBasket finished!!!');
          //console.log(response);

          // For adding more than one product optimize the success overlay:
          if (response.headline_succ.length > 5) {
            $('#modal-productAdded #modal-title').html(response.headline_succ);
            $('#modal-productAdded #modal-body').html(response.html_succ);
            if (response.headline_failed.length > 5) {
              $('#modal-productAdded #modal-title2').html(response.headline_failed);
              $('#modal-productAdded #modal-body2').html(response.html_failed);
            } else {
              $('#modal-productAdded #modal-header2').remove();
              $('#modal-productAdded #modal-body2').remove();
            }
          } else {
            $('#modal-productAdded #modal-title').html(response.headline_failed);
            $('#modal-productAdded #modal-body').html(response.html_failed);
            $('#modal-productAdded #modal-header2').remove();
            $('#modal-productAdded #modal-body2').remove();
          }
          // these 2 cases are for an erx article only #Sonderlocke
          if (response._apn_addtobasket_overlay_title_cart.length > 0) {
            $('#_apn_addtobasket_overlay_title_cart').text(response._apn_addtobasket_overlay_title_cart);
          }
          if (response._apn_addtobasket_overlay_title_dismiss.length > 0) {
            $('#_add2cart_button_1').removeClass('btn-inverse');
            $('#_add2cart_button_2').addClass('btn-inverse');
            $('#_apn_addtobasket_overlay_title_dismiss').text(response._apn_addtobasket_overlay_title_dismiss);
          }

          $('#modal-productAdded').modal();
        });
      }
    },
    remove: function (id) {
      let self = this;
      $.ajax({
        url: '/rpc.php?action=removefrombasket',
        data: { abskt: id },
        method: 'POST',
      }).done(function (response) {
        self.update();
        self.showMessages(response.messages);
      });
    },
    update: function () {
      if (!this.getPopoverElem() || !this.getPopoverElem().length) {
        return; // avoid AJAX call if the target is not set
      }
      let self = this;
      $.ajax({
        url: '/rpc.php',
        data: { action: 'ajaxbasket' },
      }).done(function (response) {
        if (_DEBUG) console.log('++++++LiveBasketLoaded-->:');
        if (_DEBUG) console.log(response);

        live_basket = response.items;

        /* Remove every possibly add2Cart Reco of an product that is in the basket */
        for (let cartitem of response.items) {
          // You can use `let` instead of `const` if you like
          $('._add2cart-reco_pzn_' + cartitem.pro_pzn).remove();
        }
        $('.apn-add2cart-reco').show(); // If we are shure there is no, we can try to show the add2cart reco

        let count = response.count || 0;
        self.setCount(count);
        self.popoverCallback(response);
      });
    },
    setupPopover: function (response) {
      if (response.count == 0) {
        return; // nothing to do
      }
      setupCartPopover(this.getPopoverElem(), response.popover, this.cartTemplate);
      this.popoverCallback = this.updatePopover;
    },
    updatePopover: function (response) {
      this.getPopoverElem().popover('dispose');
      if (response.count == 0) {
        // no popover for empty carts
        return;
      }
      // workaround: there is no obvious way to change the html content of a popover
      setupCartPopover(this.getPopoverElem(), response.popover, this.cartTemplate);
    },
    getPopoverElem: function () {
      return this.popoverElem;
    },
    setCount: function (count) {
      $('#header-basket-item-count').html(count).removeClass('apn-hidden');
    },
    showMessages: function (messages) {
      if (!messages) {
        return;
      }
      for (let i = 0, length = messages.length; i < length; i++) {
        let msgData = messages[i];
        aponeo.addNotification(msgData[0], msgData[1]);
      }
    },
  };

  $(document).ready(function () {
    //-----------------------------------
    // ### Aponeo AddressSuggest ###
    //------------------------------------
    // safe to use the function, not on every page loeaded
    if (typeof useAddressSuggestDefault !== 'undefined' && useAddressSuggestDefault) {
      $('input#cus_city').jsonSuggest({
        url: '/rpc.php?action=plzort',
        maxResults: 12,
        minCharacters: 0,
        depend_formvalue: 'cus_zip',
        depend_formvalue2: 'cus_country',
      });
      $('input#cus_street').jsonSuggest({
        url: '/rpc.php?action=plzstr',
        maxResults: 12,
        minCharacters: 1,
        depend_formvalue: 'cus_zip',
        depend_formvalue2: 'cus_country',
      });
    }
  });

  //-----------------------------------
  // ### Aponeo Show/Hide Tables ###
  // TODO: Figure out if this can be removed
  //------------------------------------
  $(document).ready(function () {
    $('.js-open-table').on('click touch', function () {
      let target = $(this).data('table');
      if ($(target).hasClass('closed')) {
        $(this).removeClass('closed');
        $(target).removeClass('closed');
      } else {
        $(this).addClass('closed');
        $(target).addClass('closed');
        $('html, body').animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          300,
        );
      }
    });
  });

  //-----------------------------------
  // ### customized used in basket for recipe only
  //------------------------------------
  $(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  let popOverHystereseDelay = 100;
  //-----------------------------------
  // ### Aponeo Account Popover ###
  //------------------------------------
  function setupAccountPopover(elem, content) {
    let accountTemplate =
      '<div class="popover account-popover d-none d-lg-block" role="tooltip"><div class="arrow"></div><h3 class="popover-header text-center apn-text-16 font-secondary font-weight-bold py-2"></h3><div class="popover-body"></div></div>';

    function hideAccountPopover() {
      // there is a small gap between elem and popover, that's why there is a small timeout before popover hide
      setTimeout(function () {
        let elemIsHovered = $(elem).is(':hover'),
          popOverIsHovered = $('.popover.account-popover:hover').length > 0;

        // only hide content when both are not hovered
        if (!elemIsHovered && !popOverIsHovered) {
          elem.popover('hide');
        }
      }, popOverHystereseDelay);
    }

    elem
      .popover({
        container: 'body',
        html: true,
        content: content,
        template: accountTemplate,
        placement: 'bottom',
        trigger: 'manual',
        delay: {
          show: 0,
          hide: 0,
        },
      })
      .on('show.bs.popover', function () {
        $(content).removeClass('d-none');
      })
      .on('mouseenter', function () {
        elem.popover('show');
      })
      .on('mouseleave', function () {
        hideAccountPopover();
      });

    $('body').on('mouseleave', '.popover.account-popover', function (e) {
      if (!$(e.target).is('.form-control')) {
        hideAccountPopover();
      }
    });

    // clicks in the popover stay in the popover
    $('body').on('click', '.popover.account-popover', function (e) {
      e.stopPropagation();
    });
  }

  if (header.find('.account-popover-content').length) {
    setupAccountPopover(header.find('.header-account'), $('.account-popover-content'));
  }

  //-----------------------------------
  // ### Aponeo Cart Popover ###
  //------------------------------------

  // function is shared between the prototype and production site
  function setupCartPopover(elem, content, template) {
    function hideCartPopover() {
      // there is a small gap between elem and popover, that's why there is a small timeout before popover hide
      setTimeout(function () {
        let elemIsHovered = $(elem).is(':hover'),
          popOverIsHovered = $('.popover.cart-popover:hover').length > 0;

        // only hide content when both are not hovered
        if (!elemIsHovered && !popOverIsHovered) {
          elem.popover('hide');
        }
      }, popOverHystereseDelay);
    }

    elem
      .popover({
        container: 'body',
        html: true,
        template: template,
        content: content,
        placement: 'bottom',
        title: 'Ihr Warenkorb',
        trigger: 'focus',
        delay: {
          show: 0,
          hide: 0,
        },
      })
      .on('mouseenter', function () {
        $(this).trigger('focus');
      })
      .on('mouseleave', function () {
        hideCartPopover();
      });

    $('body').on('mouseleave', '.popover.cart-popover', function (e) {
      hideCartPopover();
    });
  }

  if (header.find('.cart-popover-content').length) {
    // prototype functionality:
    setupCartPopover(header.find('.header-cart'), $('.cart-popover-content'), cartTemplate);
    $('#header-basket-item-count').html(2).removeClass('apn-hidden');
  } else {
    win.apnCart = new Cart(header.find('.header-cart'));
  }

  //-----------------------------------
  // ### Aponeo Service Popover ###
  //------------------------------------
  function setupServicePopover(elem, content) {
    let serviceTemplate =
      '<div class="popover apn-service-popover d-none d-lg-block" role="tooltip"><div class="arrow"></div><h3 class="popover-header text-center apn-text-16 font-secondary font-weight-bold py-2"></h3><div class="popover-body"></div></div>';

    function hideServicePopover() {
      // there is a small gap between elem and popover, that's why there is a small timeout before popover hide
      setTimeout(function () {
        let elemIsHovered = $(elem).is(':hover'),
          popOverIsHovered = $('.popover.apn-service-popover:hover').length > 0;

        // only hide content when both are not hovered
        if (!elemIsHovered && !popOverIsHovered) {
          elem.popover('hide');
        }
      }, popOverHystereseDelay);
    }

    elem
      .popover({
        container: 'body',
        html: true,
        content: content,
        template: serviceTemplate,
        placement: 'bottom',
        trigger: 'manual',
        delay: {
          show: 0,
          hide: 0,
        },
      })
      .on('show.bs.popover', function () {
        $(content).removeClass('d-none');
      })
      .on('mouseenter', function () {
        elem.popover('show');
      })
      .on('mouseleave', function () {
        hideServicePopover();
      });

    $('body').on('mouseleave', '.popover.apn-service-popover', function (e) {
      hideServicePopover();
    });
  }

  if (header.find('.apn-service-popover-content').length) {
    setupServicePopover(header.find('.apn-header-service'), $('.apn-service-popover-content'));
  }

  //--- Interktionscheck

  if (aponeo.isMobile()) {
    $('.apn-is-mobile').css('display', 'block');
    $('.apn-is-not-mobile').css('display', 'none');
  } else {
    $('.apn-is-mobile').css('display', 'none');
    $('.apn-is-not-mobile').css('display', 'block');
  }
})(jQuery, window);

/* harmony default export */ var modules_aponeo = (aponeo);

;// ./build/shared/js/modules/backToTopFixed.js
__webpack_require__.dn(backToTopFixed);
/* harmony default export */ function backToTopFixed() {
  const $backToTopFixed = $('.back-to-top-fixed');
  let lastScrollPosition = 0;

  if ($backToTopFixed.length) {
    $(window).scroll(toggleButton);
    $backToTopFixed.click(function () {
      $('html, body').animate({ scrollTop: 0 }, 500);
      return false;
    });
  }

  function toggleButton() {
    if ($(window).scrollTop() > $(window).innerHeight() && lastScrollPosition > $(window).scrollTop()) {
      $backToTopFixed.addClass('back-to-top-fixed--visible');
    } else {
      $backToTopFixed.removeClass('back-to-top-fixed--visible');
    }
    lastScrollPosition = $(window).scrollTop();
  }
}

;// ./build/shared/js/modules/basket.js


const basket_addToBasketFunctions = () => {
  $('.btn-add-to-cart:not(.initialized)')
    .click((event) => {
      event.preventDefault();
      $('#modal-productAdded').modal('hide'); // Remove a poosibly existing Add2Cart Modal

      const helperElement = $(event.currentTarget).parent().children('input[name="abskt"]');
      const id = helperElement.val();
      let amount = parseInt($('#amnt_' + id).val());

      if (amount > 0) {
        // on pdp we will use the input amount
      } else {
        amount = 1;
      }

      $('._add2cart-reco_id_' + id).remove(); // Remove add2Cart-Reco in case of adding the same product
      const helperUpsellingAction = $(event.currentTarget).parent().parent().parent().attr('data-dl-action');
      const helperUpsellingList = $(event.currentTarget)
        .parent()
        .parent()
        .parent()
        .attr('data-dl-addtocartupsellinglist');

      // console.log('##############################');
      // console.log(helperElement);
      // console.log('##############################');

      if (helperUpsellingAction) {
        // WEB-2737 special case to close the default modal and reopen for success modal
        // When this process runs very fast the new modal will not been show
        showLoadingScreen();
        let timeout;
        let delay = 1000;
        timeout = window.setTimeout(() => {
          console.log('[paused] Adding item with internal ID ' + id + ' and amount ' + amount + ' to basket.');
          apnCart.add(id, amount);
        }, delay);
      } else {
        console.log('Adding item with internal ID ' + id + ' and amount ' + amount + ' to basket.');
        apnCart.add(id, amount);
      }

      // Push add to basket event to GTM data layer WEB-2012
      if (window['google_tag_manager']) {
        if (_DEBUG) console.log('--------------Check Mengen -------------------------------');
        // Fix WEB-3751 ggf Mengenüberschreitung
        var amount_incart = 0;
        let maxsales = helperElement.data('amount-allowed');

        if (_DEBUG) {
          console.log('ID: ' + id);
          console.log('Currently in cart:');
          console.log(live_basket);
        }

        for (let cartitem of live_basket) {
          if (cartitem['PKpro_id'] == id) {
            if (_DEBUG) console.log('ID:' + id + ' is allready in cart');
            amount_incart = cartitem['bas_amount'];
          }
        }

        if (_DEBUG) {
          console.log('amount_incart: ' + amount_incart);
          console.log('submitted amount: ' + amount);
          console.log('maxsales: ' + maxsales);
        }

        if (parseInt(amount_incart) + parseInt(amount) > parseInt(maxsales)) {
          if (_DEBUG) console.log('Mengenüberschreitung!!!');
          //amount = maxsales;
          amount = parseInt(maxsales) - parseInt(amount_incart);
          if (_DEBUG) console.log('force amount to:' + amount);
        } else {
          if (_DEBUG) console.log('amount of:' + amount + ' ok');
        }

        // --------------Eof fix Mengen ------------------------------

        window.dataLayer = window.dataLayer || [];

        let pageType = 'undefined pageType';
        if (
          typeof window['google_tag_manager']['GTM-5GNVZ2M'] === 'object' &&
          typeof window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer === 'object'
        ) {
          pageType = window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer.get('pageType');
        }

        let action = 'undefined (' + pageType + ')';
        let _netprice = parseFloat(
          (
            (parseFloat(helperElement.data('gross-price')) / (100 + parseFloat(helperElement.data('tax')))) *
            100
          ).toFixed(2),
        );

        let basketChange = {
          brand: helperElement.data('brand'),
          grossPrice: helperElement.data('gross-price'),
          netPrice: _netprice,
          internalId: helperElement.data('internal-id'),
          name: helperElement.data('name'),
          pzn: String(helperElement.data('pzn')),
          quantity: amount,
          manufacturer: helperElement.data('manufacturer'),
          manufacturerid: helperElement.data('manufacturerid'),
        };

        if (!pageType) {
          console.log('pageType undefined');
          basketChange.action = 'undefined pagetype Add to Basket';
        } else if (pageType === 'productdetail') {
          basketChange.action = 'PDP Item Add to Basket';
        } else if (pageType === 'category' || pageType.indexOf('category_subpage') !== -1) {
          basketChange.action = 'Category Page Item Add to Basket';
        } else if (pageType === 'search') {
          basketChange.action = 'Search Results Item Add to Basket';
        } else if (pageType === 'service_wechselwirkungscheck') {
          basketChange.action = 'Interaction Check Item Add to Basket';
        } else if (helperUpsellingAction) {
          basketChange.action = helperUpsellingAction;
          basketChange.addToCartUpsellingList = 'Add to Cart "' + helperUpsellingList + '"';
        }

        if (_DEBUG) {
          console.log('Event:addToBasket,basketChange:');
          console.log(basketChange);
        }

        // Ideally we should have passed the product list name and position here (WEB-2030),
        // but the shop cannot support this with acceptable effort. Therefore this data gets added in GTM.
        dataLayer.push({
          event: 'addToBasket',
          basketChange: basketChange,
        });
      }
    })
    .addClass('initialized');
};

/* harmony default export */ var basket = (() => {
  const $productAmountCounter = $('.js_product-amount');

  if ($productAmountCounter.length) {
    $productAmountCounter.each((i, elem) => {
      let timeout;
      const delay = 500;
      let $amount = $('._input_autosubmit', elem);
      $('.btn', elem).on('click touch', function (event) {
        if ($(event.currentTarget).hasClass('--delete')) {
          $('.cart-product-list__item__remove', $(event.currentTarget).parents('.cart-product-list__item')).trigger(
            'click',
          );
          return;
        }

        let currentAmount = parseInt($amount.val());
        if ($(event.currentTarget).hasClass('--increase')) {
          $amount.val(currentAmount + 1);
        } else if ($(event.currentTarget).hasClass('--decrease')) {
          $amount.val(Math.max(currentAmount - 1, 1));
        }

        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
          $amount.trigger('change');
        }, delay);
      });
    });

    // Input for amount of items
    $('._input_autosubmit').change(function () {
      if (_DEBUG) {
        console.log(
          'Changing basket item amount from ' + $(this).data('original-amount') + ' to ' + $(this).val() + '.',
        );
      }
      // Try a simple submit, no matter what tracking is
      // Firefox fix WEB-2339
      $('#basket').submit();

      if (_DEBUG) console.log('-------------- Check Mengen Basketpage-------------------------------');
      // at this page isn´t submitted additional amount!
      // its the new amount in basket!
      var amount_incart = 0;
      let maxsales = $(this).data('amount-allowed');
      let amount = $(this).val();
      let id = $(this).data('internal-id');

      if (_DEBUG) {
        console.log('ID: ' + id);
        console.log('Currently in cart:');
        console.log(live_basket);
      }

      for (let cartitem of live_basket) {
        if (cartitem['PKpro_id'] == id) {
          if (_DEBUG) console.log('ID:' + id + ' is allready in cart');
          amount_incart = cartitem['bas_amount'];
        }
      }

      if (_DEBUG) {
        console.log('amount_incart: ' + amount_incart);
        console.log('submitted new amount: ' + amount);
        console.log('maxsales: ' + maxsales);
      }

      if (parseInt(amount) > parseInt(maxsales)) {
        if (_DEBUG) console.log('Mengenüberschreitung!!!');
        amount = maxsales;
        console.log('force amount to:' + amount);
      } else {
        if (_DEBUG) console.log('new amount of:' + amount + ' ok');
      }
      // --------------Eof fix Mengen ------------------------------

      // Push event to GTM data layer
      if (window['google_tag_manager'] && $(this).data('original-amount') !== $(this).val()) {
        window.dataLayer = window.dataLayer || [];

        let _netprice = parseFloat(
          ((parseFloat($(this).data('gross-price')) / (100 + parseFloat($(this).data('tax')))) * 100).toFixed(2),
        );

        dataLayer.push({
          event: $(this).data('original-amount') > $(this).val() ? 'removeFromBasket' : 'addToBasket',
          basketChange: {
            action: 'Basket Page Item Amount Change',
            brand: $(this).data('brand'),
            grossPrice: $(this).data('gross-price'),
            netPrice: _netprice,
            internalId: $(this).data('internal-id'),
            name: $(this).data('name'),
            pzn: String($(this).data('pzn')),
            quantity: Math.abs($(this).data('original-amount') - amount),
            manufacturer: $(this).data('manufacturer'),
            manufacturerid: $(this).data('manufacturerid'),
          },
        });
      }
    });

    // Warenkorb X-Icon
    $('.cart-product-list__item__remove').on('click touch', function () {
      $($(this).data('hide')).hide(700);
      if (_DEBUG) {
        console.log('Removing basket item.', this);
      }
      $('#basket-amount_' + $(this).data('removeitem')).val(0);

      // Try a simple submit, no matter what tracking is
      // Firefox fix WEB-2339
      $('#basket').submit();

      // Push event to GTM data layer
      if (window['google_tag_manager'] && $(this).data('prev') !== $(this).val()) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'removeFromBasket',
          basketChange: {
            action: 'Basket Page Item Removal',
            brand: $(this).data('brand'),
            grossPrice: $(this).data('gross-price'),
            internalId: $(this).data('internal-id'),
            name: $(this).data('name'),
            pzn: $(this).data('pzn'),
            quantity: $(this).data('original-amount'),
          },
        });
      }
    });
    // special buttons with remove function for special products
    $('._js_item__remove').on('click touch', function () {
      $($(this).data('hide')).hide(700);
      if (_DEBUG) {
        console.log('Removing basket item.', this);
      }
      $('#basket-amount_' + $(this).data('removeitem')).val(0);

      // Try a simple submit, no matter what tracking is
      // Firefox fix WEB-2339
      $('#basket').submit();

      // Push event to GTM data layer
      if (window['google_tag_manager'] && $(this).data('prev') !== $(this).val()) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'removeFromBasket',
          basketChange: {
            action: 'Basket Page Item Removal',
            brand: $(this).data('brand'),
            grossPrice: $(this).data('gross-price'),
            internalId: $(this).data('internal-id'),
            name: $(this).data('name'),
            pzn: $(this).data('pzn'),
            quantity: $(this).data('original-amount'),
          },
        });
      }
    });
  }
});
__webpack_require__.dn(basket);

;// ./build/shared/js/modules/applepay.js
/**
 * Load Apple Pay SDK from Apple's CDN
 * Returns a promise that resolves when SDK is loaded or if it's already available
 * @returns {Promise<void>}
 */
function loadApplePaySDK() {
  return new Promise((resolve) => {
    if (window.ApplePaySession) {
      return resolve();
    }

    const script = document.createElement('script');
    script.src = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
    script.onload = () => resolve();
    script.onerror = () => {
      console.warn('Failed to load Apple Pay SDK from CDN');
      resolve();
    };

    document.head.appendChild(script);
  });
}

/**
 * Check if Apple Pay is available on this device/browser
 * Loads the SDK on demand when checking availability
 * @returns {boolean} True if Apple Pay can be used
 */
async function checkApplePayAvailability() {
  // 1. Basic User Agent Check to filter out non-Apple platforms early
  // TODO: This is technically wrong, however, because Apple Pay is also supported on Windows, Android, etc.
  const userAgent = navigator.userAgent.toLowerCase();
  const isAppleOS = userAgent.includes('macintosh') || userAgent.includes('iphone') || userAgent.includes('ipad');

  if (!isAppleOS) {
    return false;
  }

  // Load SDK if interface not already available
  await loadApplePaySDK();

  // 2. Check if Apple Pay JS API is available in the browser
  if (!window.ApplePaySession) {
    return false;
  }

  // 3. Check if the hardware capability check method exists
  if (typeof window.ApplePaySession.canMakePayments !== 'function') {
    return false;
  }

  try {
    // 4. Query the native hardware check
    // TODO: Implement full availability check via ApplePaySession.applePayCapabilities(),
    // but this requires the per-vendor merchant identifier. Just use hardware check for now.
    const canMakePayments = window.ApplePaySession.canMakePayments();
    return !!canMakePayments;
  } catch (error) {
    console.error('Apple Pay availability check failed:', error);
    return false;
  }
}

;// ./build/shared/js/modules/checkout.js



const ShowHide_bx_tel = () => {
  let ShippingMethodActive = $('input[name=shipping]:checked').val();
  if (
    ShippingMethodActive === '10|1' ||
    ShippingMethodActive === '10|2' ||
    ShippingMethodActive === '11|1' ||
    ShippingMethodActive === '11|2' ||
    ShippingMethodActive === '46|3'
  ) {
    $('#bx-tel-block').show(200);
  } else {
    $('#bx-tel-block').hide(200);
  }
};

/* harmony default export */ var checkout = (() => {
  /*
   * when closing address forms, scroll to matching header
   */
  $(document).ready(($) => {
    //-----------------------------------
    // ### Landingpage Rattz-Woche 2019 ###
    //------------------------------------
    if ($('[data-teaser-name="Rabattz Woche 2019 | Header"]').length) {
      $('.apn-page-wrapper').css('background-color', '#000');
      $('footer').css('background-color', '#fff');
      $('.apn-breadcrumb-nav').hide();
      $('.apn-breadcrumb').hide();
    }

    const el = $('.apn-customer-address-list');
    if (el.length) {
      el.on('hide.bs.collapse', (event) => {
        const scrollTarget = $(event.target).prev();
        if (!scrollTarget.isInViewport()) {
          const offset = scrollTarget.offset().top - 15;
          modules_aponeo.scrollTop(offset);
        }
      });
    }

    $('input[name=shipping_calender]').click((event) => {
      // if($('#radio_button').is(':checked')) { alert("it's checked"); }
      let shippingId = $(event.target).attr('data-shipping-id');
      shippingId = shippingId.replace('|', '\\\|');

      $("input[name='shipping']").prop('checked', false); // alle unchecken
      $('#shipping_' + shippingId).prop('checked', true); // die korrekt checken
      ShowHide_bx_tel();
    });

    $('#bx-tel-calender').change(() => {
      $('#bx-tel').val($('#bx-tel-calender').val());
      ShowHide_bx_tel();
    });

    $("input[name='shipping']").change(() => {
      ShowHide_bx_tel();
    });

    const $checkoutShippingMethodForm = $("form[name='checkout_shipping_method']");
    $checkoutShippingMethodForm.submit(() => {
      let ShippingMethodActive = $('input[name=shipping]:checked').val();
      if (
        ShippingMethodActive === '10|1' ||
        ShippingMethodActive === '10|2' ||
        ShippingMethodActive === '11|1' ||
        ShippingMethodActive === '11|2' ||
        ShippingMethodActive === '46|3'
      ) {
        const $bxTel = $('#bx-tel');
        if ($bxTel.val().length < 6) {
          $bxTel.hide(200);
          $bxTel.show(200);
          $bxTel.css({ border: '1px solid #fe2550' });
          return false;
        }
      }
    });

    if ($checkoutShippingMethodForm.length > 0) {
      ShowHide_bx_tel();
    }

    // checkout shipping calendar
    const $modalCheckoutCalendar = $('.modal-checkout-calendar');
    if ($modalCheckoutCalendar.length) {
      const deliveryTypeElement = $('#delivery-type');
      $modalCheckoutCalendar.find('input[type="radio"]').on('change', (event) => {
        deliveryTypeElement.text($(event.target).data('name'));
        $modalCheckoutCalendar.find('.collapse').collapse('hide');
        if ($(event.target).data('target')) {
          $($(event.target).data('target')).collapse('show');
        }
      });
    }

    // hide any open payment panel when another radio is selected
    $(document).on('change', '#payment-method input[type="radio"]', function () {
      var $target = $($(this).data('target'));
      $('#payment-method .collapse.show').not($target).collapse('hide');
    });

    // Mobile Pay: detect Apple Pay support and set data attributes for CSS visibility
    const mobilePay = document.querySelector('[data-mobile-pay]');
    if (mobilePay) {
      (async () => {
        const hasApplePaySupport = await checkApplePayAvailability();
        mobilePay.dataset.applePay = hasApplePaySupport ? 'true' : 'false';
      })();
    }
  });

  const showInvoiceButton = (id) => {
    $.ajax({
      type: 'GET',
      url: '/kundenbereich/hasinvoice/' + id,
    })
      .fail(() => {
        console.log(id + 'error');
      })
      .done((result) => {
        if (result === '1') {
          $('#_btn-invoice_download_' + id).show(700);
        }
      });
  };
});
__webpack_require__.dn(checkout);

;// ./build/shared/js/modules/contactForm.js
/* harmony default export */ var contactForm = (() => {
  if ($('#KontaktEmpfaenger').length) {
    (($) => {
      $('#KontaktEmpfaenger').change(function () {
        $('.topics').hide();
        $('.topic').prop('checked', false);

        $('#topics_' + $(this).val()).show();
        // $("#rowKontaktBestellKundenNr").hide();
      });

      $("input[name$='topic']").click(function () {
        var showfield = $(this).attr('data-showField');

        if (showfield == '0') $('#rowKontaktBestellKundenNr').hide();
        else $('#rowKontaktBestellKundenNr').show();
      });

      $('button:reset').click(function () {
        $('.topics').hide();
        sel = document.getElementById('KontaktEmpfaenger');
        sel.selectedIndex = 0;
        return false;
      });
    })(jQuery);
  }

  if ($('._contactfom_sended').length) {
    $('._hidewhensended').hide();
  }
});
__webpack_require__.dn(contactForm);

;// ./build/shared/js/modules/coupons.js
__webpack_require__.dn(coupons);
/* harmony default export */ function coupons() {
  let discountsActive = [];

  /**
   * Set the cursor style for the body element
   * @param {string} cursorStyle - the CSS cursor style to set (e.g., 'wait', 'default')
   */
  function setCursor(cursorStyle) {
    $('body').css('cursor', cursorStyle);
  }

  /**
   * Check if a coupon code is currently active
   * @param {string} couponcode
   * @returns {boolean}
   */
  function isCouponActive(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    return discountsActive.some((d) => d.code.toUpperCase() === normalizedCode);
  }

  /**
   * Set a Coupon-Checkbox to checked and disabled
   * @param {string} couponcode
   */
  function checkCouponActivation(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    const couponClass = '._coupon_activation_' + normalizedCode;
    const $checkbox = $(couponClass);

    console.log(`show active coupon: ${couponClass}`);

    $checkbox.prop('checked', true);
    //$checkbox.prop('disabled', true);
    $checkbox.parent().addClass('coupon-checkbox--is-active');

    // in checkout it should be shown - not activate in checkout
    $(couponClass).show();
  }

  /**
   * Set a Coupon-Checkbox to unchecked and enabled
   * (if activation failed)
   * @param {string} couponcode
   */
  function uncheckCouponActivation(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    console.log(`un-show active coupon: ._coupon_activation_${normalizedCode}`);

    const $checkbox = $('._coupon_activation_' + normalizedCode);
    $checkbox.prop('checked', false);
    //$checkbox.prop('disabled', false);
    $checkbox.parent().removeClass('coupon-checkbox--is-active');
  }

  /**
   * Hide inactive coupons checkboxes
   * Currently only used on the checkout page
   * @param {Array} discountsActive
   */
  function hideInactiveCoupons(discountsActive) {
    const activeCodeClasses = discountsActive.map((d) => '_coupon_activation_' + d.code.toUpperCase());

    $('._coupon_activation').each(function () {
      const $checkbox = $(this);
      const isActive = activeCodeClasses.some((codeClass) => $checkbox.hasClass(codeClass));

      if (!isActive) {
        $checkbox.parents('.coupon-activation-banner').hide();
      }
    });
  }

  /**
   * Send a coupon code for activation
   * @param {string} couponcode
   */
  function activateCoupon(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    console.log(`try to activate coupon: ${normalizedCode}`);

    $.ajax({
      url: '/rpc.php?action=addcode',
      method: 'POST',
      data: { voucher: normalizedCode },
      success: function (response) {
        console.log(`activation success: ${normalizedCode}`);

        if (response?.success === 1) {
          // Erfolg
          if (!isCouponActive(normalizedCode)) {
            discountsActive.push({ code: normalizedCode });
            console.log('added to active discounts:', normalizedCode);
          }
        } else {
          // Fehler oder unbekannter Zustand
          console.warn(`activation not successful: ${normalizedCode}`);
          uncheckCouponActivation(normalizedCode);
        }
      },
      error: function (xhr, status, error) {
        console.warn(`activation failed: ${normalizedCode}`);
        console.log('Fehler beim Request:', error);
        uncheckCouponActivation(normalizedCode);
      },
      complete: function (xhr, status) {
        console.log('AJAX complete');
        console.log('Status:', status);
        console.log('Response:', xhr.responseText);

        if (window.location.pathname === '/warenkorb/' || window.location.pathname === '/warenkorb.html') {
          // at page url basket/cart we need a reload to show recalculated the values
          window.location.replace(window.location.pathname + window.location.search);
        }
      },
    });
  }

  /**
   * Send a coupon code for removal
   * @param {string} couponcode
   * @param {boolean} refreshpage - whether to reload the page after removal
   */
  function removeCoupon(couponcode, refreshpage = false, coupontype = 'coupon') {
    setCursor('wait');

    console.log(`try to remove coupontype ${coupontype}: ${couponcode}`);

    $.ajax({
      url: `/rpc.php?action=removefrombasket&${coupontype}=${couponcode}`,
      method: 'GET',
      success: function (response) {
        console.log(`removal success: ${couponcode}`);
        uncheckCouponActivation(couponcode);

        const normalizedCode = couponcode.toUpperCase();
        discountsActive = discountsActive.filter((d) => d.code.toUpperCase() !== normalizedCode);
        console.log('removed from active discounts:', normalizedCode);
      },
      error: function (xhr, status, error) {
        console.warn(`removal failed: ${couponcode}`);
        console.log('Fehler beim Request:', error);
      },
      complete: function (xhr, status) {
        console.log('AJAX complete');
        console.log('Status:', status);
        console.log('Response:', xhr.responseText);

        setCursor('default');
        if (
          refreshpage ||
          window.location.pathname === '/warenkorb/' ||
          window.location.pathname === '/warenkorb.html'
        ) {
          // at page url basket/cart we need a reload to show recalculated the values
          window.location.reload(true);
        }
      },
    });
  }

  /**
   * Handler for coupon activation change events
   */
  function handleCouponChange() {
    const code = this.value;

    if (this.checked) {
      console.log('aktiviert:', code);
      checkCouponActivation(code);
      activateCoupon(code);
    } else {
      console.log('deaktiviert:', code);
      removeCoupon(code);
    }
  }

  /**
   * Attach change event listener to coupon activation sliders
   */
  function setupCouponChangeListeners() {
    $('._coupon_activation').on('change', handleCouponChange);
  }

  /**
   * Setup MutationObserver to watch for dynamically loaded product list elements
   */
  function setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-loaded' &&
          mutation.target.classList.contains('productlist-combi_element')
        ) {
          const $element = $(mutation.target);

          if ($element.attr('data-loaded') === 'true') {
            $element.find('._coupon_activation').on('change', handleCouponChange);
            $element.find('._coupon_activation').each(function () {
              const code = $(this).val();
              if (code && isCouponActive(code)) {
                checkCouponActivation(code);
              }
            });
          }
        }
      });
    });

    const productListElements = document.querySelectorAll('.productlist-combi_element');
    const observerConfig = {
      attributes: true,
      attributeFilter: ['data-loaded'],
      subtree: false,
    };

    productListElements.forEach((element) => {
      observer.observe(element, observerConfig);
    });

    console.log(`Observing ${productListElements.length} product list elements for changes`);
  }

  /**
   * Initialize the coupon module by checking active discounts and setting up event listeners
   */
  function init() {
    discountsActive = window.dataLayer?.[0]?.['discounts'] || [];

    if (discountsActive) {
      console.log('active discounts:', discountsActive);

      discountsActive.forEach((discountActive, index) => {
        console.log(index, discountActive);
        checkCouponActivation(discountActive.code);
      });

      const isCheckout = window.location.pathname === '/checkout/3/'; // checkout payment
      const isPaypalCheckout = window.location.pathname === '/expresscheckout/'; // one-page express checkout
      const isCardCheckout = window.location.pathname === '/checkout/'; // checkout error-cart
      if (isCheckout || isPaypalCheckout || isCardCheckout) {
        hideInactiveCoupons(discountsActive);
      }
    } else {
      console.log('active discounts: keine');
    }

    setupCouponChangeListeners();
    setupMutationObserver();

    $(document).on('click', '._cart-coupon-remove', function () {
      const $button = $(this);
      const couponCode = $button.data('removeitem');
      const couponType = couponCode.includes('€') ? 'coupon_apocash' : 'coupon';
      const refreshpage = $button.data('refreshpage');

      if (!couponCode) {
        console.error('No coupon code found in data-removeitem attribute');
        return false;
      }

      $button.closest('._cart-coupon').hide(400);
      removeCoupon(couponCode, refreshpage == 1, couponType);

      return false;
    });
  }

  init();
}

;// ./build/shared/js/modules/customer_area.js
/* harmony default export */ var customer_area = (() => {
  $(function () {
    // bind change event to select
    $('#invoice_period_select').on('change', function () {
      var url = $(this).val(); // get selected value
      if (url) {
        // require a URL
        window.location = url; // redirect
      }
      return false;
    });
  });

  // apocash deactivate tag manager WEB-5058
  const modalApocashDeactivationSumbit = $('#ds5_modal_deactivate').find('form');
  modalApocashDeactivationSumbit.on('submit', function () {
    window.dataLayer.push({
      event: 'apo_cash_deactivation',
      location: 'customer_account',
      customer_id: cusid,
    });
  });
});
__webpack_require__.dn(customer_area);

;// ./build/shared/js/modules/detailLink.js
const addDetailLinkFunctions = () => {
  $('._JsDetailLink:not(._js_link_initialized)')
    .click((event) => {
      const jsLinkUrl = $(event.currentTarget).data('url');

      console.log('replacing href:' + jsLinkUrl);
      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl,
          jsLinkInnerText: event.target.innerText ? event.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: () => {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
      return false;
    })
    .addClass('_js_link_initialized');

  // WEB-2652 tracking click on the product/image to get the pdp
  $('._JsEventLink:not(._js_event_initialized)')
    .click((event) => {
      const helperUpselling = $(event.currentTarget);
      const action = $(event.currentTarget).data('dl-event');
      const pzn = $(event.currentTarget).data('dl-pzn');
      const basePrice = $(event.currentTarget).data('dl-baseprice');
      const grossPrice = $(event.currentTarget).data('dl-grossprice');
      const name = $(event.currentTarget).data('dl-name');

      const UpsellingList = $(event.currentTarget).parent().parent().attr('data-dl-addtocartupsellinglist');

      console.log('found action for dl:' + helperUpselling.data('dl-event'));
      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: action,
          addToCartUpsellingList: 'Add to Cart "' + UpsellingList + '"',
          addToCartUpsellingProduct: {
            grossPrice: grossPrice,
            basePrice: basePrice,
            name: name,
            pzn: pzn,
          },
        });
      }

      return false;
    })
    .addClass('_js_event_initialized');
};

;// ./build/shared/js/modules/fetchProductDetail.js


/**
 * Fetches product detail data (e.g. tier prices, apoCash) from the backend.
 * The backend handles shop-specific features gracefully (e.g. apoCash).
 *
 * @param {number|string} productId  - The product ID
 * @param {number|string} amount     - The requested quantity
 * @param {AbortSignal} signal       - Optional AbortSignal to cancel the request
 * @returns {Promise<Object>}        - Promise that resolves with the parsed JSON result
 */
async function fetchProductDetail(productId, amount, signal) {
  if (_DEBUG) console.log('Fetching:', productId, amount);

  try {
    const params = new URLSearchParams({ action: 'fetch-product-detail', id: productId, amnt: amount });
    const response = await fetch(`/rpc.php?${params}`, { method: 'GET', signal });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    return await response.json();
  } catch (error) {
    if (error.name !== 'AbortError') console.error('fetchProductDetail failed:', error);
    throw error;
  }
}

;// ./build/shared/js/modules/filterSort.js
/* harmony default export */ var filterSort = (() => {
  if ($('#dropdown-sort').length) {
    (($) => {
      $('#dropdown-sort').on('click', function () {
        $('#dropdown-content-sort').slideToggle('slow');
      });
    })(jQuery);
  }
});
__webpack_require__.dn(filterSort);

;// ./build/shared/js/modules/form-validation.js


/* harmony default export */ var form_validation = (() => {
  const $form = $('.js-prevalidate-form');

  if (!$form.length) {
    return false;
  }

  const $inputs = $(':input', $form).not(
    ':input[type=button], :input[type=submit], :input[type=reset], :input[type=hidden]',
  );
  $inputs.each(function () {
    $(this).addClass('_prevalidate');
  });

  $('._prevalidate').focusout(function () {
    const $input = $(this);
    const fieldName = $input.attr('name');

    const actionUrl = '/rpc.php?action=formvalidate';
    const formData = {
      required: $input.attr('required') === 'required' ? 1 : 0,
      validate: $input.attr('name'),
      [$input.attr('name')]: $input.val(),
    };

    // try to use all data to validate a field in context
    let formDataTest = {
      required: $input.attr('required') === 'required' ? 1 : 0,
      validate: $input.attr('name'),
      [$input.attr('name')]: $input.val(),
      //depends: $input.dataset.dependson
      depends: $input.attr('data-dependson') === undefined ? null : $input.attr('data-dependson'),
    };

    const $errorDisplay = $input.closest('form').find(`._displaywarning_${fieldName}`);

    // let test = $(':input', $input.closest('form')).not(':input[type=button], :input[type=submit], :input[type=reset], :input[type=hidden]');
    let test = $(':input', $input.closest('form')).not(':input[type=button], :input[type=submit], :input[type=reset]');
    test.each(function () {
      let $fieldname = $(this).attr('name');
      let $fieldvalue = $(this).val();
      formDataTest[$fieldname] = $fieldvalue;
    });

    if (_DEBUG) console.log('***************************');
    if (_DEBUG) console.log(formDataTest);

    $.ajax({
      type: 'POST',
      url: actionUrl,
      data: formDataTest,
      success: (data) => {
        if (data.valid === true) {
          $input.addClass('is-valid');

          if ($input.hasClass('is-invalid')) {
            $input.removeClass('is-invalid');

            if ($errorDisplay.length) {
              $errorDisplay.empty();
            } else {
              $input.next('.feedback-error').remove();
            }
          }
        } else if (data.valid === false) {
          $input.addClass('is-invalid');

          if ($input.hasClass('is-valid')) {
            $input.removeClass('is-valid');
          }

          if ($errorDisplay.length) {
            $errorDisplay.text(data.error_text);
          } else if ($input.next('.feedback-error').length) {
            $input.next('.feedback-error').text(data.error_text);
          } else {
            $input.after(`<p class="feedback-error">${data.error_text}</p>`);
          }
        }
      },
    });
  });
});
__webpack_require__.dn(form_validation);

;// ./build/shared/js/modules/freeShippingProgress.js
/* harmony default export */ var freeShippingProgress = (() => {
  var $freeShippingProgress = $('.js-free-shipping-progress');
  if ($freeShippingProgress) {
    var $freeShippingMessage = $('.free-shipping-progress__message', $freeShippingProgress),
      $freeShippingProgressBar = $('.free-shipping-progress__progress', $freeShippingProgress),
      priceDifferenceUntilFreeShipping = $freeShippingProgress.attr('data-difference'),
      freeShippingMargin = parseFloat($freeShippingProgress.attr('data-free-shipping-margin')) + 0.01,
      percentageOfProgress = ((freeShippingMargin - priceDifferenceUntilFreeShipping) / freeShippingMargin) * 100;

    if (priceDifferenceUntilFreeShipping) {
      // see https://stackoverflow.com/questions/14826143/string-replaceall-is-not-working   - its best to escape the .
      $freeShippingMessage.html(
        'Noch ' +
          (Math.round(priceDifferenceUntilFreeShipping * 100) / 100).toFixed(2).replaceAll('\.', ',') +
          ' €, um versandkostenfrei zu bestellen.',
      );
      $freeShippingProgressBar.css('width', percentageOfProgress + '%');
    } else {
      console.log('priceDifferenceUntilFreeShipping... not available');
    }
  }
});
__webpack_require__.dn(freeShippingProgress);

;// ./build/shared/js/modules/header.js
let $header = $('.header');
// Adjust scroll position for anchor links due to fixed header
((w) => {
  const shiftWindow = () => {
    if ($header.css('position') === 'fixed') {
      const h = -$header.height();
      w.scrollBy(0, h);
    }
  };
  if (w.location.hash) shiftWindow();
  w.addEventListener('hashchange', shiftWindow);
})(window);

// Adjust page top padding according to size of fixed header
const resizeHeader = () => {
  if ($header.css('position') === 'fixed') {
    const offset = $header.height();
    $('main').css('padding-top', offset);
    $('.off-canvas-wrapper').css('top', offset);
  } else {
    $('main').css('padding-top', '');
  }
};

/* harmony default export */ var header = (() => {
  // Observer for resizing the header and main padding if turbo-container is inserted. Inserting the container has caused overlapping between main page content and header content.
  $(document).ready(() => {
    // observer that does something if a mutation happens, ie. the child list has changed - the turbo container is added.
    const headerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        for (i = 0; i < mutation.addedNodes.length; i++) {
          if ($(mutation.addedNodes[i]).hasClass('trboModuleContainer')) {
            setTimeout(() => {
              resizeHeader();
            }, 300);
          }
        }
        // disconnect the observer after container ist inserted and header is resized
        headerObserver.disconnect();
      });
    });
    // Observe the header if the list of child element changes - in checkout there is no such element
    if (document.getElementById('page-header')) {
      headerObserver.observe(document.getElementById('page-header'), {
        childList: true,
      });
    }

    $('form[name="suchformular"]').submit(function (q) {
      console.log(q);
      if ($.trim($("[name='q']").val()) === '') {
        q.preventDefault();
      }
      //
    });
  });
});
__webpack_require__.dn(header);

;// ./build/shared/js/modules/headerNav.js
/* harmony default export */ var headerNav = (() => {
  initHeaderNav();

  function initHeaderNav() {
    const mobileView = window.matchMedia('(max-width: 992px)');
    const touchDeviceInDesktopView =
      window.matchMedia('(min-width: 992px)').matches &&
      ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
    const $headerNav = $('.header-nav');
    const $navItemLinksAll = $('.header-nav__content ul > li > .header-nav__link');
    const $navItemLinksWithCollapse = $('.header-nav__content ul > li > *[data-target]');
    const $navItemLinksWithOnlyTeaserCollapse = $navItemLinksWithCollapse.filter('[data-only-teaser-content]');
    const $navItemLinksWithOnlyMenuListCollapse = $navItemLinksWithCollapse.filter(':not([data-only-teaser-content])');
    const $navContents = $('.header-nav__content');
    const $navContentLvl1 = $('.header-nav__content-lvl-1');
    const $header = $('.header') ? $('.header') : $('.apn-header');
    const $backdrop = $('.backdrop');

    setViewConfig();
    window.onresize = setViewConfig;
    initNavMobile();
    initNavDesktop();

    /**
     * set view specific config
     */
    function setViewConfig() {
      if (mobileView.matches) {
        // close layer on change view
        $navContentLvl1.trigger('mouseleave');
        // remove height. It set for desktop view
        $navContents.filter(':not(.header-nav__content-lvl-1)').height('');
        // remove all _js_link64 class to set mobile view specific to enable click action for fake-link in leaflet.js
        $navItemLinksAll.filter('[data-nav-fake-link]').removeClass('_js_link64');
        $navItemLinksWithOnlyTeaserCollapse.filter('[data-nav-fake-link]').addClass('_js_link64');
        $navItemLinksAll.filter('[data-nav-fake-link]:not([data-target])').addClass('_js_link64');
        // accessibility
        $navItemLinksWithOnlyTeaserCollapse.removeAttr('role');
        $navItemLinksWithOnlyTeaserCollapse.removeAttr('aria-expanded');
      } else {
        // close mobile navi
        $('.js-toggle-off-canvas').removeClass('collapsed');
        $('.js-toggle-off-canvas').attr('aria-expanded', 'false');
        $navContentLvl1.removeClass('show');
        $('body').toggleClass('backdrop-visible');
        // remove height. It set for mobile view
        $navContents.height('');
        $navContents.find('> ul').height('');
        // accessibility
        $navItemLinksWithOnlyTeaserCollapse.attr('role', 'button');
        $navItemLinksWithOnlyTeaserCollapse.attr('aria-expanded', 'false');
        // add class _js_link64 to enable click action for fake-link in leaflet.js
        $navItemLinksAll.filter('[data-nav-fake-link]').addClass('_js_link64');
        //hide backdrop and opened nav desktop
        _toggleBackdropDesktop(false);
        $navContentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
      }
    }

    /**
     * navi mobile view
     */
    function initNavMobile() {
      // switch toogler & show/close navi (level 1)
      $('.js-toggle-off-canvas').on('click touch', function () {
        if (mobileView.matches === false) return;
        $(this).toggleClass('collapsed');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
        $navContentLvl1.toggleClass('show');
        if ($navContentLvl1.hasClass('show')) {
          setNavContentInnerHeight($navContentLvl1);
          $navItemLinksAll.filter('[aria-expanded="true"]').attr('aria-expanded', 'false');
        }
        $('body').toggleClass('backdrop-visible');
        // set height to level 1 nav content (outer height for scroll). + 1px rounding error
        $navContentLvl1.css('height', 'calc(100vh - ' + ($header.outerHeight() - 1) + 'px)');
        $navContentLvl1.scrollTop(0);
      });

      // show level 2 & 3
      $navItemLinksWithOnlyMenuListCollapse.on('click touch', function (e) {
        if (mobileView.matches === false) return;
        const $contentLvlToShow = $($(this).data('target'));
        if ($contentLvlToShow) {
          e.preventDefault();
          // hide all visible content of current level & show selected
          const $currentContent = $(this).closest('.header-nav__content');
          $currentContent.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');

          $(this).attr('aria-expanded', 'true');
          setNavContentInnerHeight($contentLvlToShow);

          $navContentLvl1.scrollTop(0);
          $currentContent.scrollTop(0);
        }
      });

      // close level 1 & 2 & 3
      $headerNav.find('.header-nav__back-link').on('click touch', function () {
        if (mobileView.matches === false) return;
        const $navContent = $(this).closest('.header-nav__content');
        if ($navContent.hasClass('header-nav__content-lvl-1')) {
          // close level 1
          $('.js-toggle-off-canvas').trigger('click');
        } else {
          // close level 2 & 3
          $navContent.siblings('*[aria-expanded="true"]').attr('aria-expanded', 'false');
          setNavContentInnerHeight($navContent.parent().closest('.header-nav__content'));
        }
      });

      /**
       * set height for ul-element in all contents to height of visible nav-content (or window height if smaller) for mobile view to enable scroll
       * use on each change visible nav-content level
       * @param $visibleNavContent
       */
      function setNavContentInnerHeight($visibleNavContent) {
        const $navInnerContents = $('.header-nav__content > ul');
        const $visibleNavInnerContent = $visibleNavContent.find('> ul');
        const naviMaxHeight = $(window).height() - $header.outerHeight();

        $visibleNavInnerContent.height('');
        if (naviMaxHeight < $visibleNavInnerContent.height()) {
          $navInnerContents.height($visibleNavInnerContent.height());
        } else {
          $navInnerContents.height(naviMaxHeight);
        }

        // Set height on the panel container to activate overflow-y: auto scrolling on lvl-2/3
        $visibleNavContent.css('height', 'calc(100vh - ' + ($header.outerHeight() - 1) + 'px)');
      }
    }

    /**
     * navi desktop view
     */
    function initNavDesktop() {
      let navContentShowTimeoutId;
      let navContentShowTimeoutDelay;
      let navContentHideTimeoutId;
      let navContentHideBackdropTimeoutId;
      const navContentHideTimeoutDelay = 300;

      // all level: hide/show nav content on mouseover for desktop and touchstart for mobile
      $navItemLinksAll.on('touchstart mouseover showWithoutDelay', function (e) {
        if (mobileView.matches === true) return;
        navContentShowTimeoutDelay = e.type === 'showWithoutDelay' ? 0 : 300;
        const $navItemLink = $(this);

        clearTimeout(navContentShowTimeoutId);
        if ($navItemLink.hasClass('header-nav__lvl-headline')) return;

        // for desktop touch: prevent a-href request and open level 1(layer).
        if (
          touchDeviceInDesktopView &&
          $navItemLink.data('target') &&
          $navItemLink.data('level') === 1 &&
          e.type === 'touchstart'
        ) {
          e.preventDefault();
          if ($navItemLink.attr('aria-expanded') === 'true') {
            // close layer if opened
            $navContentLvl1.trigger('mouseleave');
            return;
          }
        }

        navContentShowTimeoutId = setTimeout(function () {
          // hide all visible content form this level and down
          $navItemLink
            .closest('.header-nav__content')
            .find('ul > li > *[aria-expanded="true"]')
            .attr('aria-expanded', 'false');

          if ($navItemLink.data('target')) {
            if ($navItemLink.data('level') === 1) {
              // open level-3 content from first link-item with content on open level-2(layer)
              $($navItemLink.data('target'))
                .find('> ul > li > *[aria-expanded="false"]')
                .first()
                .trigger('showWithoutDelay');
            }

            // show nav content
            $navItemLink.attr('aria-expanded', 'true');
            setLayerHeightForSelectedNavLinkItem($navItemLink);
            _toggleBackdropDesktop(true);

            const lazyloadImages = $($navItemLink.data('target')).find('> .header-nav__teaser img.lazyload');
            if (lazyloadImages.length > 0) {
              // repeat set height for lazyload images, because loading change the element height
              onClassChange(lazyloadImages.get(0), function () {
                setLayerHeightForSelectedNavLinkItem($navItemLink);
              });
            }
          }
        }, navContentShowTimeoutDelay);
      });

      // prevent adding following event listeners on mobile
      if (mobileView.matches === true) return;

      // hide all expanded levels on mouseleave of level 1(layer)
      $navContentLvl1.on('mouseleave', function (e) {
        const contentLvl1 = $(this);
        navContentHideTimeoutId = setTimeout(function () {
          contentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
          _toggleBackdropDesktop(false);
        }, navContentShowTimeoutDelay);
      });

      // close backdrop on touch on large mobile devices
      $backdrop.on('touchstart', function (e) {
        $navContentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
        _toggleBackdropDesktop(false);
      });

      // close backdrop and nav content on links without dropdown
      $('.header-nav__content-lvl-1 > ul > li > .header-nav__link:not([aria-haspopup="menu"])').on(
        'mouseenter',
        function (e) {
          const contentLvl1 = $(this);
          navContentHideBackdropTimeoutId = setTimeout(function () {
            contentLvl1.find('> ul > li > *[aria-expanded="true"]').attr('aria-expanded', 'false');
            _toggleBackdropDesktop(false);
          }, navContentShowTimeoutDelay);
        },
      );

      $('.header-nav__content-lvl-2').on('mouseenter', function (e) {
        // stop layer-close action on hover the layer
        clearTimeout(navContentHideTimeoutId);
      });

      /**
       *  set layer height => some height of level 2 & 3 & 4
       *
       * @param $navItemLink
       */
      function setLayerHeightForSelectedNavLinkItem($navItemLink) {
        let $navContents = $($navItemLink.data('target'));
        $navContents = $navContents.add($navItemLink.parents('.header-nav__content:not(.header-nav__content-lvl-1)'));
        $navContents.height('');

        let navContentLayerHeight = 0;
        $navContents.each(function () {
          if (navContentLayerHeight < $(this).outerHeight()) {
            navContentLayerHeight = $(this).outerHeight();
          }
        });
        $navContents.css('height', navContentLayerHeight + 'px');
      }
    }

    function _toggleBackdropDesktop(isVisible) {
      if (!$backdrop.length) return;
      if (isVisible) {
        $('body').addClass('backdrop-visible');
      } else {
        $('body').removeClass('backdrop-visible');
      }
    }
  }

  /**
   *
   * @param node
   * @param callback
   * @returns {MutationObserver}
   */
  function onClassChange(node, callback) {
    let lastClassString = node.classList.toString();

    const mutationObserver = new MutationObserver((mutationList) => {
      for (const item of mutationList) {
        if (item.attributeName === 'class') {
          const classString = node.classList.toString();
          if (classString !== lastClassString) {
            callback(mutationObserver);
            lastClassString = classString;
            break;
          }
        }
      }
    });

    mutationObserver.observe(node, { attributes: true });
    return mutationObserver;
  }
});
__webpack_require__.dn(headerNav);

;// ./build/shared/js/modules/themeAssets.js
//-----------------------------------
// ### Theme asset paths ###
//-----------------------------------
//
// Every frontend is deployed with its own asset directory only (/js/<theme>, /css/<theme>);
// the other themes are stripped from the build. Dynamically loaded assets must therefore never
// use a hardcoded theme path, otherwise they 404 on every shop but the hardcoded one.
//
// Note: $.cachedScript() in main.js rewrites a hardcoded /js/aponeo_de/ prefix to the current
// shop, which used to hide this for scripts - but $.loadStylesheet() has no such rewrite, so
// hardcoded stylesheets stayed broken. Resolve the theme here instead of relying on that.
//
// The theme is derived from the URL of the bundle that is currently being executed,
// e.g. /js/pharmeo_de/min/dist/main.js -> pharmeo_de.

const FALLBACK_THEME = 'aponeo_de';

// Matches the theme segment of a webpack bundle URL (js/<theme>/[min/]dist|bundles/<file>)
const THEME_PATTERN = /\/js\/([^/]+)\/(?:min\/)?(?:dist|bundles)\//;

const detectTheme = () => {
  // The bundle importing this module is evaluated synchronously while its own script tag runs,
  // so currentScript points at that bundle.
  const currentScript = document.currentScript;
  const currentMatch = currentScript && THEME_PATTERN.exec(currentScript.src || '');

  if (currentMatch) {
    return currentMatch[1];
  }

  // Fallback for cases where currentScript is unavailable (e.g. the bundle was injected
  // by a script loader): look the bundle up in the DOM instead.
  const scripts = document.getElementsByTagName('script');

  for (let i = 0; i < scripts.length; i += 1) {
    const match = THEME_PATTERN.exec(scripts[i].src || '');

    if (match) {
      return match[1];
    }
  }

  return FALLBACK_THEME;
};

const theme = detectTheme();

/**
 * URL of a minified asset of the current theme.
 *
 * @param {string} type Asset type directory, 'js' or 'css'
 * @param {string} file Path of the asset relative to the theme's min directory
 * @returns {string}
 */
const themeAssetUrl = (type, file) => `/${type}/${theme}/min/${file}`;

;// ./build/shared/js/modules/headroom.js


/* harmony default export */ var headroom = (() => {
  let xhr;

  const initHeadroom = () => {
    let headroom = new Headroom($('.header').get(0), {
      tolerance: {
        down: 10,
        up: 10,
      },
      onUnpin: function () {
        if ($('html, body').hasClass('off-canvas-opened')) {
          $(this.elem).removeClass(this.classes.unpinned).addClass(this.classes.pinned);
        } else {
          $(this.elem).removeClass(this.classes.pinned).addClass(this.classes.unpinned);
        }
        if ($('.apn-header .apn-header-search input:focus').length > 0) {
          $(this.elem).removeClass(this.classes.unpinned).addClass(this.classes.pinned);
        }
      },
    });
    headroom.init();
  };

  const loadHeadroom = () => {
    if (typeof xhr === 'undefined' && window.matchMedia('screen and (max-width: 991px)').matches) {
      xhr = $.cachedScript(themeAssetUrl('js', 'headroom.js')).done(() => {
        initHeadroom();
      });
      $(window).off('resize', loadHeadroom);
    }
  };

  $(document).ready(() => {
    loadHeadroom();
  });
  $(window).resize(loadHeadroom);
});
__webpack_require__.dn(headroom);

;// ./build/shared/js/modules/interactionCheck.js


/* harmony default export */ var interactionCheck = (() => {
  const $interactionCheck = $('.js-apn-itxCheck');
  const $interactionCheckButton = $('.js-apn-itxCheckButton');
  const $interactionRemoveButton = $('.js-apn-itxRemoveButton');

  if ($interactionCheck.length && $interactionCheckButton.length) {
    (($) => {
      const $interactionCheckFailure = $interactionCheck.find('.js-apn-itxFailure'),
        $interactionCheckSuccess = $interactionCheck.find('.js-apn-itxSuccess');

      const resetInteractionCheck = () => {
        $interactionCheckSuccess.addClass('hidden');
        $interactionCheckFailure.addClass('hidden');
        $interactionCheck.addClass('hidden');
        $interactionCheck.find('.js-apn-itxInteraction').not('.hidden').remove();
      };

      const getPznList = () => {
        let pznItems = [];
        $('span[data-contains="pzn"]').each((index, element) => {
          pznItems.push(element.innerText);
        });
        return pznItems;
      };

      $interactionCheckButton.click(() => {
        resetInteractionCheck();
        $interactionCheckButton.attr('disabled', 'disabled');
        showLoadingScreen();

        $.ajax({
          url: '/rpc.php?action=interaktionsinfo',
          data: {
            pznlist: getPznList(),
          },
          dataType: 'json',
          method: 'POST',
        })
          .done((response) => {
            if (response.length) {
              const $interactionTemplate = $interactionCheck.find('.js-apn-itxInteraction'),
                $messageTemplate = $interactionTemplate.find('.js-apn-itxMessage');

              response.forEach((itx) => {
                let $interaction = $interactionTemplate.clone();
                $interaction.find('.js-apn-itxMessages').empty();
                $interaction.find('.js-apn-itxProduct1').html(itx['products'][0]['name']);
                $interaction.find('.js-apn-itxProduct2').html(itx['products'][1]['name']);
                $interaction.find('.js-apn-itxPzn1').html(itx['products'][0]['pzn']);
                $interaction.find('.js-apn-itxPzn2').html(itx['products'][1]['pzn']);
                $interaction.find('.js-apn-itxSeverity').html(itx['meta']['interactionScore']['shortText1']);
                $interaction.find('.js-apn-itxDesc').html(itx['meta']['interactionScore']['fullText1']);
                $interaction.find('.js-apn-itxAdditionalDesc').html(itx['meta']['interactionScore']['fullText2']); //  + itx['meta']['interactionScore']['shortText2']
                $interaction.find('.js-apn-itxDate').html(itx['meta']['timeDataSet']);
                itx['messages'].forEach((message) => {
                  let $message = $messageTemplate.clone();
                  $message.find('.js-apn-itxMessageDesc').html(message['description']);
                  $message.find('.js-apn-itxMessageInteraction').html(message['interaction']);
                  $interaction.find('.js-apn-itxMessages').append($message);
                });
                $interaction.removeClass('hidden');
                $interactionCheck.find('.js-apn-itxInteractions').append($interaction);
              });
            } else {
              $interactionCheckSuccess.removeClass('hidden');
            }
          })
          .fail((response) => {
            if (response.status === 200 && response.responseText === '') {
              // this is the case if not interactions are known, server respond is empty
              $interactionCheckSuccess.removeClass('hidden');
            } else {
              $interactionCheckFailure.removeClass('hidden');
            }
          })
          .always(() => {
            $interactionCheck.removeClass('hidden');
            $interactionCheckButton.removeAttr('disabled');

            $('.js-intercation-step_1').show();
            // removeLoadingScreen();
          });
      });

      $interactionRemoveButton.click((event) => {
        let $pzn = $(event.target).data('pzn');
        console.log($pzn);
        //showLoadingScreen();

        $.ajax({
          url: '/rpc.php?action=interactionscheck&do=remove&pzn=' + $pzn,
          dataType: 'json',
          method: 'GET',
        })
          .done((response) => {
            if ((response = 1)) {
              $('#product-' + $pzn).hide(400);
              //removeLoadingScreen();
              //hideLoadingScreen();
            } else {
              console.log('invalid response:');
              console.log(response);
            }
          })
          .always(() => {});
      });
    })(jQuery);
  }
});
__webpack_require__.dn(interactionCheck);

;// ./build/shared/js/modules/jssinglesubmit.js
/* harmony default export */ var jssinglesubmit = (() => {
  // prevent multiple clicks on submit buttons when form contains class "_js-single-submit"
  /*    document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form.classList.contains('_js-single-submit')) return;

        const submitButton = form.querySelector(
            'button[type="submit"], input[type="submit"]'
        );

        if (!submitButton) {
            return;
        }

        if (submitButton.dataset.submitted === '1') {
            e.preventDefault();
            return;
        }
        showLoadingScreen()
        console.log('force _jssinglesubmit');
        submitButton.dataset.submitted = '1';
        submitButton.disabled = true;
    }, true);*/

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form.classList.contains('_js-single-submit')) return;

      if (form.dataset.submitted === '1') {
        e.preventDefault();
        return;
      }

      form.dataset.submitted = '1';
      showLoadingScreen();
      console.log('force _jssinglesubmit');

      // optional: UI sperren
      const btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (btn) {
        btn.style.pointerEvents = 'none';
        btn.classList.add('is-disabled');
      }
    },
    true,
  );
});
__webpack_require__.dn(jssinglesubmit);

;// ./build/shared/js/modules/banking.js
// Checkout Optionales BIC-Form wenn IBAN nicht DE...
const fctCheckIbanForBic = () => {
  $('#iban_hide').keyup(() => {
    fctCheckForBic();
  });

  fctCheckForBic();
};

const fctCheckForBic = () => {
  try {
    const $ibanHide = $('#iban_hide');
    if ($ibanHide.val().length > 2) {
      if ($ibanHide.val().toUpperCase().indexOf('DE') >= 0) {
        $('#bic').hide();
        $("label[for='bic']").hide();
      } else {
        $('#bic').show();
        $("label[for='bic']").show();
      }
    } else {
      $('#bic').hide();
      $("label[for='bic']").hide();
    }
  } catch (e) {
    // No Iban input available
  }
};

;// ./build/shared/js/modules/bonuspoints.js
// Update the bonuspoint div-container on PDP
const updatePdpBonuspoints = async () => {
  const pdpBonusContainer = document.getElementById('pdp_bonus_container');
  if (pdpBonusContainer && pdpBonusContainer.dataset.pzn) {
    try {
      const url = `rpc.php?action=productbonuspoint&case=pdp&propzn=${pdpBonusContainer.dataset.pzn}`;
      const response = await fetch(url);
      const html = await response.text();
      pdpBonusContainer.innerHTML = html;
    } catch (error) {
      console.error('Error updating PDP bonuspoints:', error);
    }
  }

  const pdpBonusAlternateSize = document.querySelectorAll('._pdp_bonus_alternatesize');
  await Promise.all(
    Array.from(pdpBonusAlternateSize).map(async (element) => {
      const pzn = element.dataset.pzn;
      const targetElement = document.getElementById(`_pdp_bonus_alternatesize_${pzn}`);

      if (targetElement) {
        try {
          const url = `rpc.php?action=productbonuspoint&propzn=${pzn}`;
          const response = await fetch(url);
          const htmlContent = await response.text();

          if (htmlContent.trim() !== '') {
            targetElement.innerHTML = htmlContent;
            targetElement.classList.add('apo-cash-badge');
          }
        } catch (error) {
          console.error(`Error updating PDP bonuspoints:`, error);
        }
      }
    }),
  );
};

;// ./build/shared/js/modules/legalInfo.js
function initLegalInfo(isLoopedSlider) {
  const $legalInfoItems = isLoopedSlider ? $('.swiper-slide-duplicate .teaser-legal-infos') : $('.teaser-legal-infos');

  $legalInfoItems.each((index, legalInfoItem) => {
    const $legalInfoItem = $(legalInfoItem);
    const $openButton = $legalInfoItem.find('.teaser-legal-infos__button');
    const $closeButton = $legalInfoItem.find('.teaser-legal-infos__button-close');
    const $content = $legalInfoItem.find('.teaser-legal-infos__content');
    const $companionSlider = $legalInfoItem.parents('.apn-hero-teaser-compagnion');
    let $heroSliderInstance;

    $openButton.on('click', (e) => {
      e.preventDefault();
      $content.show();
      if ($legalInfoItem.hasClass('teaser-legal-infos--slider')) {
        if (!$companionSlider.length) {
          hideLegalInfoOnSlide($legalInfoItem);
          pauseSlider($legalInfoItem.parents('.swiper-container'));
        } else {
          $heroSliderInstance = $companionSlider.prev().find('.swiper-container');
          hideLegalInfoOnSlide($legalInfoItem);
          pauseSlider($heroSliderInstance);
        }
      }
    });
    $closeButton.on('click', (e) => {
      e.preventDefault();
      $content.hide();

      if ($companionSlider.length) {
        resumeSlider($heroSliderInstance);
      } else if ($legalInfoItem.hasClass('teaser-legal-infos--slider') && !$companionSlider.length) {
        resumeSlider($legalInfoItem.parents('.swiper-container'));
      }
    });
  });
}

function hideLegalInfoOnSlide($legalInfoItem) {
  const $legalInfoSliderItemContent = $legalInfoItem.find('.teaser-legal-infos__content');

  const $swiperWrapper = $legalInfoSliderItemContent.parents('.swiper-wrapper');
  const $swiperContainer = $legalInfoSliderItemContent.parents('.swiper-container');

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      $legalInfoSliderItemContent.hide();
      resumeSlider($swiperContainer);
      disconnectObserver();
    });
  });

  // Observe Swiper transition
  observer.observe($swiperWrapper[0], {
    attributes: true,
    attributeFilter: ['style'],
  });

  function disconnectObserver() {
    observer.disconnect();
  }
}

function pauseSlider($swiperContainer) {
  const swiperInstance = $swiperContainer[0].swiper;
  swiperInstance.autoplay.pause();
  swiperInstance.autoplay.paused = true;
}

function resumeSlider($swiperContainer) {
  const swiperInstance = $swiperContainer[0].swiper;

  if (swiperInstance.autoplay.paused) {
    swiperInstance.autoplay.start();
    swiperInstance.autoplay.paused = false;
  }
}

;// ./build/shared/js/modules/swiperLoader.js


function loadSwiper() {
  const isSwiperLibLoaded = typeof Swiper === 'function';
  if (isSwiperLibLoaded) {
    return $.when();
  }

  return $.cachedScript(themeAssetUrl('js', 'swiper.js'));
}

;// ./build/shared/js/modules/sliders.js




//-----------------------------------
// ### Aponeo Sliders ###
//------------------------------------

// Global Sliders Array
const apnSliders = [];

// Initiate Sliders if present on page
function initiateSliders() {
  if ($('.swiper-container').length === 0) {
    return;
  }

  loadSwiper().done(() => {
    // Big slider on e.g. start page
    if ($('.apn-teaser-hero-slider').length) {
      $('.apn-teaser-hero-slider .swiper-container').each((index, element) => {
        let apn_compagnion_slider = null;
        if ($(element).parents('.with-compagnion').length) {
          const $sharedParent = $(element).closest('.row');
          const $compagnionSlider = $('.apn-compagnion-wrapper .swiper-container', $sharedParent);
          if ($compagnionSlider.length) {
            apn_compagnion_slider = new Swiper($compagnionSlider, {
              loop: true,
              allowTouchMove: false,
              preventClicks: false,
            });
          }
        }

        let initialized = false;
        const apn_teaser_hero_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          on: {
            init: function () {
              initialized = true;
              initLegalInfo(true);
            },
            slideNextTransitionStart: function () {
              if (apn_compagnion_slider && initialized) {
                apn_compagnion_slider.slideNext();
              }
            },
            slidePrevTransitionStart: function () {
              if (apn_compagnion_slider && initialized) {
                apn_compagnion_slider.slidePrev();
              }
            },
          },
        });
      });
    }

    // Banner slider on e.g. start page
    if ($('.apn-teaser-banner-slider').length) {
      $('.apn-teaser-banner-slider .swiper-container').each((index, element) => {
        const apn_teaser_banner_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          on: {
            init: function () {
              initLegalInfo(true);
            },
          },
        });
      });
    }

    // Slider on Product Detail Page
    let apnProductDetailSliders = [];
    if ($('.apn-product-detail-slider').length) {
      $('.apn-product-detail-slider .swiper-container').each(function (index, element) {
        const apn_product_detail_slider = new Swiper($('.apn-product-detail-slider .swiper-container')[index], {
          pagination: {
            el: $('.apn-product-detail-slider .swiper-pagination')[index],
            type: 'bullets',
            clickable: true,
          },
          on: {
            slideChange: () => {
              if (apnProductDetailThumbnailSliders[index]) {
                // slide the thumbnail slider
                apnProductDetailThumbnailSliders[index].slideTo(element.realIndex);
                // set active class for active preview
                apnProductDetailThumbnailSliders[index].slides.removeClass('swiper-slide-fake-active');
                $(apnProductDetailThumbnailSliders[index].slides[apnProductDetailSliders[index].activeIndex]).addClass(
                  'swiper-slide-fake-active',
                );
              }
            },
          },
        });
        apnProductDetailSliders[index] = apn_product_detail_slider;
      });
    }

    // Thumbnail slider on Product Detail Page
    let apnProductDetailThumbnailSliders = [];
    if ($('.apn-product-detail-thumbnail-slider').length) {
      $('.apn-product-detail-thumbnail-slider .swiper-container').each((i, e) => {
        const apn_product_detail_thumbnail_slider = new Swiper(
          $('.apn-product-detail-thumbnail-slider .swiper-container')[i],
          {
            slidesPerView: 'auto',
            navigation: {
              nextEl: $('.apn-product-detail-thumbnail-slider .swiper-button-next')[i],
              prevEl: $('.apn-product-detail-thumbnail-slider .swiper-button-prev')[i],
            },
            on: {
              tap: (event) => {
                const slide = $(event.target).closest('.swiper-slide');
                if (slide && typeof slide.data('index') !== 'undefined') {
                  apnProductDetailSliders[i].slideTo(slide.data('index'));
                }
              },
            },
          },
        );
        apnProductDetailThumbnailSliders[i] = apn_product_detail_thumbnail_slider;
      });
    }

    // Category Slider
    if ($('.apn-teaser-category-slider').length && $(window).width() < 992) {
      $('.apn-teaser-category-slider .swiper-container').each((i) => {
        const apn_teaser_category_slider = new Swiper($('.apn-teaser-category-slider .swiper-container')[i], {
          slidesPerView: '4',
          freeMode: true,
          spaceBetween: 15,
        });
      });
    }

    // Product Slider -- only initialise non empty ones:
    if ($('.apn-teaser-product-slider:has(.swiper-wrapper > *)').length) {
      $('.apn-teaser-product-slider .swiper-container').each((i, element) => {
        const maxSlides = $(element).hasClass('max-slides-4') ? 4 : 5;
        const numberOfSlides = $(element).children('.swiper-wrapper')[0].childElementCount;
        const apn_teaser_product_slider = new Swiper($(element), {
          slidesPerView: 'auto',
          slidesPerGroup: maxSlides,
          breakpoints: {
            991: {
              slidesPerGroup: 1,
            },
          },
          navigation: {
            nextEl: $(element).siblings('.swiper-button-next'),
            prevEl: $(element).siblings('.swiper-button-prev'),
          },
        });

        setSameHeight(element, '.apn-product-list-item-header');

        if (numberOfSlides <= maxSlides) {
          $(element).siblings('.swiper-button-next').removeClass('d-lg-block');
          $(element).siblings('.swiper-button-prev').removeClass('d-lg-block');
        }
      });
    }

    // Auto Slider
    if ($('.apn-teaser-auto-slider').length) {
      $('.apn-teaser-auto-slider .swiper-container').each((i) => {
        const apn_teaser_auto_slider = new Swiper($('.apn-teaser-auto-slider .swiper-container')[i], {
          autoplay: {
            delay: 2500,
          },
        });
      });
    }

    // Benefits Slider
    if ($('.apn-teaser-benefits-slider').length) {
      let _slidesPerView = $(window).width() > 767 ? 3 : 2;
      $('.apn-teaser-benefits-slider .swiper-container').each((i) => {
        const apn_teaser_benefits_slider = new Swiper($('.apn-teaser-benefits-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Customer Slider
    if ($('.apn-teaser-customer-slider').length) {
      let _slidesPerView = $(window).width() > 991 ? 2 : 1;
      $('.apn-teaser-customer-slider .swiper-container').each((i) => {
        const apn_teaser_benefits_slider = new Swiper($('.apn-teaser-customer-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          spaceBetween: 30,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Brand Slider
    if ($('.apn-teaser-brand-slider').length) {
      $('.apn-teaser-brand-slider .swiper-container').each(function (i) {
        var apn_teaser_brand_slider = new Swiper($('.apn-teaser-brand-slider .swiper-container')[i], {
          slidesPerView: 3.5,
          spaceBetween: 15,
          // Responsive breakpoints
          breakpoints: {
            // when window width is >= 767px
            767: {
              slidesPerView: 3.5,
              spaceBetween: 15,
            },
            // when window width is >= 991px
            991: {
              slidesPerView: 3.5,
              spaceBetween: 15,
            },
          },
        });
      });
    }

    // Advisor Slider
    if ($('.apn-teaser-advisor-slider').length && $(window).width() < 992) {
      $('.apn-teaser-advisor-slider .swiper-container').each((i) => {
        const apn_teaser_advisor_slider = new Swiper($('.apn-teaser-advisor-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: {
            nextEl: $('.apn-teaser-advisor-slider .swiper-button-next')[i],
            prevEl: $('.apn-teaser-advisor-slider .swiper-button-prev')[i],
          },
        });
      });
    }

    if ($('.apn-bonus-scheme__overview__slider').length) {
      $('.apn-bonus-scheme__overview__slider.swiper-container').each(function () {
        const apnBonusSchemeOverviewSlider = new Swiper(this, {
          navigation: {
            nextEl: $('.swiper-button-next', this),
            prevEl: $('.swiper-button-prev', this),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          slidesPerView: 2,
          breakpoints: {
            991: {
              slidesPerView: 1,
            },
          },
          on: {
            init: function () {
              initLegalInfo(true);
            },
          },
        });
      });
    }

    // Product List Combi Slider
    let productCombiSlider = {};

    if ($('.product-combi__slider .swiper-container').length) {
      $('.product-combi__slider .swiper-container').each((index, element) => {
        const activeIndex = $(element).find('.swiper-slide:has(.active)').index();
        productCombiSlider = new Swiper(element, {
          initialSlide: activeIndex ?? 0,
          slidesPerView: 'auto',
          spaceBetween: 15,
          freeMode: true,
        });

        if (window.matchMedia('screen and (min-width: 768px)').matches) {
          if (productCombiSlider !== undefined) {
            productCombiSlider.destroy(false, true);
          }
        }
      });
    }

    // Add Sliders to global Array sliders
    $('.swiper-container').each(function (index, element) {
      const swiper = this.swiper;
      if (swiper) {
        apnSliders.push(swiper);
      }
    });
  });
}

// Destroy Sliders
function destroySliders() {
  $(apnSliders).each((index, element) => {
    element.destroy(false, true);
  });
}

// Toggle re-initialization and destruction of sliders if user switchs between
// tablet and desktop view
let windowWidth = $(window).width();
$(window).resize(() => {
  if ($(window).width() !== windowWidth) {
    destroySliders();
    initiateSliders();
    windowWidth = $(window).width();
  }
});

;// ./build/shared/js/modules/wishlist.js


// PZNs currently on the user's wishlist(s)
const wishlistPzns = new Set();

// TODO: consider caching the wishlist PZNs in sessionStorage to avoid one request per page load.
let wishlistPznsLoaded = false;

/**
 * Perform a leaflet RPC call.
 * @param {string} todo
 * @param {Object} [data]
 * @returns {Promise<Object>}
 */
async function leafletRequest(todo, data = {}) {
  const response = await fetch('/rpc.php?action=leaflet', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ todo, ...data }),
  });

  return response.json();
}

/**
 * Load the PZNs on the user's wishlist(s) once per page load.
 * @returns {Promise<void>}
 */
async function loadWishlistPzns() {
  try {
    const data = await leafletRequest('get-wishlist-pzns');

    if (!data || !Array.isArray(data.success)) {
      return;
    }

    wishlistPzns.clear();
    data.success.forEach((pzn) => wishlistPzns.add(Number(pzn)));
  } catch {
    // ignore, the buttons simply stay in their default state
  }
}

/**
 * Mark every wish button within the given scope according to the wishlist state.
 * @param {Element|Document} [root]
 */
function applyWishlistState(root = document) {
  root.querySelectorAll('.addtoleafletbtn-global').forEach((btn) => {
    const isOnWishlist = wishlistPzns.has(Number(btn.value));

    btn.classList.toggle('is-on-wishlist', isOnWishlist);
    btn.querySelectorAll('.wishlist-label--add').forEach((label) => (label.hidden = isOnWishlist));
    btn.querySelectorAll('.wishlist-label--remove').forEach((label) => (label.hidden = !isOnWishlist));

    if (btn.dataset.wishlistLabelDefault === undefined) {
      btn.dataset.wishlistLabelDefault = btn.getAttribute('aria-label') || '';
    }

    btn.setAttribute('aria-label', isOnWishlist ? 'Vom Merkzettel entfernen' : btn.dataset.wishlistLabelDefault);
  });
}

/**
 * Mark a product as being on the wishlist after a successful add.
 * @param {string|number} pzn
 */
function addWishlistPzn(pzn) {
  wishlistPzns.add(Number(pzn));
  applyWishlistState();
}

/**
 * Remove a product from every wishlist of the user.
 * @param {Element} btn
 */
async function removeFromWishlist(btn) {
  const pzn = Number(btn.value);
  setCursor('wait');

  try {
    const data = await leafletRequest('remove-wishlist-product', { id: pzn });

    if (!data || !data.success) {
      return;
    }

    wishlistPzns.delete(pzn);
    applyWishlistState();

    const $btn = $(btn);

    $btn.popover({
      content: 'Der Artikel wurde von ihrem Merkzettel entfernt',
      placement: 'top',
      title: 'Merkzettel',
      trigger: 'manual',
    });

    $btn.popover('show');

    $('body').one('click', () => {
      $btn.popover('hide');
    });
  } finally {
    setCursor('default');
  }
}

/**
 * Handle a click on a wish button that is already on the wishlist.
 * @param {Element} btn
 * @returns {boolean} true when the click was consumed as a removal
 */
function handleWishlistButtonClick(btn) {
  if (!btn.classList.contains('is-on-wishlist')) {
    return false;
  }

  removeFromWishlist(btn);
  return true;
}

/**
 * Load and apply the wishlist state once per page load.
 */
function initWishlist() {
  $(document).ready(() => {
    if (wishlistPznsLoaded) {
      applyWishlistState();
      return;
    }

    wishlistPznsLoaded = true;
    loadWishlistPzns().finally(() => applyWishlistState());
  });
}

;// ./build/shared/js/modules/leaflet.js
__webpack_require__.dn(leaflet);














function leaflet_addToLeafletFunctions() {
  // init wish btn global
  $('.addtoleafletbtn-global:not(.initialized)')
    .click((event) => {
      if (_DEBUG) console.log('leaflet-->addtoleafletbtn-global:click()');
      //const self = $(event.target);
      const self = $(event.currentTarget);

      // already on the wishlist -> remove it
      if (handleWishlistButtonClick(event.currentTarget)) {
        return;
      }

      const helperUpsellingAction = $(event.currentTarget).parent().parent().parent().attr('data-dl-action');
      const helperUpsellingList = $(event.currentTarget)
        .parent()
        .parent()
        .parent()
        .attr('data-dl-addtocartupsellinglist');

      // Start GTM Wishlist tracking
      if (window['google_tag_manager']) {
        /*
     const helperElement = $(event.currentTarget).parent().children('input[name="abskt"]');

      let pageType = 'undefined pageType';
      if (typeof window['google_tag_manager']['GTM-5GNVZ2M'] === 'object'
          && typeof window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer === 'object')
      {
        pageType = window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer.get('pageType');
      }
      let wishlistAdd = {
        'brand': helperElement.data('brand'),
        'grossPrice': helperElement.data('gross-price'),
        'internalId': helperElement.data('internal-id'),
        'name': helperElement.data('name'),
        'pzn': String(helperElement.data('pzn')),
        'quantity': 1,
        'manufacturer': helperElement.data('manufacturer'),
        'manufacturerid': helperElement.data('manufacturerid')
      };

      if (!pageType) {
        console.log('pageType undefined');
        wishlistAdd.action = 'undefined pagetype Add to Wishlist';
      } else if (pageType === 'productdetail') {
        wishlistAdd.action = 'PDP Item Add to Wishlist';
      } else if (pageType === 'category' || (pageType.indexOf('category_subpage') !== -1)) {
        wishlistAdd.action = 'Category Page Item Add to Wishlist';
      } else if (pageType === 'search') {
        wishlistAdd.action = 'Search Results Item Add to Wishlist';
      } else if (pageType === 'service_wechselwirkungscheck') {
        wishlistAdd.action = 'Interaction Check Item Add to Wishlist';
      } else if (helperUpsellingAction) {
        wishlistAdd.action =  helperUpsellingAction;
        wishlistAdd.addToCartUpsellingList = 'Add to Wishlist "' + helperUpsellingList + '"';
      }

      console.log(('wishlistChange-->'));
      console.log(wishlistAdd)
      dataLayer.push({
        'event': 'addToWishlist',
        'wishlistChange': wishlistAdd
      });
      console.log(('<--wishlistChange'));
*/
      } // Eof GTM Wishlist tracking

      // Try to do like a customer:
      if (_DEBUG) console.log('leaflet-->getLeaflets()');
      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          todo: 'get-leaflets',
          id: 0,
        },
      }).done((response) => {
        const customer = response.customer;
        if (_DEBUG) console.log('leaflet-->customer:' + customer);

        if (customer > 0) {
          if (_DEBUG) console.log('leaflet-->customer');
          const leaflets = response.success;
          $('.leaflets-list').each((i, e) => {
            // if ($('> option', e).length > 2) {
            //   return; // already initialized
            // }

            $(e).children().remove();
            $(e).append('<option value="">Auswählen</option>');
            $(e).append('<option value="new">Neu</option>');

            for (let _i = 0; _i < leaflets.length; _i++) {
              $(e).append(
                $('<option>', {
                  value: leaflets[_i].PKcll_id,
                  text: leaflets[_i].cll_name,
                  disabled: leaflets[_i].disabled,
                }),
              );
            }
          });

          if (_DEBUG) console.log('leaflet-->customer: addtoleafletbtn:click()');
          let el = $(event.currentTarget).parent().children();
          // el.off('click');
          el.toggle(0);
        } else {
          // do action for guest & visitors
          if (_DEBUG) console.log('leaflet-->visitor/guest');
          if (_DEBUG) console.log('leaflet-->add to session');

          $.ajax({
            url: '/rpc.php?action=leaflet',
            method: 'POST',
            data: {
              todo: 'add-to-session',
              id: self.val(),
            },
          }).done(() => {
            addWishlistPzn(event.currentTarget.value);

            self.popover({
              content: 'Der Artikel ist jetzt auf ihrem Merkzettel',
              placement: 'top',
              title: 'Merkzettel',
              trigger: 'manual',
            });

            self.popover('show');

            $('body').one('click', () => {
              self.popover('hide');
            });
          });
        }
      });
    })
    .addClass('initialized');

  applyWishlistState();

  initLeafletSelect();
}

function initLeafletSelect(root) {
  if (typeof root == 'undefined') {
    root = $('body');
  }

  $('.leaflets-list:not(.initialized)', root)
    .change(function () {
      if (_DEBUG) console.log('leaflet-->initLeafletSelect()');

      if (!$(this).val()) {
        if (_DEBUG) console.log('leaflet--> initLeafletSelect()-->false');
        return false;
      }

      const self = $(this).parent();
      setCursor('wait');
      $(this).parent().prop('id', $(this).val());

      if (_DEBUG) {
        console.log($(this));
        console.log('leaflet-->initLeafletSelect() todo:add-product');
        console.log('leaflet-->initLeafletSelect() id:' + $(this).val());
        console.log('leaflet-->initLeafletSelect() pzn:' + $(this).parent().children('.addtoleafletbtn-global').val());
      }

      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          todo: 'add-product',
          id: $(this).val(),
          pzn: $(this).parent().children('.addtoleafletbtn-global').val(),
        },
      })
        .done((response) => {
          $('#' + response.id)
            .children()
            .toggle(0);

          $('#' + response.id)
            .children('.leaflets-list')
            .val('');

          $('#' + response.id).prop('id', '');

          if (!response.success) {
            alert('Der Artikel konnte nicht auf dem Merkzettel gespeichert werden');
          } else {
            addWishlistPzn($(this).parent().children('.addtoleafletbtn-global').val());

            self.popover({
              content: 'Der Artikel ist jetzt auf ihrem Merkzettel',
              placement: 'top',
              title: 'Merkzettel',
              trigger: 'manual',
            });

            self.popover('show');

            $('body').one('click', function () {
              self.popover('hide');
            });
          }
        })
        .always(function () {
          setCursor('default');
        });
    })
    .addClass('initialized');
}

//JS for Leaflet
const leafletTimer = {};

function saveLeaflet(leafletId) {
  clearTimeout(leafletTimer[leafletId]);
  leafletTimer[leafletId] = setTimeout(function () {
    let products = [];
    $('#coupon-action-' + leafletId)
      .find('div[id^="product"]')
      .each(function () {
        products[products.length] = {
          pro_pzn: $(this).prop('id').split('-')[1],
          quantity: $(this).find('.quantity-display').val(),
        };
      });
    $.ajax({
      url: '/rpc.php?action=leaflet',
      method: 'POST',
      data: {
        id: leafletId,
        products: JSON.stringify(products),
        todo: 'update',
      },
    }).done(function (res) {
      let response = jQuery.parseJSON(res);
      if (!response['success']) {
        alert('Speichern der neuen Anzahl ist fehlgeschlagen.');
      }
    });
  }, 3000);
}

/* harmony default export */ function leaflet() {
  $(document).ready(function () {
    /**
     * Clickfunction on PDP to get manufacturer email|website via Ajax/Soap WEB-4557
     */
    if ($('._gpsr').length) {
      $('._gpsr').click(function () {
        let pzn = $('._gpsr').data('gpsrpzn');

        if (_DEBUG) console.log('Get GPSR data for pzn ' + pzn);

        setCursor('wait');
        $.ajax({
          url: '/rpc.php?action=manufacturerdata',
          method: 'POST',
          data: {
            p: pzn,
          },
        }).done(function (response) {
          setCursor('default');
          if (_DEBUG) console.log(response);

          if (isNaN === response.success) {
            return false;
          }

          $('._gpsr').hide(800);
          $('._gpsr').html('elektronische Adresse: ' + response.email + ' | ' + response.website);
          $('._gpsr').show(800);
        });

        return false;
      });
    }

    let logout = _urlParams.get('logoutinfo');
    if (logout != null) {
      if (typeof amazon !== 'undefined') {
        console.log('signout req amz');
        amazon.Pay.signout();
      }
    }

    /** Mehr Produkte laden auf Ratgeber-Seiten */
    if ($('#advisor-more-products-button').length) {
      $('#advisor-more-products-button').on('click', function () {
        $('#advisor-more-products-content').removeClass('d-none');
        $('#advisor-more-products-button-wrapper').addClass('d-none');
      });
    }

    /** Direkt den richtigen Ratgeber Tab aufmachen */
    if ($('#products-tab').length && $('#article-tab').length) {
      console.log('Tab vorhanden');
      const currentUrl = document.location.toString();
      if (currentUrl.match('#')) {
        console.log('Tab aufmachen');
        $('.nav-tabs a[href="#' + currentUrl.split('#')[1] + '"]').tab('show');
      }

      /** "Weitere Produkte" im Empfehlungsteaser soll auch den Tab aufmachen. */
      $('a[data-teaser="more"]').click(function () {
        $('.nav-tabs a[href="#products"]').tab('show');
        const productsTab = $('#products-tab');
        $('html,body').animate({ scrollTop: productsTab.offset().top }, 'slow');
      });
    }

    $('.btn-leaflet-rename').click(function () {
      $(this).parent().siblings('js-leaflet-name').children().toggle(0);
      return false;
    });

    $('.btn-leaflet-save-name').click(function () {
      $(this).prop('disabled', true);
      const el = $(this).parent().prev();
      setCursor('wait');

      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          id: el.prop('name').split('_')[1],
          name: el.val(),
          todo: 'rename',
        },
      }).done(function (response) {
        setCursor('default');

        $('div[data-leafletId="#coupon-action-' + response.id + '"] button[name="rename"]').prop('disabled', false);

        if (response.success == false) {
          alert(
            'Umbenennen des Merkzettels schlug fehl. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
          );
          return;
        }

        $('#leafletname-' + response.id).text(
          $('#leafletname-' + response.id)
            .next()
            .find('input[name^="name_"]')
            .val(),
        );

        $('div[data-leafletId="#coupon-action-' + response['id'] + '"] js-leaflet-name')
          .children()
          .toggle(0);

        $('.js-leafletSortButton').val('');
      });

      return false;
    });

    $('.btn-leaflet-delete').click(function () {
      const name = $(this).closest('.page-nav-menu-item').children().find('.js-leaflet-name').text();

      if (!confirm('"' + name + '" wirklich löschen?')) {
        return false;
      }

      setCursor('wait');

      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          id: $(this).val(),
          todo: 'delete',
        },
      }).done(function (response) {
        setCursor('default');

        if (isNaN === response.success) {
          alert('Löschen des Merkzettels schlug fehl. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.');
          return false;
        }

        $('#leaflet-' + response.success).slideUp();
      });

      return false;
    });

    $('.btn-quantity-increase').click(function () {
      let element = $(this).siblings('.display-quantity');
      if (Number(element.val()) < Number($(this).siblings('.max-sales').val())) {
        element.val(Number(element.val()) + 1);
        $('#btn-save').show();
      }
    });

    $('.btn-quantity-decrease').click(function () {
      let element = $(this).siblings('.display-quantity');
      if (Number(element.val()) > 1) {
        element.val(Number(element.val()) - 1);
        $('#btn-save').show();
      }
    });

    $('div[id^=leaflet-]').each(function () {
      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          id: $(this).prop('id').split('-')[1],
          todo: 'get-products',
        },
      }).done(function (response) {
        let products = response.success;
        const node = $('#coupon-action-' + response.id + ' > .coupon-information > .cart-product-list');

        for (let i = 0; i < products.length; i++) {
          node.append(products[i]);
        }

        basket_addToBasketFunctions();

        node.find('.btn-remove').click(function () {
          setCursor('wait');
          $.ajax({
            url: '/rpc.php?action=leaflet',
            method: 'POST',
            data: {
              todo: 'remove-product',
              leaflet: $(this).parents('div[id^=leaflet-]').prop('id').split('-')[1],
              id: $(this).val(),
            },
          }).done(function (response) {
            setCursor('default');

            if (response.id) {
              $('#product-' + response.id).slideUp(1000);
            }
          });

          return false;
        });

        $('#coupon-action-' + response.id + ' .quantity-increase').click(function () {
          let element = $(this).parents('.input-group').children('.quantity-display');
          if (Number(element.val()) < Number(element.parent().children('.quantity-max').val())) {
            element.val(Number(element.val()) + 1);
            saveLeaflet(response.id);
          }
        });

        $('#coupon-action-' + response.id + ' .quantity-decrease').click(function () {
          let element = $(this).parents('.input-group').children('.quantity-display');
          if (Number(element.val()) > Number(element.parent().children('.quantity-min').val())) {
            element.val(Number(element.val()) - 1);
            saveLeaflet(response.id);
          }
        });
      });
    });

    // Merkzettel sortieren WEB-1511
    const leafletSortButton = $('.js-leafletSortButton');
    const $leafletList = $('.js-eaflet-list');
    const $leaflets = $leafletList.find('.js-leaflet');

    if (leafletSortButton.length && $leaflets.length) {
      let descending = false;

      const sortLexicographical = function (a, b) {
        const leafletNameA = $(a).find('[id^=leafletname-]').html();
        const leafletNameB = $(b).find('[id^=leafletname-]').html();
        if (descending) {
          return leafletNameB.localeCompare(leafletNameA);
        } else {
          return leafletNameA.localeCompare(leafletNameB);
        }
      };

      const sortLastEdit = function (a, b) {
        const timestampA = $(a).data('lastEdit');
        const timestampB = $(b).data('lastEdit');
        if (timestampA > timestampB) return -1;
        if (timestampA < timestampB) return 1;
        return 0;
      };

      leafletSortButton.change(function (e) {
        switch (this.value) {
          case 'sortLexicographicalAsc':
            descending = false;
            $leaflets.sort(sortLexicographical);
            break;
          case 'sortLexicographicalDesc':
            descending = true;
            $leaflets.sort(sortLexicographical);
            break;
          case 'sortLastEditDesc':
            $leaflets.sort(sortLastEdit);
            break;
        }

        // Re-order elements in DOM
        $leafletList.append($leaflets);
      });
    }

    leaflet_addToLeafletFunctions();
    basket_addToBasketFunctions();
    addDetailLinkFunctions();

    $('#ds3, #ds4, #ds5').change(function () {
      $(this).parents('form').submit();
    });

    $('#ds5_teaser_deactivate').change(function (event) {
      $('#ds5_modal_deactivate').modal('show');
      $('#ds5_teaser_deactivate').prop('checked', true);

      event.preventDefault();
    });

    $('.teaser_dyn').each(function () {
      $.ajax({
        url: '/rpc.php?action=teaser',
        method: 'POST',
        data: {
          id: $(this).prop('id').split('-')[1],
        },
      }).done(function (response) {
        $('#teaser-' + response.id).append(response.value);
      });
    });

    // Checkout Trust modules hide if consent is allready
    if ($('input[name="newsletter"]').length) {
      $.ajax({
        url: '/rpc.php?action=check-permission',
        method: 'POST',
        data: {
          module: 'newsletter',
        },
      }).done(function (response) {
        if (response.confirmation) {
          $('#input-03').parent().slideUp();
        }
      });
    }

    if ($('input[name="confirm_dhl"]').length) {
      $.ajax({
        url: '/rpc.php?action=check-permission',
        method: 'POST',
        data: {
          module: 'dhl-tracking',
        },
      }).done(function (response) {
        if (response.confirmation) {
          $('#confirm_dhl').parent().slideUp();
        }
      });
    }

    if ($('input[name="confirmTrustPharmaHera_Marketingzwecke"]').length) {
      $.ajax({
        url: '/rpc.php?action=check-permission',
        method: 'POST',
        data: {
          module: 'ph-marketing',
        },
      }).done(function (response) {
        if (response.confirmation) {
          $('#confirmTrustPharmaHera_Marketingzwecke').parent().slideUp();
        }
      });
    }

    let PaymentMethodActive = $('input[name=PayId]:checked').val();
    if (PaymentMethodActive == 1) {
      $('#bonuspoints_calc').hide();
      $('#bonuspoints_0').show();
    } else {
      $('#bonuspoints_calc').show();
      $('#bonuspoints_0').hide();
    }

    $('input[name=PayId]').change(function () {
      console.log('Handler for .change() called.');
      PaymentMethodActive = $('input[name=PayId]:checked').val();
      console.log('PaymentId is ' + PaymentMethodActive);

      if (PaymentMethodActive == 1) {
        $('#bonuspoints_calc').hide();
        $('#bonuspoints_0').show();
      } else {
        $('#bonuspoints_calc').show();
        $('#bonuspoints_0').hide();
      }
    });

    // WerbeOverlay in Checkout:Liefert
    if ($('input#shipping_48').length && $('#shipping_48').data('sameday') == '1') {
      // BX Push Popup if BX(via Liefery) is possible and also if it is SAMEDAY
      if ($('#shipping_48').data('loyalitystate') > '2' && $('input#check-prio-delivery').length) {
        // WEB-1218 : Bei Bonusprogrammstatus Diamant soll möglichst "kostenlose" orderPrio beworben werden
        $('#checkoutOrderpriorityModal').modal('show');
      } else {
        // Wenn kein Diamant, dann Sameday bewerben
        if ($('input#shipping_46\\|3').is(':checked') == false) {
          // ...und noch nicht ausgewählt
          $('#checkoutBxPushModal').modal('show');
        }
      }
    } else if ($('input#check-prio-delivery').length) {
      // Wenn BX/Sameday(via Liefery) nicht möglich ist .....
      // Order Priority Popup wenn Orderprio möglich(angezeigt)
      // Order Priority ist verfügbar
      if ($('input#check-prio-delivery').is(':checked') == false) {
        // ...und noch nicht ausgewählt
        $('#checkoutOrderpriorityModal').modal('show');
      }
    }
    // Eof WerbeOverlay in Checkout:Liefert

    // Start Order Priority Popup & SamedayPush Popup
    $('#checkOrderPriority1').on('click touch', function () {
      $('#shipping_1').prop('checked', true);
      $('#check-prio-delivery').prop('checked', true);
    });

    $('#checkOrderPriority2').on('click touch', function () {
      $('#shipping_1').prop('checked', true);
      $('#check-prio-delivery').prop('checked', true);
    });

    $('#checkBxPush1').on('click touch', function () {
      $('#shipping_48').prop('checked', true);
      ShowHide_bx_tel();
    });

    $('#checkBxPush2').on('click touch', function () {
      $('#shipping_48').prop('checked', true);
      ShowHide_bx_tel();
    });
    // Eof Order Priority Popup & SamedayPush Popup

    updatePdpBonuspoints();
    initiateSliders();
    initLegalInfo();
    fctCheckIbanForBic();

    // Marken A-Z links toggled by select options
    $('.js-toggle-brand-overview').on('change', function () {
      const letter = $(this).find(':selected').val();
      // $('.list-wrapper').removeClass('active');
      // $('#list-' + letter).addClass('active');
      window.location.href = '#list-' + letter;
    });

    // Since Bootstrap v4 toggling of multiple targets is removed
    // Close header and show form
    $('.js-account-toggle-data').on('click touch', function () {
      $(this).parent('div').collapse('toggle');
    });

    // Close form and show header
    $('.js-account-toggle-data-header').on('click touch', function () {
      const header = $(this).closest('.apn-content-block').find('.apn-account-current-data');
      header.collapse('toggle');

      if (!header.prev().isInViewport()) {
        modules_aponeo.scrollTop(header.prev());
      }
    });

    const accordionForm = $('.form-shipping-address');

    if (accordionForm.length) {
      const $accordionFormCollapses = $('.collapse', accordionForm);

      $accordionFormCollapses
        .on('hide.bs.collapse', function (e) {
          $(this)
            .find(':input')
            .each(function () {
              $(this).prop('disabled', true);
            });
        })
        .on('shown.bs.collapse', function (e) {
          $(this)
            .find(':input')
            .each(function () {
              // is collapse was has this input visible? => important by nested collapse
              if ($(this).closest('.collapse').is(':hidden') === false) {
                $(this).prop('disabled', false);
              }
            });
        });

      // disable all collapsed input fields at startup
      $(':input', $accordionFormCollapses).each(function () {
        $(this).prop('disabled', true);
      });

      // Disable and handle Shipping-Toggle radios if customer is new
      if (accordionForm.hasClass('js-new-customer')) {
        const $newCustomerForm = $('#new-customer-location-form');
        const $shippingToggleRadios = $('input[type="radio"][id^="shipping-toggle"]');
        const $requiredInputs = $newCustomerForm.find('input[required]');
        // const requiredInputsVanilla = document
        //   .getElementById('new-customer-location-form')
        //   .querySelectorAll('input[required]');
        let isDisabled = [];

        $shippingToggleRadios.each((index, toggleRadio) => {
          const $toggleRadio = $(toggleRadio);
          const hasDisabledState = $toggleRadio.attr('disabled');

          if (typeof hasDisabledState !== 'undefined' && hasDisabledState !== false) {
            isDisabled.push('true');
          } else {
            isDisabled.push('false');
          }

          $toggleRadio.addClass('disabled').prop('disabled', true);
        });

        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            let $validInputs = $requiredInputs.filter('.is-valid');

            if ($requiredInputs.length === $validInputs.length) {
              $newCustomerForm.addClass('is-valid');
            }

            if ($newCustomerForm.hasClass('is-valid')) {
              $shippingToggleRadios.each((index, toggleRadio) => {
                const $toggleRadio = $(toggleRadio);
                if (isDisabled[index] === 'false') {
                  $toggleRadio.removeClass('disabled').prop('disabled', false);
                }
              });
            }
          });
        });

        observer.observe($newCustomerForm[0], {
          attributes: true,
          attributeFilter: ['class'],
        });

        $requiredInputs.each((index, input) => {
          observer.observe(input, {
            attributes: true,
            attributeFilter: ['class'],
          });
        });
      }

      $('.edit-link', accordionForm).on('click', function () {
        $($(this).data('inputselector')).prop('checked', true).change();
      });
    }

    // Resize page header after height changes
    $('#apn-header-search').on('hidden.bs.collapse shown.bs.collapse', function () {
      resizeHeader();
    });

    // Allow immediate input after showing search
    $('#apn-header-search').on('shown.bs.collapse', function () {
      $('#apn-header-search input[name="q"]').focus();
      // hide navigation
      if ($('#apn-main-navigation-off-canvas-wrapper').hasClass('off-canvas-opened')) {
        $('.js-toggle-off-canvas').click();
      }
    });

    // Resize Page header when document loaded
    $(document).ready(resizeHeader);
    $(window).resize(resizeHeader);

    $('._apn-teaser-close-remember').on('click touch', function () {
      if (_debug) {
        console.log('hide and remember teaser:' + $(this).data('target'));
      }

      $($(this).data('target')).hide(700, function () {
        resizeHeader();
      });

      if ($(this).data('target')) {
        setCookie('hideTeaser' + $(this).data('teaserid'), '1', 5, '/');
      }
    });

    $('.filter-item input').on('click touch', function () {
      if ($(this).data('url')) {
        window.location.href = $(this).data('url');
      } else if ($(this).data('base64')) {
        let jsLinkUrl = atob($(this).data('base64'));
        window.location.href = jsLinkUrl;
      }
    });

    if ($('._show_before').length) {
      $('._show_before').each(function (index, element) {
        console.log('vvvvvvvvvv');
        console.log($(this));

        let $showto = $(this).data('showtargetid');
        if ($('#' + $showto).length) {
          let $element = $(this).removeClass('_show_before').addClass('_show_before_show');
          $element.insertBefore('#' + $showto);
        }
      });
    }

    if ($('._show_after').length) {
      $('._show_after').each(function (index, element) {
        let $showto = $(this).data('showtargetid');

        if ($('#' + $showto).length) {
          let $element = $(this).removeClass('_show_after').addClass('_show_after_show');
          $element.insertAfter('#' + $showto);
        }
      });
    }

    $('._js_link').on('click touch', function (el) {
      const jsLinkUrl = $(this).data('url');

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl,
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
    });

    $('._js_link_blank').on('click touch', function (el) {
      // go to the same url without any GET-Params
      const jsLinkUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl + ' (blank)',
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
    });

    $('._js_link_external').on('click touch', function (el) {
      const jsLinkUrl = $(this).data('url');

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl + ' (external)',
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            window.open(jsLinkUrl);
          },
          eventTimeout: 2000,
        });
      } else {
        window.open(jsLinkUrl);
      }
    });

    $('._js_link64').on('click touch', function (el) {
      const jsLinkUrl = atob($(this).data('base64'));

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl,
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
    });

    $('._js_link64_external').on('click touch', function (el) {
      const jsLinkUrl = atob($(this).data('base64'));

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl + ' (external)',
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            window.open(jsLinkUrl);
          },
          eventTimeout: 2000,
        });
      } else {
        window.open(jsLinkUrl);
      }
    });

    $('._pdf_option_blank').on('click touch', function () {
      const formname = $(this).data('formname');
      $('form[name=' + formname + ']').submit();
    });

    $('#breadcrump_backicon').on('click touch', function () {
      // go to Back
    });

    // Hide empty recommendations container
    // select .recommendation with a child .swiper-wrapper that has no children
    $('.recommendations:has(.swiper-wrapper:not(:has(*)))').each(function () {
      $(this).hide();
    });

    // AJAX product slider
    $('.recommendations.apn-teaser[data-category]').each(function () {
      const params = {
        action: 'products',
        category: $(this).data('category'),
      };

      if ($(this).data('maxcount')) {
        params.maxcount = $(this).data('maxcount');
      }

      const self = this;

      // setup valid html structure
      if (!$('.swiper-wrapper', self).length) {
        $('.apn-teaser-product-slider', self).append(
          '<div class="swiper-container"><div class="swiper-wrapper"></div></div>',
        );
      }

      if (!$('.swiper-button-prev, .swiper-button-next', self).length) {
        $('.apn-teaser-product-slider', self).append(
          '<div class="swiper-button-prev d-none d-lg-block"></div>' +
            '<div class="swiper-button-next d-none d-lg-block"></div>',
        );
      }

      // save vars for the ajax callbacks
      const elem = $('.swiper-container', this);
      $.ajax({
        url: '/rpc.php',
        data: params,
        method: 'GET',
      }).done(function (response) {
        $('.swiper-wrapper', elem).html(response);

        if (!$('.swiper-wrapper > *', elem).length) {
          return; // got no products -- do not show swiper
        }

        $(self).show();

        const maxSlides = $(elem).hasClass(' max-slides-4') ? 4 : 5;
        const numberOfSlides = $(elem).children('.swiper-wrapper')[0].childElementCount;

        new Swiper(elem, {
          slidesPerView: 'auto',
          slidesPerGroup: maxSlides,
          breakpoints: {
            991: {
              slidesPerGroup: 1,
            },
          },
          navigation: {
            nextEl: $('.apn-teaser-product-slider .swiper-button-next', self),
            prevEl: $('.apn-teaser-product-slider .swiper-button-prev', self),
          },
        });

        if (numberOfSlides <= maxSlides) {
          $(elem).siblings('.swiper-button-next').removeClass('d-lg-block');
          $(elem).siblings('.swiper-button-prev').removeClass('d-lg-block');
        }

        // equalizer setup after adding content
        setSameHeight(elem, '.apn-product-list-item-header');

        leaflet_addToLeafletFunctions();
        basket_addToBasketFunctions();
        addDetailLinkFunctions();
      });
    });

    $('#findorder_submit').click(function () {
      // $(this).prop('disabled', true);

      const orderid = $('#findorder_id').val();
      console.log('Suche nach' + orderid);

      if (orderid.length > 2) {
        // $('findorder_submit').disable(true);
        $('#findorder_submit').attr('disabled', true);

        setCursor('wait');
        $.ajax({
          url: '/rpc.php?action=findorder_state',
          method: 'POST',
          data: {
            id: orderid,
          },
        }).done(function (response) {
          setCursor('default');
          console.log('mach wieder an!');
          // $(this).prop('disabled', true);

          console.log(response.html);
          if (response.success != false) {
            $('#findorder_response').html(response.html);
          } else {
            $('#findorder_response').html('');
          }

          $('#findorder_submit').attr('disabled', false);
        });
      } else {
        $('#findorder_response').html('<div class="txt-white">Bitte prüfen Sie Ihre Eingabe.</div>');
      }

      return false;
    });

    $('#findorder_page_submit').click(function () {
      // $(this).prop('disabled', true);

      const orderid = $('#findorder_id').val();
      console.log('Suche nach' + orderid);

      if (orderid.length > 2) {
        // $('findorder_submit').disable(true);
        $('#findorder_submit').attr('disabled', true);
        setCursor('wait');
        $('#findorder_response').hide(300);
        $('#findorder_response').html('');

        $.ajax({
          url: '/rpc.php?action=findorder_state&page=orderstate_check',
          method: 'POST',
          data: {
            id: orderid,
          },
        })
          .done(function (response) {
            setCursor('default');

            console.log(response.html);
            if (response.success != false) {
              $('#findorder_response').html(response.html);
            } else {
              $('#findorder_response').html('');
            }
          })
          .always(() => {
            $('#findorder_submit').attr('disabled', false);
            $('#findorder_response').show(300);
          });
      } else {
        $('#findorder_response').html('<div class="txt-white">Bitte prüfen Sie Ihre Eingabe.</div>');
      }

      return false;
    });
  });
}

;// ./build/shared/js/modules/megamenu.js
/* harmony default export */ var megamenu = ((menuSelector) => {
  if (typeof menuSelector == 'undefined') {
    menuSelector = '.js-navbar-megamenu';
  }
  if ($(menuSelector).length) {
    (($) => {
      const menu = $(menuSelector);
      const dropdownSelector = '.dropdown';
      const collapseSelector = '.js-mega-menu-links a';
      const dropdownSubMenuSelector = '.js-dropdown-submenu';
      const collapseLinks = menu.find(collapseSelector);
      const collapsedElements = menu.find('.collapse');

      let dropdownTimer;
      let collapseTimer;
      const showDelay = 200;
      const hideDelay = 300;

      collapsedElements.hide();

      $(menu).on('mouseenter', dropdownSelector, (e) => {
        clearTimeout(dropdownTimer);
        dropdownTimer = setTimeout(() => {
          const element = $(e.target);

          // show first collapse of dropdown
          $('.collapse:first-child', element.next('.dropdown-menu')).show();

          if (!element.closest(dropdownSelector).hasClass('show')) {
            element.dropdown('toggle');
          }
        }, showDelay);
      });

      $(menu).on('mouseleave', dropdownSelector, (e) => {
        clearTimeout(dropdownTimer);
        dropdownTimer = setTimeout(() => {
          const element = $(e.target);
          if (element.closest(dropdownSelector).hasClass('show')) {
            element.dropdown('toggle');
          }
          collapsedElements.hide();
          collapseLinks.removeClass('show').attr('aria-expanded', 'false');
        }, hideDelay);
      });

      $(menu).on('show.bs.dropdown', dropdownSelector, () => {
        clearTimeout(dropdownTimer);
      });

      $(menu).on('mouseenter', collapseSelector, (e) => {
        clearTimeout(collapseTimer);
        collapseTimer = setTimeout(() => {
          const element = $(e.target);
          if ('toggle' === element.data('toggle') && !element.hasClass('show') && element.data('target')) {
            collapsedElements.hide();
            collapseLinks.removeClass('show').attr('aria-expanded', 'false');
            element.addClass('show').attr('aria-expanded', 'true');
            $(element.data('target')).show();
          }
        }, showDelay);
      });

      $(menu).on('mouseenter', dropdownSubMenuSelector, () => {
        clearTimeout(collapseTimer);
      });

      // Try to give a clickable Megamenue headline
      let meagaclick = true;
      $(menu)
        .find('> .dropdown > a')
        .on('touchstart', () => {
          meagaclick = false;
        });
      $(menu)
        .find('> .dropdown > a')
        .on('touchmove', () => {
          meagaclick = true;
        });
      $(menu)
        .find('> .dropdown > a')
        .on('click', (event) => {
          if (meagaclick) {
            location.href = $(event.target).attr('href');
          }
        });
    })(jQuery);
  }
});
__webpack_require__.dn(megamenu);

;// ./build/shared/js/modules/packstation.js
__webpack_require__.dn(packstation);



/* harmony default export */ function packstation() {
  /**
   * Packstation finder for customer addresses
   */
  (function ($) {
    /** @class Finder */
    function Finder(form, result, resultContainer, action, trigger, modal) {
      this.form = form;
      this.result = result;
      this.resultContainer = resultContainer;
      this.ajax_action = action;
      this.dialog = modal;
      this.busy = false;

      //Search-Button Text for wording changes through the process
      this.buttonText = $('button', this.resultContainer).text();
      this.buttonLastWord = this.buttonText.split(' ').pop();
      this.lastIndex = this.buttonText.lastIndexOf(' ');
      this.buttonFirstWords = this.buttonText.substring(0, this.lastIndex);

      const self = this;
      form.on('submit', function () {
        self.search();
        self.dialog.one('hidden.bs.modal', function () {
          self.loadScreen(true);
        });
        $('button', self.resultContainer).html(self.buttonFirstWords + ' ' + self.buttonLastWord);
        return false;
      });
      result.on('click', 'label', function (event) {
        if (!self.result.data('selected')) {
          const elem = $('#' + this.htmlFor);
          const parent = elem.parent();
          /** todo refactor the AJAX result instead */
          // hide all immediate children of the container, but not the parent of the input and the next two elements
          $('> *', self.result).not(parent).not(parent.nextAll(':lt(2)')).hide();
          $(parent.nextAll(':lt(1)')).addClass('dhl-choice');
          // console.log($('button', self.resultContainer));
          // $('button', self.resultContainer).html(self.buttonFirstWords + ' ändernX');
          // $('button', self.resultContainer).removeClass('btn-primary');
          // $('button', self.resultContainer).addClass('btn-secondary');

          self.result.data('selected', true);
          modules_aponeo.scrollTop(self.result);
        } else {
          $('> *', self.result).show();
          self.result.data('selected', false);
        }
      });
      if (trigger) {
        trigger.one('show.bs.collapse', function () {
          self.search();
        });
      }
    }

    Finder.prototype = {
      search: function () {
        const form = this.form[0];
        const street = form.street.value;
        const houseNumberMatch = form.house_number.value.match(/[0-9]+/);
        const house_number = (houseNumberMatch && houseNumberMatch[0]) || 1; // the first element or a 1
        const post_code = form.postal_code.value;
        const city = form.city.value;
        const packstation = form.packstation.value;
        // only query if there is data
        if (street && house_number && post_code && city) {
          /** todo load screen */
          this.setIsBusy(true);
          this.dialog.modal('hide');
          const self = this;
          this._query(street, house_number, post_code, city, packstation)
            .always(function () {
              self.result.data('selected', false);
              self.resultContainer.show();
              self.busy = false;
              self.setIsBusy(false);
              self.loadScreen(false);
            })
            .fail(function () {
              self.result.html('<p>Es ist ein Fehler aufgetreten, bitte probieren Sie es später noch einmal.</p>');
            });
        }
        return null;
      },
      _query: function (street, house_number, post_code, city, current_packstation_id) {
        const self = this;
        const payload = [street, house_number, post_code, city].join('::');
        return $.ajax({
          url: '/rpc.php',
          data: {
            action: this.ajax_action,
            id: payload,
            street: street,
            zip: post_code,
            city: city,
            option: current_packstation_id,
          },
        }).done(function (response) {
          $('button', self.resultContainer).html(self.buttonFirstWords + ' ändern');
          $('button', self.resultContainer).removeClass('btn-primary');
          $('button', self.resultContainer).addClass('btn-secondary');
          console.log('AA##################################');
          console.log(street);
          console.log(response);
          console.log('AAA##################################');
          self.result.empty();
          // const update = response.split('|');
          // try {
          //   self.result.html(update[1]);
          // } catch (ex) {
          //   if (_debug) console.log(
          //       'Packstation finder error: unreadable response', ex, response);
          // }

          try {
            self.result.html(response.html);
          } catch (ex) {
            if (_debug) console.log('Packstation finder error: unreadable response', ex, response);
          }
        });
      },
      setIsBusy: function (state) {
        this.busy = true;
        return this;
      },
      loadScreen: function (show) {
        if (show) {
          loadingScreen_showLoadingScreen();
        } else {
          $('body').removeClass('loading');
        }
      },
    };
    /** factory function for packstationfinder
     *
     * @function Finder.packstation
     * @returns {Finder}
     */
    Finder.packstation = function () {
      return new Finder(
        $('#packstationfinder'),
        $('#ps_suche'),
        $('#packstation-result'),
        'ps_suche',
        $('#neue-packstation'),
        $('#packstationfinder-modal'),
      );
    };
    /** factory function for postfilialfinder
     *
     * @function Finder.postfiliale
     * @returns {Finder}
     */
    Finder.postfiliale = function () {
      return new Finder(
        $('#postfilialefinder'),
        $('#pf_suche'),
        $('#postfiliale-result'),
        'pf_suche',
        $('#neue-postfiliale'),
        $('#postfilialefinder-modal'),
      );
    };
    Finder.hermespaketshop = function () {
      return new Finder(
        $('#hpsfinder'),
        $('#hps_suche'),
        $('#hps-result'),
        'hps_suche',
        $('#neuer-paketshop'),
        $('#hpsfinder-modal'),
      );
    };

    if ($('#packstationfinder').length) {
      $('#packstationfinder').data('finder', Finder.packstation());
    }
    if ($('#postfilialefinder').length) {
      $('#postfilialefinder').data('finder', Finder.postfiliale());
    }
    if ($('#hpsfinder').length) {
      $('#hpsfinder').data('finder', Finder.hermespaketshop());
    }
  })(jQuery);
}

;// ./build/shared/js/modules/password.js
__webpack_require__.dn(modules_password);
/* harmony default export */ function modules_password() {
  // TODO check this when using es6 arrow functions

  // Make Password visible
  $('.js-show-pw').on('click touch', function () {
    $($(this).data('target')).attr('type') === 'password'
      ? $($(this).data('target')).attr('type', 'text')
      : $($(this).data('target')).attr('type', 'password');
  });

  (function ($) {
    /**
     * calculate a rough estimate of a passwords strength
     * @param {string} password
     * @return {int}
     */
    function _calculateScore(password) {
      let score = 0;
      //if password bigger than 6 give 1 point
      if (password.length >= 6) {
        score++;
      }
      //if password has both lower and uppercase characters give 1 point
      if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
        score++;
      }
      //if password has at least one number give 1 point
      if (password.match(/\d+/)) {
        score++;
      }
      //if password has at least one special character give 1 point
      if (password.match(/.[!,@#$%^&*?_~()-]/)) {
        score++;
      }
      //if password bigger than 12 give another 1 point
      if (password.length > 12) {
        score++;
      }
      return score;
    }

    /**
     * Custom jQuery plugin for a password strength check
     *
     * @function apnPasswordStrength
     * @memberOf jQuery.fn
     * @usage '$('#password').apnPasswordStrength([{message_elem: '#here-goes-the-output'}])
     * automatically set up for all input with a data-checkpasswordstrength="1" attribute
     * Output goes to the first found of:
     *   - the 'message_elem' in the options-object
     *   - the object in the 'data-passwordstrengthmessage'-attribute
     *   - an element with the id "<id-of-the-input>-strength"
     */
    $.fn.apnPasswordStrength = function (options) {
      const settings = $.extend(
        {
          descriptions: ['zu einfach', 'sehr einfach', 'einfach', 'mittel', 'stark', 'sehr stark'],
        },
        options,
      );
      return this.each(function () {
        const $self = $(this);
        let msg;
        if (settings.message_elem) {
          msg = settings.message_elem;
        } else if ($self.data('passwordstrengthmessage')) {
          msg = $self.data('passwordstrengthmessage');
        } else {
          msg = $('#' + this.id + '-strength');
        }
        $(this).on('keyup', function () {
          const score = _calculateScore($self.val());
          msg
            .html(settings.descriptions[score])
            .removeClass('strength0 strength1 strength2 strength3 strength4 strength5')
            .addClass('strength' + score)
            .show();
        });
      });
    };
    $('input[data-checkpasswordstrength]').apnPasswordStrength();
  })(jQuery);
}

;// ./build/shared/js/modules/pdpSkyWrapper.js
/**
 * PDP Sky-Wrapper scroll behaviour
 *
 * top = max(25px, 200px - scrollY)
 * → starts at 200px when at the top, slides up to 25px minimum while scrolling.
 *
 * Visibility: hidden when the content inside a wrapper exceeds the wrapper's
 * own width (i.e. the available side space is too narrow for the content).
 */
/* harmony default export */ var pdpSkyWrapper = (() => {
  const $skyWrappers = $('.pdp-sky-wrapper');
  if (!$skyWrappers.length) {
    return;
  }

  const updateSkyWrapperState = () => {
    const top = Math.max(25, 200 - window.scrollY);
    $skyWrappers.css('top', top + 'px');
  };

  const updateSkyWrapperVisibility = () => {
    $skyWrappers.each((_, wrapper) => {
      // Temporarily reset justify-content so all content starts at the
      // left edge – this ensures scrollWidth reliably reflects overflow
      // (justify-content: flex-end causes negative overflow which
      // scrollWidth does not capture).
      const jc = wrapper.style.justifyContent;
      wrapper.style.justifyContent = 'flex-start';
      const overflows = wrapper.scrollWidth > wrapper.clientWidth;
      wrapper.style.justifyContent = jc;

      $(wrapper).css('visibility', overflows ? 'hidden' : '');
    });
  };

  // Set initial states
  updateSkyWrapperState();
  updateSkyWrapperVisibility();

  window.addEventListener('scroll', updateSkyWrapperState, { passive: true });
  window.addEventListener('resize', updateSkyWrapperVisibility, {
    passive: true,
  });

  // Re-check visibility when teaser content is injected asynchronously
  const observer = new MutationObserver(updateSkyWrapperVisibility);
  $skyWrappers.each((_, wrapper) => {
    observer.observe(wrapper, { childList: true, subtree: true });
  });
});
__webpack_require__.dn(pdpSkyWrapper);

;// ./build/shared/js/modules/photoswipe.js



/* harmony default export */ var photoswipe = (() => {
  const $pswpContainer = $(
    '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"><div class="pswp__top-bar"><div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button><button class="pswp__button pswp__button--share" title="Share"></button><button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button><button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button><div class="pswp__preloader"><div class="pswp__preloader__icn"><div class="pswp__preloader__cut"><div class="pswp__preloader__donut"></div></div></div></div></div><div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"><div class="pswp__share-tooltip"></div></div><button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button><button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button><div class="pswp__caption"><div class="pswp__caption__center"></div></div></div></div></div>',
  );

  // Helper function to create video element for PhotoSwipe
  const createVideoElement = (src, videoId, poster) => {
    return `<div class="pswp-video-wrapper" id="${videoId}-wrapper">
      <video id="${videoId}" controls muted preload="none" poster="${poster}">
        <source src="${src}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>`;
  };

  // Initialize PhotoSwipe with both images and videos
  const initiatePhotoSwipe = ($zoomImages, $videoItems = []) => {
    const openPhotoSwipe = (index) => {
      const options = {
        index: index,
        bgOpacity: 0.75,
        shareEl: false,
        captionEl: false,
        // Add custom event handlers for videos
        listeners: {
          beforeChange: function () {
            // Pause all videos when navigating between items
            $('.pswp-video-wrapper video').each(function () {
              if (!this.paused) {
                this.pause();
              }
            });
          },
        },
      };
      let items = [];

      if ($zoomImages.first().data('photoswipeConfig') === 'app-landing-page') {
        // only add 1 image
        items = [
          {
            html: '<img class="apn-landingpage-pop-up" src="/images/resplayout/app_landingpage_pop-up.jpg" alt="APONEO App jetzt im App Store gratis herunterladen!" />',
          },
        ];
      } else {
        // Add regular images
        $zoomImages.each((i, el) => {
          const elem = $(el);
          items.push({
            src: elem.data('photoswipeSrc'),
            w: elem.data('photoswipeDim'),
            h: elem.data('photoswipeDim'),
          });
        });

        // Add video items
        $videoItems.each((i, el) => {
          const elem = $(el);
          const videoSrc = elem.attr('href');
          const videoId = elem.data('video-id');
          const videoPoster = elem.data('poster');
          const width = elem.data('pswp-width') || 1280;
          const height = elem.data('pswp-height') || 720;

          items.push({
            html: createVideoElement(videoSrc, videoId, videoPoster, width, height),
            w: width,
            h: height,
            title: '', // Leerer Titel für Video-Element
          });
        });
      }

      const gallery = new PhotoSwipe($pswpContainer.get(0), PhotoSwipeUI_Default, items, options);

      // Fix für den Caption-Fehler
      gallery.listen('gettingData', function (index, item) {
        if (item.html && !item.title) {
          item.title = '';
        }
      });

      gallery.init();
    };

    $('body').append($pswpContainer);

    // Attach click handlers to images
    $zoomImages.each((i, el) => {
      $(el).on('click.Photoswipe', (event) => {
        event.preventDefault();
        openPhotoSwipe(i);
      });
    });

    // Attach click handlers to videos
    $videoItems.each((i, el) => {
      $(el).on('click.Photoswipe', (event) => {
        event.preventDefault();
        // Videos appear after all images
        openPhotoSwipe($zoomImages.length + i);
      });
    });

    // Prevent default browser behavior for video links
    $(document).on('click', '.pswp-video-item', function (e) {
      e.preventDefault();
    });
  };

  const loadPhotoswipe = ($zoomImages, $videoItems) => {
    const css = themeAssetUrl('css', 'photoswipe.css');
    $.loadStylesheet(css);
    $.cachedScript(themeAssetUrl('js', 'photoswipe.js'))
      .done(() => {
        initiatePhotoSwipe($zoomImages, $videoItems);
      })
      .fail((jqxhr, settings, exception) => {
        console.error('Fehler beim Laden von PhotoSwipe:', exception);
      });
  };

  $(document).ready(() => {
    const $zoomImages = $('.js-photoswipe-zoom');
    const $videoItems = $('.pswp-video-item');

    if ($zoomImages.length || $videoItems.length) {
      loadPhotoswipe($zoomImages, $videoItems);
    }
  });
});
__webpack_require__.dn(photoswipe);

;// ./build/shared/js/modules/productTeaser.js
/* harmony default export */ var productTeaser = (() => {
  var $productTeasers = $('.js-apn-teaser-product');
  if ($productTeasers.length) {
    (function ($) {
      function loadProductTeaser($productTeaser) {
        var productId = $productTeaser.attr('data-product-id'),
          productPos = $productTeaser.data('productPos');

        if (productId && productPos) {
          if ($productTeaser.data('xhr') !== undefined) {
            $productTeaser.data('xhr').abort();
          }

          $productTeaser.html(
            $(
              '<div class="spinner-balls"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
            ),
          );
          var xhr = $.ajax({
            url: '/rpc.php?action=recommendation',
            method: 'GET',
            data: {
              ids: productId,
              pos: productPos,
              eleid: '0',
            },
            success: function (response) {
              var $innerHtml = $(response.html);
              $productTeaser.html($innerHtml);
              $productTeaser.trigger('productTeaser:loaded');
              addToBasketFunctions();
              addToLeafletFunctions();
              addJsDetailLink();
            },
            error: function (request, textStatus, errorThrown) {
              if (request.statusText !== 'abort') {
                $productTeaser.remove();
              }
            },
          });
          $productTeaser.data('xhr', xhr);
        }
      }

      $productTeasers.each(function () {
        var observer = new MutationObserver(function (mutations, observer) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'data-product-id') {
              loadProductTeaser($(mutation.target));
            }
          });
        });
        observer.observe(this, { attributes: true });
        loadProductTeaser($(this));
      });
    })(jQuery);
  }
});
__webpack_require__.dn(productTeaser);

;// ./build/shared/js/modules/productdetail.js


/* harmony default export */ var productdetail = (() => {
  /** Alternative Packungsgrößen auf PDP**/
  $('#productdetail_altsizes').change((event) => {
    window.location.href = $(event.target).find(':selected').data('url');
  });

  /** Anchor on Product Detail Page opens dropdown kundenbewertung (#dropdown-product-info-5) target (only mobile)**/
  $('a[href="#Bewertungen"]').on('click', function () {
    $('#dropdown-product-info-5').collapse('show');
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $('#dropdown-product-info-5').offset().top,
      },
      2000,
    );
  });

  const $productDetailRatingWrapper = $('.product-detail-rating-wrapper');
  if ($productDetailRatingWrapper.length) {
    const labels = [
      'Bitte bewerten Sie das Produkt',
      'Gefällt mir gar nicht',
      'Gefällt mir nicht',
      'Nicht schlecht',
      'Gefällt mir',
      'Gefällt mir sehr',
    ];
    $productDetailRatingWrapper.each((index, element) => {
      const $wrapper = $(element);
      const $rating = $wrapper.find('.product-detail-rating');
      const $stars = $rating.find('.icon');
      const $label = $wrapper.find('.product-detail-rating-label');
      const $input = $wrapper.find('.product-detail-rating-input');

      $stars.each((i, elemI) => {
        $(elemI).on('click mouseenter', () => {
          $stars.removeClass('active');
          $stars.each((j, elemJ) => {
            $(elemJ).addClass('active');
            return j < i;
          });
          $input.val(1 + i);
          $label.text(labels[1 + i]);
        });
      });
    });
  }

  let $productPros = $('.apn-product-pros');
  if ($productPros.length) {
    $('.apn-product-pros-link', $productPros).on('click.mw', (e) => {
      if (window.matchMedia('screen and (max-width: 767px)').matches) {
        e.preventDefault();
      }
    });
  }

  if ($('#apn-product-ratings').length) {
    const sendRpcRequest = (action, id, option, callback) => {
      $.ajax({
        type: 'GET',
        url: '/rpc.php?action=' + action + '&id=' + id + '&option=' + option,
        beforeSend: () => {
          modules_aponeo.showLoadingScreen();
        },
      })
        .done((result) => {
          if (callback) {
            callback(result);
          }
        })
        .always(() => {
          modules_aponeo.hideLoadingScreen();
        });
    };
    // yes/no buttons
    $('#apn-product-ratings .apn-product-detail-rating .rating-info').each((index, element) => {
      const id = $(element).data('rating-id');
      const target = $(element).find('.rating-text');
      const btnUp = $(element).find('.btn-rating-up');
      const btnDown = $(element).find('.btn-rating-down');
      const ratingCallback = (result) => {
        target.text(result);
        btnUp.attr('disabled', 'disabled');
        btnDown.attr('disabled', 'disabled');
      };
      btnUp.on('click', () => {
        sendRpcRequest('productrating', id, 'up', ratingCallback);
      });
      btnDown.on('click', () => {
        sendRpcRequest('productrating', id, 'down', ratingCallback);
      });
    });
    // comment modal form
    $('#apn-product-ratings .apn-product-detail-rating .btn-comment-submit').on('click', (event) => {
      const $element = $(event.target);
      const form = $element.closest('form');
      const modal = $element.parents('.modal:first');
      const errorClass = 'is-invalid';
      $.ajax({
        type: 'POST',
        url: '/rpc.php?action=addProductRatingComment',
        data: form.serialize(),
        beforeSend: () => {
          modules_aponeo.showLoadingScreen();
        },
      })
        .done((result) => {
          modules_aponeo.addNotificationList(result.messages);
          modal.modal('hide');
          modules_aponeo.refreshCaptcha();
          window.scrollTo(0, $('#notification-lines').position().top);
        })
        .fail((xhr) => {
          if (xhr.responseJSON && xhr.responseJSON.validation_errors) {
            $(':input', form).removeClass(errorClass);
            $.each(xhr.responseJSON.validation_errors, (name) => {
              const element = form.find('[name="' + name + '"]');
              element.addClass(errorClass);
              if (name === 'sec') {
                modules_aponeo.refreshCaptcha();
              }
            });
          } else if (xhr.responseJSON && xhr.responseJSON.messages) {
            $('#rating-modal').modal('hide');
            modules_aponeo.addNotificationList(result.messages);
            modal.modal('hide');
            window.scrollTo(0, $('#notification-lines').position().top);
          } else {
            modules_aponeo.addNotification(
              'Beim Bewerten dieses Produkts ist ein Fehler aufgetreten. <br> Bitte versuchen Sie es später erneut.',
              1,
            );
            modal.modal('hide');
            window.scrollTo(0, $('#notification-lines').position().top);
          }
        })
        .always(() => {
          modules_aponeo.hideLoadingScreen();
        });
    });
    // rating modal form
    $('.btn-rating-submit').on('click', (event) => {
      const element = $(event.target);
      const form = element.closest('form');
      const modal = $('#rating-modal');
      const errorClass = 'is-invalid';

      $.ajax({
        type: 'POST',
        url: '/rpc.php?action=addProductRating',
        data: form.serialize(),
        beforeSend: () => {
          modules_aponeo.showLoadingScreen();
        },
      })
        .done((result) => {
          // close modal
          modal.modal('hide');
          modules_aponeo.refreshCaptcha();
          if (!result.messages) {
            return;
          }
          modules_aponeo.addNotificationList(result.messages);
          window.scrollTo(0, $('#notification-lines').position().top);
        })
        .fail((xhr) => {
          if (xhr.responseJSON && xhr.responseJSON.validation_errors) {
            $(':input', form).removeClass(errorClass);
            $.each(xhr.responseJSON.validation_errors, (name) => {
              const element = form.find('[name="' + name + '"]');
              element.addClass(errorClass);
              if (name === 'sec') {
                modules_aponeo.refreshCaptcha();
              }
            });
          } else if (xhr.responseJSON && xhr.responseJSON.messages) {
            modal.modal('hide');
            for (let i = 0, length = xhr.responseJSON.messages.length; i < length; i++) {
              const msgData = xhr.responseJSON.messages[i];
              modules_aponeo.addNotification(msgData[0], msgData[1]);
            }
            window.scrollTo(0, $('#notification-lines').position().top);
          } else {
            modal.modal('hide');
            modules_aponeo.addNotification(
              'Beim Bewerten dieses Produkts ist ein Fehler aufgetreten. <br> Bitte versuchen Sie es später erneut.',
              1,
            );
            window.scrollTo(0, $('#notification-lines').position().top);
          }
        })
        .always(() => {
          modules_aponeo.hideLoadingScreen();
        });
    });
  }
});
__webpack_require__.dn(productdetail);

;// ./build/shared/js/modules/productlist.js





/* harmony default export */ var productlist = (() => {
  // infinite scrolling product list
  if ($('#products-grid').length && window.apn_ajax_list) {
    (() => {
      const $window = $(window),
        productsElem = $('#products-grid');
      let sIndex = window.apn_ajax_list.page_size,
        pageSize = window.apn_ajax_list.page_size,
        isDataAvailable = true,
        hasScrolled = false,
        isBusy = false;

      // run the load handler every couple of ms instead of every pixel
      $(window).scroll(() => {
        hasScrolled = true;
      });
      window.setInterval(() => {
        if (!hasScrolled || isBusy || !isDataAvailable) {
          return;
        }

        hasScrolled = false;
        isBusy = true; // set busy state early

        // use bottom of the div as reference
        const top = productsElem.offset().top,
          bottom = productsElem.height(),
          triggerOffset = 500;
        if (top + bottom - triggerOffset > $window.scrollTop() + $window.height()) {
          isBusy = false; // reset busy when exit early
          return;
        }

        modules_aponeo.showLoadingScreen();
        $.ajax({
          type: 'GET',
          url:
            '/rpc.php?action=' +
            window.apn_ajax_list.model +
            '&start=' +
            sIndex +
            '&offset=' +
            pageSize +
            '&design=responsive',
        })
          .done((result) => {
            productsElem.append(result);

            sIndex = sIndex + pageSize;

            //When data is not available
            if (!result) {
              isDataAvailable = false;
            }
          })
          .always(() => {
            isBusy = false;
            modules_aponeo.hideLoadingScreen();
            leaflet_addToLeafletFunctions();
            basket_addToBasketFunctions();
            addDetailLinkFunctions();
          });
      }, 250);
    })();
  }

  /** Sortieren Select-Element in Produktlisten **/
  $('._product_ssort').change((event) => {
    window.location.href = $(event.target).find(':selected').data('value');
  });

  // Display Aponeo's Choice Batch
  const filterPopulatity = new RegExp('sort=0').exec(window.location.href);
  const filterActive = new RegExp('sort=').exec(window.location.href);
  const pagingActive = new RegExp('seite').exec(window.location.href);
  if ((filterPopulatity || !filterActive) && !pagingActive) {
    $('.col-12:nth-child(-1n + 2) > .apn-product-list-item--list .apn-product-list-item-advice').addClass(
      'js-apn-advice',
    );
  }

  /** Dropdown Filter Prevent Scrolling of Body **/
  const dropdownFilterButton = $('#dropdown-filter');
  if ($(dropdownFilterButton).length) {
    (() => {
      const body = $('body'),
        dropdownFilterContent = $('#dropdown-content-filter'),
        dropdownFilterCloseButtons = $('.js-close-dropdown-filter'),
        dropdownFilterOpenedClass = 'show',
        isLocked = 'isLocked';

      function toggleBodyLockOnClick() {
        $(dropdownFilterButton).on('click touch', () => {
          $(body).addClass(isLocked);
        });

        $(dropdownFilterCloseButtons).on('click touch', () => {
          $(body).removeClass(isLocked);
        });
      }

      if (window.innerWidth < 992) {
        toggleBodyLockOnClick();
      }

      $(window).resize(function () {
        if (window.innerWidth < 992) {
          toggleBodyLockOnClick();

          // prevent body from scrolling when filter is opened and viewport is smaller than 992 => especially when resizing down from viewports greater than 992
          if ($(dropdownFilterContent).hasClass(dropdownFilterOpenedClass)) {
            $(body).addClass(isLocked);
          }
        } else if (window.innerWidth >= 992) {
          // unbind click event on dropdownFilterButton that may got initialized on window width smaller than 992 beforehand to prevent locking the body
          // allow body to scroll as it should never be locked on window width greater than 992
          $(dropdownFilterButton).off('click touch');
          $(body).removeClass(isLocked);
        }
      });
    })();
  }

  /**
   * Fetch and place product variants on `partial_product_list_packagegroup.tpl`
   * when there is no concrete product loaded already
   */
  if ($('.productlist-combi_element.tab-pane').length) {
    $('.productlist-combi__navi [data-concrete-product-id]').on('click touch', (event) => {
      const $tabNavButton = $(event.target);
      const concreteProductId = $tabNavButton.data('concrete-product-id');
      const completeProductId = $tabNavButton.data('complete-product-id');
      const $productContentWrapper = $(`.productlist-combi_element[id=${completeProductId}]`);
      const $activeProduct = $('.productlist-combi_element.active.show');
      const activeProductHeight = $($tabNavButton.closest('.tab-content').find($activeProduct)).height();

      if (!$productContentWrapper.length || !concreteProductId || !completeProductId) return;

      // remove empty spaces inside $productContentWrapper div
      const $trimmedProductContentWrapper = $.trim($productContentWrapper.html());

      if (!$trimmedProductContentWrapper.length) {
        $.ajax({
          type: 'GET',
          url: `/rpc.php?action=productoverview&id=${concreteProductId}`,
          beforeSend: () => {
            // prevent layout shifts by adding height of currently active product
            $productContentWrapper.css('min-height', activeProductHeight);
            modules_aponeo.showLoadingScreen();
          },
        })
          .done((result) => {
            $productContentWrapper.html(result);
            $productContentWrapper.attr('data-loaded', true);
          })
          .always(() => {
            _initializeUIFunctions();
            modules_aponeo.hideLoadingScreen();
          });
      }
    });

    const _initializeUIFunctions = () => {
      leaflet_addToLeafletFunctions();
      basket_addToBasketFunctions();
      addDetailLinkFunctions();
    };
  }
});
__webpack_require__.dn(productlist);

;// ./build/shared/js/modules/radioToggle.js
__webpack_require__.dn(radioToggle);
/* harmony default export */ function radioToggle() {
  const $hiddenElement = $('.js-hidden');
  if ($hiddenElement.length) {
    setTimeout(() => {
      $hiddenElement.removeClass('js-hidden');
    }, 500);
  }

  const $radios = $('input[type="radio"][data-toggle="collapse"]');

  if ($radios.length) {
    $radios.each((index, element) => {
      const $radio = $(element);
      const $radioGroup = $(`[name="${$radio.attr('name')}"]`);
      const $collapseTarget = $($radio.data('target'));

      __toggleRadioTarget($radio, $collapseTarget);

      // Toggle on change
      $radioGroup.on('change', (event) => {
        const $changedRadio = $(event.delegateTarget);
        const $collapseTarget = $($radio.data('target'));
        const hasCollapseTarget = $changedRadio.data('target') !== undefined;

        // Disable radio: prevent multiple parallel runs
        if (hasCollapseTarget) {
          $changedRadio.prop('disabled', true);
        }

        __toggleRadioTarget($radio, $collapseTarget);

        // Re-enable checkbox
        if ($changedRadio.prop('disabled') === true) {
          $collapseTarget.on('shown.bs.collapse hidden.bs.collapse', () => {
            $changedRadio.prop('disabled', false);
          });
        }
      });
    });

    /**
     * @param {array} $radio
     * @param {array} $collapseTarget
     */
    function __toggleRadioTarget($radio, $collapseTarget) {
      // Important: init collapsible beforehand
      $collapseTarget.collapse({
        toggle: false,
      });

      if ($radio.prop('checked') === true) {
        $collapseTarget.on('show.bs.collapse', function (e) {
          e.stopPropagation();
        });
        $collapseTarget.collapse('show');
        $radio.attr('data-toggle', null);
      } else {
        $collapseTarget.on('hide.bs.collapse', function (e) {
          e.stopPropagation();
        });
        $collapseTarget.collapse('hide');
        $radio.attr('data-toggle', 'collapse');
      }
    }
  }
}

;// ./build/shared/js/modules/searchFlyoutState.js
// Reflect the Exorbyte search flyout state on the body element.
const SEARCH_OPEN_CLASS = 'search-is-open';
const SCROLLBAR_WIDTH_PROPERTY = '--scrollbar-width';

function initSearchFlyoutState() {
  const observer = new MutationObserver(() => {
    const flyout = document.querySelector('.exsg_box');
    const isOpen = Boolean(flyout) && getComputedStyle(flyout).display === 'block';

    document.body.classList.toggle(SEARCH_OPEN_CLASS, isOpen);

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (isOpen && scrollbarWidth > 0) {
      document.body.style.setProperty(SCROLLBAR_WIDTH_PROPERTY, `${scrollbarWidth}px`);
    } else {
      document.body.style.removeProperty(SCROLLBAR_WIDTH_PROPERTY);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
}

;// ./build/shared/js/modules/select-box.js
__webpack_require__.dn(select_box);
/* harmony default export */ function select_box() {
  const $selectBoxes = $('.js-select-box');

  $selectBoxes.each(function () {
    const $placeholder = $(this).find('option[disabled]');

    if (!$placeholder.has('[selected]')) {
      $(this).addClass('has-selection');
    }
  });

  $selectBoxes.on('click', function () {
    const optionsArray = this.options;

    if (optionsArray.selectedIndex !== 0) {
      $(this).addClass('has-selection');
    }
  });
}

;// ./build/shared/js/modules/stickyCartFlyout.js


const ROOT_SELECTOR = '.js-sticky-cart-flyout';
const BUY_BOX_FORM_SELECTOR = 'form[name="form_warenkorb"]';
const BUY_BOX_TRIGGER_SELECTOR = '[data-sticky-cart-flyout-trigger]';

const HEADER_SELECTOR = '.header';
const APP_INSTALL_BANNER_SELECTOR = '#apn-app-install';
const CLASS_HEADROOM_UNPINNED = 'headroom--unpinned';

const CLASS_VISIBLE = 'sticky-cart-flyout--visible';
const CLASS_NO_TRANSITION = 'sticky-cart-flyout--no-transition';

/**
 * Show/hide the sticky cart flyout.
 *
 * @param {HTMLElement} flyout
 * @param {boolean} visible
 * @param {boolean} animate
 */
function setFlyoutVisible(flyout, visible, animate = true) {
  if (!animate) {
    flyout.classList.add(CLASS_NO_TRANSITION);
  }

  flyout.classList.toggle(CLASS_VISIBLE, visible);
  flyout.setAttribute('aria-hidden', visible ? 'false' : 'true');
  flyout.inert = !visible;

  if (!animate) {
    flyout.getBoundingClientRect();
    flyout.classList.remove(CLASS_NO_TRANSITION);
  }
}

/**
 * Calculates the vertical pixel height of sticky elements currently occluding
 * the top of the viewport (e.g., sticky headers and app install banners).
 *
 * Used to shrink the IntersectionObserver root viewport so elements hidden
 * UNDER sticky overlays are treated as out-of-view (e.g. underneath the header).
 *
 * @returns {number}
 */
function getTopOcclusionHeight() {
  let height = 0;
  const header = document.querySelector(HEADER_SELECTOR);

  // The header only covers content while it is fixed,
  // and only when not translated off screen by headroom.
  if (header && getComputedStyle(header).position === 'fixed' && !header.classList.contains(CLASS_HEADROOM_UNPINNED)) {
    height = header.getBoundingClientRect().height;
  }

  // The app install banner is a sibling of the header, not a child.
  const appInstallBanner = document.querySelector(APP_INSTALL_BANNER_SELECTOR);

  if (appInstallBanner) {
    // Uses `bottom` coordinate because the banner might be partially scrolled off-screen
    // or translated upward (yielding a negative/zero bottom position when hidden/dismissed).
    height = Math.max(height, appInstallBanner.getBoundingClientRect().bottom);
  }

  return Math.max(0, Math.round(height));
}

/**
 * Notify when the overlaying elements at the top of the viewport change, i.e.
 * when headroom pins/unpins the header, when the header or banner is resized
 * or when the viewport changes.
 *
 * @param {() => void} onChange
 */
function watchTopOcclusion(onChange) {
  const header = document.querySelector(HEADER_SELECTOR);
  const appInstallBanner = document.querySelector(APP_INSTALL_BANNER_SELECTOR);
  const elements = [header, appInstallBanner].filter(Boolean);

  if (elements.length > 0) {
    const classObserver = new MutationObserver(onChange);

    for (const element of elements) {
      classObserver.observe(element, { attributes: true, attributeFilter: ['class'] });
    }

    // Catches size changes without a window resize, e.g. a dismissed announcement bar
    if (typeof ResizeObserver === 'function') {
      const sizeObserver = new ResizeObserver(onChange);

      for (const element of elements) {
        sizeObserver.observe(element);
      }
    }
  }

  window.addEventListener('resize', onChange);
}

/**
 * Controls the visibility of the sticky cart flyout based on whether the
 * primary buy box action is visible in the unoccluded viewport area.
 *
 * @param {HTMLElement} flyout
 */
function initVisibilityObserver(flyout) {
  const buyBoxForm = document.querySelector(BUY_BOX_FORM_SELECTOR);
  const trigger = buyBoxForm?.querySelector(BUY_BOX_TRIGGER_SELECTOR);
  const observedElement = trigger || buyBoxForm;

  if (!observedElement) {
    return;
  }

  let isFirstUpdate = true;
  let showTimeout;
  let observer;
  let occlusionHeight;

  const observerCallback = (entries) => {
    for (const entry of entries) {
      window.clearTimeout(showTimeout);

      if (entry.isIntersecting) {
        // The main button came into view -> hide the bar immediately
        setFlyoutVisible(flyout, false, !isFirstUpdate);
      } else if (isFirstUpdate) {
        // Page load with the main button out of view -> show without animating
        setFlyoutVisible(flyout, true, false);
      } else {
        // The main button left the viewport -> show again after a short delay
        showTimeout = window.setTimeout(() => setFlyoutVisible(flyout, true), 150);
      }

      isFirstUpdate = false;
    }
  };

  // The root margin can only be set on creation, so we have to recreate the
  // observer whenever the overlay at the top of the viewport changes.
  const createObserver = () => {
    const nextOcclusionHeight = getTopOcclusionHeight();

    if (observer && nextOcclusionHeight === occlusionHeight) {
      return;
    }

    occlusionHeight = nextOcclusionHeight;

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(observerCallback, {
      threshold: 0,
      rootMargin: occlusionHeight > 0 ? `-${occlusionHeight}px 0px 0px 0px` : '0px',
    });

    observer.observe(observedElement);
  };

  let pendingRefresh;
  const scheduleCreateObserver = () => {
    window.cancelAnimationFrame(pendingRefresh);
    pendingRefresh = window.requestAnimationFrame(createObserver);
  };

  createObserver();
  watchTopOcclusion(scheduleCreateObserver);
}

/**
 * Keep the bar's quantity stepper in sync with the buy box amount input.
 * Clicking the flyout buttons forwards to the buy box controls so the existing
 * amount/tier-price handling (and its events) stays the single source of truth.
 *
 * @param {HTMLElement} flyout
 */
function initQuantitySync(flyout) {
  const amountInput = flyout.querySelector('.js-sticky-cart-flyout__amount-input');
  const minusButton = flyout.querySelector('.js-sticky-cart-flyout__amount-minus');
  const plusButton = flyout.querySelector('.js-sticky-cart-flyout__amount-plus');

  const buyBoxForm = document.querySelector(BUY_BOX_FORM_SELECTOR);
  const buyBoxInput = buyBoxForm?.elements?.['amnt'] || document.querySelector('.js-amount__input');

  if (!amountInput || !buyBoxInput) {
    return;
  }

  const getMin = () => parseInt(amountInput.min, 10) || 1;
  const getMax = () => parseInt(amountInput.max, 10) || Number.MAX_SAFE_INTEGER;
  const clamp = (value) => Math.min(Math.max(value, getMin()), getMax());

  const updateButtonStates = () => {
    const value = parseInt(amountInput.value, 10) || getMin();

    if (minusButton) {
      minusButton.disabled = value <= getMin();
    }

    if (plusButton) {
      plusButton.disabled = value >= getMax();
    }
  };

  const syncFromBuyBox = () => {
    const value = parseInt(buyBoxInput.value, 10);

    if (!Number.isNaN(value)) {
      amountInput.value = value;
      amountInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    updateButtonStates();
  };

  const changeQuantity = (direction) => {
    const buyBoxMinus = buyBoxForm?.querySelector('.js-amount__btn--minus');
    const buyBoxPlus = buyBoxForm?.querySelector('.js-amount__btn--plus');

    if (direction < 0 && buyBoxMinus) {
      buyBoxMinus.click();
      return;
    }

    if (direction > 0 && buyBoxPlus) {
      buyBoxPlus.click();
      return;
    }

    // Fallback for if the buy box buttons could not be found, but shouldn't happen.
    buyBoxInput.value = clamp((parseInt(buyBoxInput.value, 10) || 1) + direction);
    buyBoxInput.dispatchEvent(new Event('input', { bubbles: true }));
    buyBoxInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  if (minusButton) {
    minusButton.addEventListener('click', () => changeQuantity(-1));
  }

  if (plusButton) {
    plusButton.addEventListener('click', () => changeQuantity(1));
  }

  amountInput.addEventListener('change', () => {
    buyBoxInput.value = clamp(parseInt(amountInput.value, 10) || 1);
    buyBoxInput.dispatchEvent(new Event('change', { bubbles: true }));
    syncFromBuyBox();
  });

  buyBoxInput.addEventListener('input', syncFromBuyBox);
  buyBoxInput.addEventListener('change', syncFromBuyBox);

  syncFromBuyBox();
}

/**
 * Update the displayed total savings for the selected quantity.
 *
 * Savings = (reference price - current unit price) x quantity. Tier/BMSM discounts
 * are already part of the current unit price, so they are included implicitly.
 *
 * @param {HTMLElement} flyout
 */
function initSavingsSync(flyout) {
  const savingsWrapper = flyout.querySelector('.js-sticky-cart-flyout__savings');
  const savingsValue = flyout.querySelector('.js-sticky-cart-flyout__savings-value');
  const priceElement = flyout.querySelector('.js-tier-price-display');
  const amountInput = flyout.querySelector('.js-sticky-cart-flyout__amount-input');
  const referencePrice = parseFloat(flyout.dataset.referencePrice);

  if (!savingsWrapper || !savingsValue || !priceElement) {
    return;
  }

  const updateSavings = () => {
    const unitPrice = parsePrice(priceElement.textContent);
    const fallbackPrice = parseFloat(flyout.dataset.unitPrice);
    const currentPrice = Number.isNaN(unitPrice) ? fallbackPrice : unitPrice;
    const quantity = parseInt(amountInput?.value, 10) || 1;

    if (Number.isNaN(referencePrice) || Number.isNaN(currentPrice) || referencePrice <= currentPrice) {
      savingsWrapper.hidden = true;
      return;
    }

    const savings = (referencePrice - currentPrice) * quantity;
    savingsValue.textContent = `${savings.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
    savingsWrapper.hidden = false;
  };

  // The unit price element is updated by tierPriceUpdater, so react to DOM changes
  new MutationObserver(updateSavings).observe(priceElement, {
    childList: true,
    characterData: true,
    subtree: true,
  });

  if (amountInput) {
    amountInput.addEventListener('input', updateSavings);
    amountInput.addEventListener('change', updateSavings);
  }

  updateSavings();
}

function stickyCartFlyout() {
  const flyout = document.querySelector(ROOT_SELECTOR);

  if (!flyout) {
    return;
  }

  initVisibilityObserver(flyout);
  initQuantitySync(flyout);
  initSavingsSync(flyout);

  // Make sure the bar's own add-to-cart button is bound to the global handler
  if (typeof window.addToBasketFunctions === 'function') {
    window.addToBasketFunctions();
  }
}

;// ./build/shared/js/modules/tierPriceUpdater.js




/**
 * Find the amount input element on the page
 *
 * @returns {HTMLInputElement|null} The amount input element or null if not found
 */
function findAmountInput() {
  // 1. First try form-based (aponeo_de style)
  let amountInput = document.forms['form_warenkorb']?.elements['amnt'];

  // 2. If not found, search by class
  if (!amountInput) {
    amountInput = document.querySelector('.js-amount__input');
  }

  // 3. Fallback: search by name
  if (!amountInput) {
    amountInput = document.querySelector('input[name="amnt"]');
  }

  return amountInput || null;
}

/**
 * Find the current tier based on quantity
 * @param {number} quantity - The selected quantity
 * @returns {object|null} The matching tier or null if none found
 */
function findCurrentTier(quantity) {
  let currentTier = productPriceTiers[0];
  let highestMatchingAmount = -1;

  for (const tier of productPriceTiers) {
    if (quantity >= tier.amount && tier.amount > highestMatchingAmount) {
      currentTier = tier;
      highestMatchingAmount = tier.amount;
    }
  }

  if (!currentTier) {
    if (_DEBUG) console.log('no tier found for amount:', quantity);
    return null;
  }

  return currentTier;
}

/**
 * Update the DOM with tier information
 * @param {object} tier - The tier object with price and savings data
 * @param {number} amount - The selected quantity
 */
function updateTierDisplay(tier, amount) {
  const pdpProductSaleprice = tier.saleprice.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Update all price elements
  const priceElements = document.querySelectorAll('.js-tier-price-display');
  if (priceElements.length > 0) {
    for (const element of priceElements) {
      element.textContent = `${pdpProductSaleprice} €`;
    }

    if (_DEBUG) console.log('Updated price elements:', priceElements);
  } else if (_DEBUG) {
    if (_DEBUG) console.warn('Could not find price elements with class .js-tier-price-display');
  }

  // Update all baseprice elements
  const basepriceElements = document.querySelectorAll('.js-baseprice-info');
  if (basepriceElements.length > 0) {
    if (tier.baseprice !== undefined) {
      for (const element of basepriceElements) {
        element.textContent = tier.baseprice;
      }
    }

    if (_DEBUG) console.log('Updated baseprice elements:', basepriceElements);
  } else {
    if (_DEBUG) console.warn('Could not find baseprice elements with class .js-baseprice-info');
  }

  // Update tier saving percent spans
  const savingPercentElements = document.querySelectorAll('.js-tier-saving-percent');
  if (savingPercentElements.length > 0) {
    if (tier.saving_additional_percent !== undefined) {
      const value = parseFloat(tier.saving_additional_percent);
      const precision = value < 0.5 ? 1 : 0;

      const formattedSavingPercent = value.toLocaleString('de-DE', {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });

      for (const element of savingPercentElements) {
        element.textContent = `-${formattedSavingPercent}%`;
      }
    } else {
      for (const element of savingPercentElements) {
        element.textContent = '';
      }
    }

    if (_DEBUG) console.log('Updated saving percent elements:', savingPercentElements);
  } else if (_DEBUG) {
    if (_DEBUG) console.warn('Could not find saving percent elements with class .js-tier-saving-percent');
  }

  // Update tier saving value spans
  const savingValueElements = document.querySelectorAll('.js-tier-saving-value-display');
  if (savingValueElements.length > 0) {
    for (const element of savingValueElements) {
      if (typeof tier.saving_additional_euro === 'undefined' || tier.saving_additional_euro === 0) {
        element.textContent = '';
        continue;
      }

      const totalSaving = tier.saving_additional_euro * amount;

      const formattedSavingValue = totalSaving.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      element.textContent = `${formattedSavingValue} €`;
    }

    if (_DEBUG) console.log('Updated saving value elements:', savingValueElements);
  } else {
    if (_DEBUG) console.warn('Could not find saving value elements with class .js-tier-saving-value-display');
  }
}

/**
 * Update the price display when tier is selected based on quantity
 *
 * @param {number} amount - The selected quantity
 */
function updateTierDetails(amount) {
  if (_DEBUG) console.log('--->showTierInformation for amount:', amount);

  if (typeof productPriceTiers === 'undefined') {
    if (_DEBUG) console.log('no tiers found');
    return;
  }

  const currentTier = findCurrentTier(amount);

  if (!currentTier) {
    return;
  }

  if (_DEBUG) console.log('current tier:', currentTier);
  if (_DEBUG) console.log('saleprice:', currentTier.saleprice);

  updateTierDisplay(currentTier, amount);

  if (_DEBUG) console.log('tier starts:', currentTier.amount);
  if (_DEBUG) console.log('saving_percent against UVP/ARP:', currentTier.saving_percent);
  if (_DEBUG) console.log('saving_percent extra:', currentTier.saving_additional_percent);
  if (_DEBUG) console.log('saving_euro extra:', currentTier.saving_additional_euro);
  if (_DEBUG) console.log('--->Eof showTierInformation for amount:', amount);
}

/**
 * Update the active tier button based on the current amount
 * Marks the highest tier button whose data-amount is <= current amount as active
 *
 * @param {number} amount - The current quantity
 */
function updateActiveTierButton(amount) {
  const tierButtons = document.querySelectorAll('.js-tier-btn');

  if (tierButtons.length === 0) {
    if (_DEBUG) console.log('updateActiveTierButton: no tier buttons found');
    return;
  }

  let activeTierButton = null;
  let highestMatchingAmount = -1;

  for (const button of tierButtons) {
    const tierAmount = parseInt(button.dataset.amount, 10);
    if (!isNaN(tierAmount) && amount >= tierAmount && tierAmount > highestMatchingAmount) {
      activeTierButton = button;
      highestMatchingAmount = tierAmount;
    }
  }

  if (_DEBUG) console.log('updateActiveTierButton: highest matching amount:', highestMatchingAmount);

  for (const button of tierButtons) {
    button.classList.remove('active');
  }

  if (activeTierButton) {
    activeTierButton.classList.add('active');
    if (_DEBUG) console.log('updateActiveTierButton: activated button for tier:', highestMatchingAmount);
  }
}

/**
 * Fetch product detail and dispatch custom event
 * @param {string|number} productId - The product ID
 * @param {number} amount - The requested quantity
 * @param {AbortSignal} signal - AbortSignal to cancel the request
 */
async function fetchAndDispatchProductDetail(productId, amount, signal) {
  if (!productId) {
    return;
  }

  try {
    document.dispatchEvent(
      new CustomEvent('product-detail-update-start', {
        detail: { productId, amount },
      }),
    );

    if (_DEBUG) console.log(`tierPriceUpdater: fetching product detail (${productId}) for amount: ${amount}`);

    const result = await fetchProductDetail(productId, amount, signal);

    document.dispatchEvent(
      new CustomEvent('product-detail-update', {
        detail: { productId, amount, result },
      }),
    );

    if (_DEBUG) console.log('tierPriceUpdater: product detail event dispatched');
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.error('tierPriceUpdater: error fetching product detail:', error);

      document.dispatchEvent(
        new CustomEvent('product-detail-update-error', {
          detail: { error },
        }),
      );
    } else if (_DEBUG) {
      console.log('tierPriceUpdater: product detail fetch aborted');
    }
  }
}

/**
 * Update the shipping cost text when product detail updates occur
 */
function setupShippingCostTextListener() {
  const shippingCostElement = document.querySelector('.js-shipping-cost-text');

  if (!shippingCostElement) {
    if (_DEBUG) console.log('setupShippingCostTextListener: shipping cost element not found');
    return;
  }

  const freeShippingThreshold = parseFloat(shippingCostElement.dataset.freeShippingThreshold) + 0.01;
  const templateText = shippingCostElement.dataset.shippingCostTextTemplate; // "Versandkostenfrei ab %1s"
  const freeText = shippingCostElement.dataset.shippingCostTextFree; // "Versandkostenfrei"

  const isFreeshippingUnlocked = shippingCostElement.dataset.isFreeShipping === 'true';
  const cartSubtotal = parseFloat(shippingCostElement.dataset.cartSubtotal) || 0;

  const applyDefaultState = () => {
    if (!isNaN(freeShippingThreshold) && templateText) {
      const formattedThreshold = freeShippingThreshold.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      shippingCostElement.innerHTML = `${templateText.replace('%1s', formattedThreshold)} €`;
      shippingCostElement.dataset.isFreeShipping = 'false';
    } else {
      shippingCostElement.innerHTML = 'Fehler beim Berechnen der Versandkosten';
      shippingCostElement.dataset.isFreeShipping = 'false';
    }
  };

  const hasTiers = typeof productPriceTiers !== 'undefined' && productPriceTiers.length > 1;

  if (hasTiers) {
    // Handle tiers case: listen to product detail update event

    document.addEventListener('product-detail-update-start', () => {
      insertDotLoaderElement(shippingCostElement);
    });

    document.addEventListener('product-detail-update', (event) => {
      const { result, amount } = event.detail;

      if (result?.ProdDetailVersandkostenfreiText && result?.ProdDetailVersandkostenfrei !== undefined) {
        shippingCostElement.innerHTML = result.ProdDetailVersandkostenfreiText;
        shippingCostElement.dataset.isFreeShipping = result.ProdDetailVersandkostenfrei ? 'true' : 'false';
      }
    });

    document.addEventListener('product-detail-update-error', () => {
      applyDefaultState();
    });
  } else {
    // Handle no-tiers case: simple shipping cost calculation based on total price
    const amountInput = findAmountInput();

    if (!amountInput) {
      return;
    }

    if (isNaN(freeShippingThreshold) || !templateText || !freeText) {
      if (_DEBUG) {
        console.warn('setupShippingCostTextListener: missing data attributes', {
          threshold: freeShippingThreshold,
          templateText,
          freeText,
        });
      }

      return;
    }

    const updateShippingText = () => {
      const amount = parseInt(amountInput?.value, 10) || 1;
      const priceElement = document.querySelector('.js-tier-price-display');

      if (!priceElement) {
        return;
      }

      const price = parsePrice(priceElement.textContent);

      if (isNaN(price)) {
        return;
      }

      const productTotal = price * amount;
      const totalCartValue = cartSubtotal + productTotal;

      if (totalCartValue >= freeShippingThreshold || isFreeshippingUnlocked) {
        shippingCostElement.innerHTML = freeText;
        shippingCostElement.dataset.isFreeShipping = 'true';
      } else {
        applyDefaultState();
      }
    };

    amountInput.addEventListener('change', updateShippingText);
  }

  const renderDefaultText = (el, template, threshold) => {
    const formattedThreshold = threshold.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    el.innerHTML = template.replace('%1s', formattedThreshold) + ' €';
  };
}

/**
 * Initialize tier price updater
 * Listens for amount input changes and updates the price display
 */
function initTierPriceUpdater() {
  const amountInput = findAmountInput();

  if (!amountInput) {
    if (_DEBUG) console.log('tierPriceUpdater: amount-input not found');
    return;
  }

  if (_DEBUG) console.log('tierPriceUpdater: amount-input found');

  const productId = document.getElementById('abskt')?.dataset.internalId;
  const abortControllerRef = { current: null };

  const debouncedFetchProductDetail = debounce((amount) => {
    if (!productId) {
      return;
    }

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    abortControllerRef.current = new AbortController();
    fetchAndDispatchProductDetail(productId, amount, abortControllerRef.current.signal);
  }, 300);

  const onAmountValueChanged = () => {
    const amount = parseInt(amountInput.value, 10) || 1;
    updateTierDetails(amount);
    updateActiveTierButton(amount);
    debouncedFetchProductDetail(amount);
  };

  amountInput.addEventListener('change', onAmountValueChanged);

  setupShippingCostTextListener();
}

// EXTERNAL MODULE: ./build/shared/js/plugins/zeynepjs/zeynep.js
var zeynep = __webpack_require__(625);
;// ./build/sparmed_de/js/sliders.js



//-----------------------------------
// ### Sliders ###
//------------------------------------

// Global Sliders Array
const sliders = [];

// Initiate Sliders if present on page
function sliders_initiateSliders() {
  if ($('.swiper-container').length === 0) {
    return;
  }

  loadSwiper().done(() => {
    // Big slider on e.g. start page
    if ($('.teaser-hero-slider').length) {
      $('.teaser-hero-slider .swiper-container').each((index, element) => {
        let compagnion_slider = null;
        if ($(element).parents('.with-compagnion').length) {
          const $sharedParent = $(element).closest('.row');
          const $compagnionSlider = $('.compagnion-wrapper .swiper-container', $sharedParent);
          if ($compagnionSlider.length) {
            compagnion_slider = new Swiper($compagnionSlider, {
              loop: true,
              allowTouchMove: false,
              preventClicks: false,
            });
          }
        }

        let initialized = false;
        const teaser_hero_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          on: {
            init: function () {
              initialized = true;
            },
            slideNextTransitionStart: function () {
              if (compagnion_slider && initialized) {
                compagnion_slider.slideNext();
              }
            },
            slidePrevTransitionStart: function () {
              if (compagnion_slider && initialized) {
                compagnion_slider.slidePrev();
              }
            },
          },
        });
      });
    }

    // Banner slider on e.g. start page
    if ($('.teaser-banner-slider').length) {
      $('.teaser-banner-slider .swiper-container').each((index, element) => {
        const teaser_banner_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
        });
      });
    }

    // Slider on Product Detail Page
    let productDetailSliders = [];
    if ($('.product-detail-slider').length) {
      $('.product-detail-slider .swiper-container').each(function (index, element) {
        const product_detail_slider = new Swiper($('.product-detail-slider .swiper-container')[index], {
          pagination: {
            el: $('.product-detail-slider .swiper-pagination')[index],
            type: 'bullets',
            clickable: true,
          },
          on: {
            slideChange: () => {
              if (productDetailThumbnailSliders[index]) {
                // slide the thumbnail slider
                productDetailThumbnailSliders[index].slideTo(element.realIndex);
                // set active class for active preview
                productDetailThumbnailSliders[index].slides.removeClass('swiper-slide-fake-active');
                $(productDetailThumbnailSliders[index].slides[productDetailSliders[index].activeIndex]).addClass(
                  'swiper-slide-fake-active',
                );
              }
            },
          },
        });
        productDetailSliders[index] = product_detail_slider;
      });
    }

    // Thumbnail slider on Product Detail Page
    let productDetailThumbnailSliders = [];
    if ($('.product-detail-thumbnail-slider').length) {
      $('.product-detail-thumbnail-slider .swiper-container').each((i, e) => {
        const product_detail_thumbnail_slider = new Swiper($('.product-detail-thumbnail-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          navigation: {
            nextEl: $('.product-detail-thumbnail-slider .swiper-button-next')[i],
            prevEl: $('.product-detail-thumbnail-slider .swiper-button-prev')[i],
          },
          on: {
            tap: (event) => {
              const slide = $(event.target).closest('.swiper-slide');
              if (slide && typeof slide.data('index') !== 'undefined') {
                productDetailSliders[i].slideTo(slide.data('index'));
              }
            },
          },
        });
        productDetailThumbnailSliders[i] = product_detail_thumbnail_slider;
      });
    }

    // Category Slider
    if ($('.teaser-category-slider').length && $(window).width() < 992) {
      $('.teaser-category-slider .swiper-container').each((i) => {
        const teaser_category_slider = new Swiper($('.teaser-category-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 15,
        });
      });
    }

    // Product Slider -- only initialise non empty ones:
    if ($('.teaser-product-slider:has(.swiper-wrapper > *)').length) {
      $('.teaser-product-slider .swiper-container').each((i, element) => {
        const hasSideNav = $('.side-nav').length ? 4 : 5; // if slider is on page that has a side nav only show 4 items per view and group
        const teaser_product_slider = new Swiper($(element), {
          slidesPerView: hasSideNav,
          slidesPerGroup: hasSideNav,
          breakpoints: {
            767: {
              slidesPerView: 1.75,
              slidesPerGroup: 1,
            },
            991: {
              slidesPerView: 3.6,
              slidesPerGroup: 1,
            },
            1200: {
              slidesPerView: 3.75,
              slidesPerGroup: 3.75,
            },
          },
          navigation: {
            nextEl: $(element).siblings('.swiper-button-next'),
            prevEl: $(element).siblings('.swiper-button-prev'),
          },
        });
        setSameHeight(element, '.product-list-item-header');
      });
    }

    // Auto Slider
    if ($('.teaser-auto-slider').length) {
      $('.teaser-auto-slider .swiper-container').each((i) => {
        const teaser_auto_slider = new Swiper($('.teaser-auto-slider .swiper-container')[i], {
          autoplay: {
            delay: 2500,
          },
        });
      });
    }

    // Benefits Slider
    if ($('.teaser-benefits-slider').length) {
      let _slidesPerView = $(window).width() > 767 ? 3 : 2;
      $('.teaser-benefits-slider .swiper-container').each((i) => {
        const teaser_benefits_slider = new Swiper($('.teaser-benefits-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Customer Slider
    if ($('.teaser-customer-slider').length) {
      let _slidesPerView = $(window).width() > 991 ? 2 : 1;
      $('.teaser-customer-slider .swiper-container').each((i) => {
        const teaser_benefits_slider = new Swiper($('.teaser-customer-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          spaceBetween: 30,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Brand Slider
    if ($('.teaser-brand-slider').length) {
      $('.teaser-brand-slider .swiper-container').each((i) => {
        const teaser_brand_slider = new Swiper($('.teaser-brand-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 15,
        });
      });
    }

    // Advisor Slider
    if ($('.teaser-advisor-slider').length && $(window).width() < 992) {
      $('.teaser-advisor-slider .swiper-container').each((i) => {
        const teaser_advisor_slider = new Swiper($('.teaser-advisor-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: {
            nextEl: $('.teaser-advisor-slider .swiper-button-next')[i],
            prevEl: $('.teaser-advisor-slider .swiper-button-prev')[i],
          },
        });
      });
    }

    // Product List Combi Slider
    let productCombiSlider = {};

    if ($('.product-combi__slider .swiper-container').length) {
      $('.product-combi__slider .swiper-container').each((index, element) => {
        const activeIndex = $(element).find('.swiper-slide:has(.active)').index();
        productCombiSlider = new Swiper(element, {
          initialSlide: activeIndex ?? 0,
          slidesPerView: 'auto',
          spaceBetween: 15,
          freeMode: true,
        });

        if (window.matchMedia('screen and (min-width: 768px)').matches) {
          if (productCombiSlider !== undefined) {
            productCombiSlider.destroy(false, true);
          }
        }
      });
    }

    // Coupon Slider
    if ($('.coupon-slider').length) {
      $('.coupon-slider .swiper-container').each((i, element) => {
        const couponSlider = new Swiper(element, {
          slidesPerView: 3,
          spaceBetween: 15,
          breakpoints: {
            992: {
              slidesPerView: 2.25,
              spaceBetween: 15,
            },
            576: {
              slidesPerView: 1.25,
              spaceBetween: 10,
            },
          },
          navigation: {
            nextEl: $(element).siblings('.swiper-button-next'),
            prevEl: $(element).siblings('.swiper-button-prev'),
          },
          watchOverflow: true,
        });
      });
    }

    // Add Sliders to global Array sliders
    $('.swiper-container').each(function (index, element) {
      const swiper = this.swiper;
      if (swiper) {
        sliders.push(swiper);
      }
    });
  });
}

// Destroy Sliders
function sliders_destroySliders() {
  $(sliders).each((index, element) => {
    element.destroy(false, true);
  });
}

// Toggle re-initialization and destruction of sliders if user switchs between
// tablet and desktop view
let sliders_windowWidth = $(window).width();
$(window).resize(() => {
  if ($(window).width() !== sliders_windowWidth) {
    sliders_destroySliders();
    sliders_initiateSliders();
    sliders_windowWidth = $(window).width();
  }
});

;// ./build/sparmed_de/js/main.js
/* unused harmony import specifier */ var main_DEBUG;














































// used globally
window.showLoadingScreen = modules_aponeo.showLoadingScreen;
window.setSameHeight = setSameHeight;
window.keepalive = keepalive;
window.addJsDetailLink = addDetailLinkFunctions;
window.addToLeafletFunctions = leaflet_addToLeafletFunctions;
window.addToBasketFunctions = basket_addToBasketFunctions;
window.getCookie = getCookie;
window.fetchProductDetail = fetchProductDetail;

if (_DEBUG) console.log('running with _DEBUG = TRUE');

(function () {
  // change POST to GET in history to prevent
  // send post again or browser ask "do you want send data agian"
  try {
    history.replaceState(null, document.title, window.location.href);
  } catch (e) {
    console.warn('replaceState not supported:', e);
  }
})();

// same as jquery.getscript but without timestamp
// @see https://api.jquery.com/jquery.getscript/
const currentScript = document.currentScript || document.scripts[document.scripts.length - 1];
let buildNumber = '';
if (currentScript.src.indexOf('?') > 0) {
  buildNumber = currentScript.src.split('?')[1];
}
$.cachedScript = (url, options) => {
  if (/^\/js\/(aponeo_de)\//.test(url)) {
    url = url.replace('/aponeo_de/', '/sparmed_de/');
  }
  options = $.extend(options || {}, {
    dataType: 'script',
    cache: true,
    url: url + '?' + buildNumber,
  });
  return jQuery.ajax(options);
};

$.loadStylesheet = (src) => {
  if (typeof document.createStyleSheet === 'undefined') {
    $('<link>').appendTo('head').attr({
      type: 'text/css',
      rel: 'stylesheet',
      href: src,
    });
  } else {
    // fallback for IE
    document.createStyleSheet(src);
  }
};

/**
 * Basic documentation
 */
/** @global {bool}*/
const main_debug = (/* unused pure expression or super */ null && (main_DEBUG));

/**
 * copy the footnotes 4/5 to add2cart Reco (This text contains an _js_link, so it must be copied before _js_link is initialysed)
 */
basket();

// Init Offcanvas Menu
$('.drilldown', '#main-navigation-off-canvas-wrapper').zeynep();

filterSort();
contactForm();
leaflet();
initWishlist();
headerNav();

initAmountInput();
initTierPriceUpdater();
initSearchFlyoutState();
photoswipe();
jssinglesubmit();
loadingScreen();

$(document).ready(($) => {
  /**
   * Setzt im Kundenbereich den evtl. vorhandenen Button zum Rgdownload auf show()
   */
  const $invoiceDownloadButton = $('._btn-invoice_download');
  if ($invoiceDownloadButton.length) {
    $invoiceDownloadButton.each(function () {
      const invoiceId = $(this).data('value');
      showInvoiceButton(invoiceId);
    });
  }

  if (
    getCookie('sid') != session &&
    (dataLayer[0].pageType == 'basket' || dataLayer[0].pageType == 'customerarea_login')
  ) {
    $.getJSON('/rpc.php?action=teaser&id=264', function (data) {
      $('#notification-lines').append(data['value']);
    });
  }

  $(function () {
    const delay = 1000 + Math.floor(Math.random() * 1001);
    $('#_contactform_hp_terms_div').addClass('hidden');

    setTimeout(() => {
      $('#terms').prop('disabled', true).removeAttr('required');
    }, delay);
  });

  getTeaserDyn();
});

function getTeaserDyn() {
  console.log('::::: Starte dynteaserFunction for:' + dataLayer[0].pageType);

  $.ajax({
    type: 'GET',
    url: '/rpc.php/?action=dynamicteaser',
    data: {
      dl_pagetype: dataLayer[0].pageType,
    },
    success: function (result) {
      console.log(result);
      //result.forEach (renderTeaserDyn);
      for (let i in result) {
        console.log(i);
        //console.log(result[i]);
        renderTeaserDyn(result[i]);
      }
    },
    error: function () {
      console.log('::::: ERROR');
    },
  });
}
function renderTeaserDyn(teaser_item) {
  console.log(':::::  Start rendering teaser: ' + teaser_item['tsr_name']);
  console.log(teaser_item);
  console.log(teaser_item['tsr_name']);
  // tsr_load_dynamic_method:
  // before append after replaceWith
  switch (teaser_item['tsr_load_dynamic_method']) {
    case 'before':
      $(teaser_item['tsr_load_value']).before(teaser_item['tsr_value_wrapped']);
      break;
    case 'append':
      $(teaser_item['tsr_load_value']).append(teaser_item['tsr_value_wrapped']);
      break;
    case 'after':
      $(teaser_item['tsr_load_value']).after(teaser_item['tsr_value_wrapped']);
      break;
    case 'replaceWith':
      $(teaser_item['tsr_load_value']).replaceWith(teaser_item['tsr_value_wrapped']);
      break;
    default:
      break;
  }
}

// add missing function for customer area
function showInvoiceButton(id) {
  $.ajax({
    type: 'GET',
    // url: '/kundenbereich/hasinvoice/'+id
    url: '/kundenbereich/hasinvoice/' + id,
  })
    .fail(function () {
      console.log(id + 'error');
    })
    .done(function (result) {
      if (result == '1') {
        $('#_btn-invoice_download_' + id).show(700);
        $('#_btn-invoice_nodownload_' + id).hide();
      }
    });
}

productlist();

const addMeToLC = () => {
  $.get('/rpc.php', { action: 'addMeToLC' })
    .always(() => {
      $('a#addMeToLC').text('Danke');
      $('.login-mtext').parents('.row.apn-message-orange:first').delay(1200).hide(600);
    })
    .done((data) => {
      if (main_DEBUG) {
        console.log('Data Loaded: ' + data);
      }
    });
};

// SEO Text Collapse
$('.apn-seo-collapse')
  .after()
  .on('click touch', (event) => {
    $(event.currentTarget).collapse('toggle');
  });

$('._cmpscreencustomopen').on('click touch', (event) => {
  __cmp('showScreenAdvanced');
  event.preventDefault();
});

/** collapse seo text */
$('.apn-text-collapse').on('click', (event) => {
  $(event.target).toggleClass('closed');
});

// Anchor on Product Detail Page opens dropdown target (only mobile)
$('.apn-product-detail-information-more').on('click', function () {
  $('#dropdown-product-info-1').collapse('show');
});

// Exorbyte replaces search input in DOM, we have to initalize again
const clearInputNode = $('#apn-header-search .apn-clear-input').get(0);
if (clearInputNode) {
  const searchInputObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        modules_aponeo.clearInput();
      }
    });
  });
  searchInputObserver.observe(clearInputNode, { childList: true });
}

(function openCollapseFromAnchorLink(hash) {
  try {
    if (hash && $(hash).length) {
      var collapseId = $(hash).first().data('collapseOpen');
      var $collapse = collapseId ? $('#' + collapseId) : null;
      if ($collapse && $collapse.length && $collapse.collapse) {
        $collapse.collapse('show');
      }
    }
  } catch (ex) {
    //ignore invalid anchors
  }
})(window.location.hash);

// Set Device Classes
if (modules_aponeo.isMobile()) {
  $('body').addClass('isMobile');
}
if (modules_aponeo.isTablet()) {
  $('body').addClass('isTablet');
}

// Load Stylesheets for search
// 5382_sparmed_dev (dev/test/staging project)
$(document).ready(($) => {
  $.loadStylesheet('https://d25a50wq0hgskv.cloudfront.net/5382_sparmed_dev/lib/ecsSuggest.css.gz');
  $.loadStylesheet('https://d25a50wq0hgskv.cloudfront.net/5382_sparmed_dev/sncustom/sntemplate.css.gz');
});

headroom();

modules_password();

packstation();

header();

announcementBar();

checkout();

megamenu();

productdetail();
stickyCartFlyout();

interactionCheck();

productTeaser();

freeShippingProgress();

const $apnHelp = $('.js-apn-help');
if ($apnHelp.length) {
  __webpack_require__.e(/* import() */ 394).then(__webpack_require__.bind(__webpack_require__, 394)).then(({ default: faq }) => faq($apnHelp));
}

// ### Guarantee Label Opener ###
$(document).on('click', '._guarantee-label-opener', function () {
  $('#modal-eu-guarantee-basic').modal();
});

customer_area();

sliders_initiateSliders();

select_box();

radioToggle();

backToTopFixed();
pdpSkyWrapper();

form_validation();

coupons();

}();
/******/ })()
;
//# sourceMappingURL=main.js.map